export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string }
  /** Represents untyped JSON */
  JSON: { input: any; output: any }
  /** Represents a numeric value that can be either Integer, Float, or BigDecimal */
  Numeric: { input: number; output: number }
  Upload: { input: unknown; output: unknown }
}

export type IAccountRequest = {
  __typename?: 'AccountRequest'
  createdAt: Scalars['ISO8601DateTime']['output']
  errorMessage?: Maybe<Scalars['String']['output']>
  escalatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  escalatedBy?: Maybe<IUser>
  failedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  kind: OpsAccountRequestKind
  notes?: Maybe<Scalars['String']['output']>
  payload?: Maybe<IAccountRequestPayloadUnionPresenterType>
  priority: OpsAccountRequestPriority
  processedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  processedBy?: Maybe<IUser>
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  rejectedBy?: Maybe<IUser>
  reviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  reviewedBy?: Maybe<IUser>
  status: OpsAccountRequestStatus
  user: IUser
}

export enum AccountRequestCancelSubscriptionRequestPayloadCancellationType {
  AtCommitmentEnd = 'at_commitment_end',
  AtPeriodEnd = 'at_period_end',
  Immediately = 'immediately'
}

export type IAccountRequestCollection = {
  __typename?: 'AccountRequestCollection'
  accountRequests: Array<IAccountRequest>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IAccountRequestDynamicFilter = {
  field: AccountRequestDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum AccountRequestDynamicFilterField {
  EscalatedAt = 'escalated_at',
  Kind = 'kind',
  Priority = 'priority',
  Status = 'status',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name',
  UserId = 'user_id'
}

export type IAccountRequestDynamicFilterItem = {
  items: Array<IAccountRequestDynamicFilter>
  operator: DynamicFilterOperator
}

export type IAccountRequestPayloadUnionPresenterType =
  | ICancelSubscriptionResponsePayload
  | IChangeSubscriptionBillingCycleResponsePayload
  | ICreditResponsePayload
  | IDeleteDuplicateAccountResponsePayload
  | IMiscRequestResponsePayload
  | IOneOffAddonResponsePayload
  | IPauseSubscriptionResponsePayload
  | IRefundResponsePayload
  | ISuccess
  | IUncancelSubscriptionResponsePayload
  | IUnpauseSubscriptionResponsePayload
  | IUpdateSubscriptionResponsePayload
  | IUpsertLimitedSupportResponsePayload

export type IAccountRequestPayloadUnionSubmissionType = {
  cancelSubscription?: InputMaybe<ICancelSubscriptionRequestPayload>
  changeSubscriptionBillingCycle?: InputMaybe<IChangeSubscriptionBillingCycleRequestPayload>
  credit?: InputMaybe<ICreditRequestPayload>
  deleteDuplicateAccount?: InputMaybe<IDeleteDuplicateAccountRequestPayload>
  miscRequest?: InputMaybe<IMiscRequestPayload>
  oneOffAddon?: InputMaybe<IOneOffAddonRequestPayload>
  pauseSubscription?: InputMaybe<IPauseSubscriptionRequestPayload>
  refund?: InputMaybe<IRefundRequestPayload>
  type: OpsAccountRequestKind
  uncancelSubscription?: InputMaybe<IUncancelSubscriptionRequestPayload>
  unpauseSubscription?: InputMaybe<IUnpauseSubscriptionRequestPayload>
  updateSubscription?: InputMaybe<IUpgradeSubscriptionRequestPayload>
  updateSubscriptionChurnRecovery?: InputMaybe<IUpdateSubscriptionChurnRecoveryRequestPayload>
}

export type IAccountRequestSort = {
  direction: SortDirection
  field: AccountRequestSortField
}

export enum AccountRequestSortField {
  EscalatedAt = 'escalated_at',
  Kind = 'kind',
  Priority = 'priority',
  ProcessedAt = 'processed_at',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name'
}

export type IAccountRequestsConfig = {
  __typename?: 'AccountRequestsConfig'
  pauseReasons: Array<IOpsAccountRequestKindsPauseSubscriptionReasonDef>
  refundReasons: Array<IOpsAccountRequestKindsRefundReasonDef>
}

export type IActionGoal = {
  __typename?: 'ActionGoal'
  cadence: ActionGoalCadence
  category: ActionGoalCategory
  description: Scalars['String']['output']
  displayUnits?: Maybe<Scalars['String']['output']>
  goalText?: Maybe<Scalars['String']['output']>
  icon: UiIcon
  id: Scalars['ID']['output']
  kind: ActionGoalKind
  macroGoal?: Maybe<Scalars['String']['output']>
  metricKind: ActionGoalMetricKind
  metricValue?: Maybe<Scalars['Float']['output']>
  numberDays: Scalars['Int']['output']
  startDate: Scalars['ISO8601Date']['output']
  status: ActionGoalStatus
  summaryDescription: Scalars['String']['output']
  title: Scalars['String']['output']
}

export enum ActionGoalCadence {
  Weekly = 'weekly'
}

export enum ActionGoalCategory {
  Fitness = 'fitness',
  Glucose = 'glucose',
  Habits = 'habits',
  Nutrition = 'nutrition'
}

export type IActionGoalCompletion = {
  __typename?: 'ActionGoalCompletion'
  date: Scalars['ISO8601Date']['output']
}

export enum ActionGoalKind {
  CaloriesGoal = 'calories_goal',
  CarbsGoal = 'carbs_goal',
  CustomTextGoal = 'custom_text_goal',
  CyclingDistanceGoal = 'cycling_distance_goal',
  ExerciseGoal = 'exercise_goal',
  FastingGoal = 'fasting_goal',
  FiberGoal = 'fiber_goal',
  FlightsClimbedGoal = 'flights_climbed_goal',
  GlucoseMeanGoal = 'glucose_mean_goal',
  GlucoseMinGoal = 'glucose_min_goal',
  GlucoseMorningAverageGoal = 'glucose_morning_average_goal',
  GlucosePeakGoal = 'glucose_peak_goal',
  GlucoseSleepAverageGoal = 'glucose_sleep_average_goal',
  GlucoseStandardDeviationGoal = 'glucose_standard_deviation_goal',
  GlucoseTimeInRangeGoal = 'glucose_time_in_range_goal',
  GlucoseTimeOutsideRangeGoal = 'glucose_time_outside_range_goal',
  GlucoseTotalScoreGoal = 'glucose_total_score_goal',
  MealPresenceGoal = 'meal_presence_goal',
  MeditationGoal = 'meditation_goal',
  NetCarbsGoal = 'net_carbs_goal',
  ProteinGoal = 'protein_goal',
  RunningDistanceGoal = 'running_distance_goal',
  SaturatedFatGoal = 'saturated_fat_goal',
  SleepGoal = 'sleep_goal',
  SodiumGoal = 'sodium_goal',
  StepsGoal = 'steps_goal',
  SugarGoal = 'sugar_goal',
  SwimmingDistanceGoal = 'swimming_distance_goal',
  TotalFatGoal = 'total_fat_goal',
  VideoCallPresenceGoal = 'video_call_presence_goal'
}

export enum ActionGoalMetricKind {
  CaloriesGteMetric = 'calories_gte_metric',
  CaloriesLteMetric = 'calories_lte_metric',
  CarbsGteMetric = 'carbs_gte_metric',
  CarbsLteMetric = 'carbs_lte_metric',
  CyclingDistanceMetric = 'cycling_distance_metric',
  ExerciseDurationGteMetric = 'exercise_duration_gte_metric',
  ExercisePresenceMetric = 'exercise_presence_metric',
  FastingDurationGteMetric = 'fasting_duration_gte_metric',
  FastingPresenceMetric = 'fasting_presence_metric',
  FiberGteMetric = 'fiber_gte_metric',
  FlightsClimbedMetric = 'flights_climbed_metric',
  GlucoseMaxStatsGteMetric = 'glucose_max_stats_gte_metric',
  GlucoseMaxStatsLteMetric = 'glucose_max_stats_lte_metric',
  GlucoseMeanScoreMetric = 'glucose_mean_score_metric',
  GlucoseMinStatsGteMetric = 'glucose_min_stats_gte_metric',
  GlucoseMinStatsLteMetric = 'glucose_min_stats_lte_metric',
  GlucoseMorningAverageStatsGteMetric = 'glucose_morning_average_stats_gte_metric',
  GlucoseMorningAverageStatsLteMetric = 'glucose_morning_average_stats_lte_metric',
  GlucosePeakScoreMetric = 'glucose_peak_score_metric',
  GlucoseSleepAverageStatsGteMetric = 'glucose_sleep_average_stats_gte_metric',
  GlucoseSleepAverageStatsLteMetric = 'glucose_sleep_average_stats_lte_metric',
  GlucoseStandardDeviationScoreMetric = 'glucose_standard_deviation_score_metric',
  GlucoseStandardDeviationStatsLteMetric = 'glucose_standard_deviation_stats_lte_metric',
  GlucoseTimeInRangeStatsGteMetric = 'glucose_time_in_range_stats_gte_metric',
  GlucoseTimeOutsideRangeScoreMetric = 'glucose_time_outside_range_score_metric',
  GlucoseTotalScoreMetric = 'glucose_total_score_metric',
  ManualTextMetric = 'manual_text_metric',
  MealPresenceMetric = 'meal_presence_metric',
  MeditationDurationGteMetric = 'meditation_duration_gte_metric',
  MeditationPresenceMetric = 'meditation_presence_metric',
  NetCarbsLteMetric = 'net_carbs_lte_metric',
  ProteinGteMetric = 'protein_gte_metric',
  RunningDistanceMetric = 'running_distance_metric',
  SaturatedFatLteMetric = 'saturated_fat_lte_metric',
  SleepDurationGteMetric = 'sleep_duration_gte_metric',
  SodiumLteMetric = 'sodium_lte_metric',
  StepCountMetric = 'step_count_metric',
  SugarLteMetric = 'sugar_lte_metric',
  SwimmingDistanceMetric = 'swimming_distance_metric',
  TotalFatGteMetric = 'total_fat_gte_metric',
  TotalFatLteMetric = 'total_fat_lte_metric',
  VideoCallPresenceMetric = 'video_call_presence_metric'
}

export type IActionGoalOption = {
  __typename?: 'ActionGoalOption'
  allowsMultipleActiveGoalsForKind: Scalars['Boolean']['output']
  category: ActionGoalCategory
  description: Scalars['String']['output']
  icon: UiIcon
  kind: ActionGoalKind
  metricOptions: Array<IMetricOption>
  requiresGoalText: Scalars['Boolean']['output']
  title: Scalars['String']['output']
}

export enum ActionGoalStatus {
  Active = 'active',
  Deleted = 'deleted'
}

export type IActionGoalSummary = {
  __typename?: 'ActionGoalSummary'
  actionGoal: IActionGoal
  completions?: Maybe<Array<IActionGoalCompletion>>
  id: Scalars['ID']['output']
}

export type IActionGoalSummaryCollection = {
  __typename?: 'ActionGoalSummaryCollection'
  actionGoalSummaries: Array<IActionGoalSummary>
  startDate: Scalars['ISO8601Date']['output']
}

export type IActivity = {
  __typename?: 'Activity'
  allDay: Scalars['Boolean']['output']
  autoGenerated: Scalars['Boolean']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  description: Scalars['String']['output']
  endedAt: Scalars['ISO8601DateTime']['output']
  externalSource?: Maybe<Scalars['String']['output']>
  favorite: Scalars['Boolean']['output']
  glucose: IEntryGlucose
  id: Scalars['ID']['output']
  length: Scalars['Int']['output']
  occurredAt: Scalars['ISO8601DateTime']['output']
  startedAt: Scalars['ISO8601DateTime']['output']
  statistics: IEntryStatistics
  status?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type IAddonLimit = {
  __typename?: 'AddonLimit'
  description?: Maybe<Scalars['String']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  productId: Scalars['ID']['output']
  purchasedAmount: Scalars['Int']['output']
}

export type IAddress = {
  __typename?: 'Address'
  city: Scalars['String']['output']
  country?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  state?: Maybe<AddressState>
  street: Scalars['String']['output']
  street2: Scalars['String']['output']
  zipCode: Scalars['String']['output']
}

export enum AddressCountry {
  Ca = 'CA',
  Gb = 'GB',
  Us = 'US'
}

export enum AddressState {
  Aa = 'AA',
  Ab = 'AB',
  Ae = 'AE',
  Ak = 'AK',
  Al = 'AL',
  Ap = 'AP',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Bc = 'BC',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Mb = 'MB',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nb = 'NB',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nl = 'NL',
  Nm = 'NM',
  Ns = 'NS',
  Nt = 'NT',
  Nu = 'NU',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  On = 'ON',
  Or = 'OR',
  Other = 'Other',
  Pa = 'PA',
  Pe = 'PE',
  Pr = 'PR',
  Pw = 'PW',
  Qc = 'QC',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Sk = 'SK',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
  Yt = 'YT'
}

export type IAllowEarlyExitBehavior = {
  __typename?: 'AllowEarlyExitBehavior'
  followupSurvey?: Maybe<SurveysConfigKind>
}

export type IAmazonBuyer = {
  __typename?: 'AmazonBuyer'
  emailAlias: Scalars['String']['output']
  userId?: Maybe<Scalars['ID']['output']>
}

export type IAmazonOrder = {
  __typename?: 'AmazonOrder'
  address?: Maybe<IAddress>
  amazonOrderId: Scalars['String']['output']
  buyer?: Maybe<IAmazonBuyer>
  id: Scalars['ID']['output']
  items: Array<IAmazonOrderItem>
  phoneNumber?: Maybe<Scalars['String']['output']>
  purchasedAt: Scalars['ISO8601DateTime']['output']
  shippingOrder?: Maybe<IOrder>
  status: ShippingAmazonOrderStatus
  total: Scalars['Float']['output']
}

export type IAmazonOrderDynamicFilter = {
  field: AmazonOrderDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum AmazonOrderDynamicFilterField {
  AddressCity = 'address_city',
  AddressCountry = 'address_country',
  AddressName = 'address_name',
  AddressState = 'address_state',
  AddressStreet = 'address_street',
  AddressStreet_2 = 'address_street_2',
  AddressZipCode = 'address_zip_code',
  AmazonOrderId = 'amazon_order_id',
  BuyerEmailAlias = 'buyer_email_alias',
  BuyerUserId = 'buyer_user_id',
  Id = 'id',
  ItemsAmazonOrderItemId = 'items_amazon_order_item_id',
  ItemsAsin = 'items_asin',
  ItemsQuantity = 'items_quantity',
  ItemsSku = 'items_sku',
  PhoneNumber = 'phone_number',
  PurchasedAt = 'purchased_at',
  ShippingOrderId = 'shipping_order_id',
  Status = 'status',
  Total = 'total'
}

export type IAmazonOrderDynamicFilterItem = {
  items: Array<IAmazonOrderDynamicFilter>
  operator: DynamicFilterOperator
}

export type IAmazonOrderItem = {
  __typename?: 'AmazonOrderItem'
  amazonOrderItemId: Scalars['String']['output']
  asin: Scalars['String']['output']
  id: Scalars['ID']['output']
  quantity: Scalars['Int']['output']
  sku: Scalars['String']['output']
}

export type IAmazonOrderSort = {
  direction: SortDirection
  field: AmazonOrderSortField
}

export enum AmazonOrderSortField {
  AddressCity = 'address_city',
  AddressCountry = 'address_country',
  AddressName = 'address_name',
  AddressState = 'address_state',
  AddressStreet = 'address_street',
  AddressStreet_2 = 'address_street_2',
  AddressZipCode = 'address_zip_code',
  AmazonOrderId = 'amazon_order_id',
  BuyerEmailAlias = 'buyer_email_alias',
  BuyerUserId = 'buyer_user_id',
  Id = 'id',
  ItemsAmazonOrderItemId = 'items_amazon_order_item_id',
  ItemsAsin = 'items_asin',
  ItemsQuantity = 'items_quantity',
  ItemsSku = 'items_sku',
  PhoneNumber = 'phone_number',
  PurchasedAt = 'purchased_at',
  ShippingOrderId = 'shipping_order_id',
  Status = 'status',
  Total = 'total'
}

export type IAnswer = {
  __typename?: 'Answer'
  /** @deprecated Use followups instead */
  followup?: Maybe<IFollowup>
  followups: Array<IFollowup>
  inlineAlert?: Maybe<IInlineAlert>
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type IAnswersGroup = {
  __typename?: 'AnswersGroup'
  answers: Array<IAnswer>
  answersOrder: SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswersOrder
}

export enum AppointmentDynamicEhrFilterField {
  CoachingKind = 'coaching_kind',
  CreatedAt = 'created_at',
  Kind = 'kind',
  LastStateKind = 'last_state_kind',
  MeetingAt = 'meeting_at'
}

export enum AppointmentEhrSortField {
  CoachingKind = 'coaching_kind',
  CreatedAt = 'created_at',
  Kind = 'kind',
  MeetingAt = 'meeting_at'
}

export type IApprovalRequest = {
  __typename?: 'ApprovalRequest'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: UserApprovalRequestKind
  state: UserApprovalRequestState
  user: IUser
}

export type IAssignableAuthorizationPolicy = {
  __typename?: 'AssignableAuthorizationPolicy'
  id: Scalars['ID']['output']
  kind: UserAuthorizationPolicyKind
  policy: IAuthorizationPolicy
}

export type IAuthorizationPolicy = {
  __typename?: 'AuthorizationPolicy'
  grants: Array<IAuthorizationPolicyGrant>
  name: Scalars['String']['output']
}

export type IAuthorizationPolicyCollection = {
  __typename?: 'AuthorizationPolicyCollection'
  additionalPolicies: Array<IUserAuthorizationPolicy>
  rolePolicies: Array<IAuthorizationPolicy>
}

export type IAuthorizationPolicyGrant = {
  __typename?: 'AuthorizationPolicyGrant'
  permission: Scalars['String']['output']
  resource: Scalars['String']['output']
  scope?: Maybe<Scalars['String']['output']>
}

export type IBehavior = {
  __typename?: 'Behavior'
  allowEarlyExit: Scalars['Boolean']['output']
  allowMultipleSubmissions: Scalars['Boolean']['output']
  redirectOnOutcome: Scalars['Boolean']['output']
  showAlertOnClose: Scalars['Boolean']['output']
  showProgressIndicator: Scalars['Boolean']['output']
  trackResponses: Scalars['Boolean']['output']
  warnBeforeStopping: Scalars['Boolean']['output']
}

export type IBillingAllowance = {
  __typename?: 'BillingAllowance'
  id: Scalars['ID']['output']
  kind: BillingAllowanceKind
  remaining: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type IBillingAllowanceCollection = {
  __typename?: 'BillingAllowanceCollection'
  allowances: Array<IBillingAllowance>
}

export enum BillingAllowanceKind {
  CoachingCall = 'coaching_call',
  LabPanelDiscount = 'lab_panel_discount'
}

export enum BillingPaymentIntentCaptureMethod {
  Automatic = 'automatic',
  AutomaticAsync = 'automatic_async',
  Manual = 'manual'
}

export enum BillingPaymentIntentReason {
  Automatic = 'automatic',
  Preauthorization = 'preauthorization'
}

export enum BillingPaymentIntentStatus {
  Cancelled = 'cancelled',
  Processing = 'processing',
  RequiresAction = 'requires_action',
  RequiresCapture = 'requires_capture',
  RequiresConfirmation = 'requires_confirmation',
  RequiresPaymentMethod = 'requires_payment_method',
  Succeeded = 'succeeded'
}

export enum BillingProduct {
  AmazonNutrisenseMonthly = 'amazon_nutrisense_monthly',
  AutoCancelNutrisenseMonthly = 'auto_cancel_nutrisense_monthly',
  AutoCancelNutrisenseMonthlyGoogleShopping = 'auto_cancel_nutrisense_monthly_google_shopping',
  BundledFixedMember = 'bundled_fixed_member',
  BundledFixedMemberBuyNowPayLater = 'bundled_fixed_member_buy_now_pay_later',
  CancellationFee = 'cancellation_fee',
  Cgm = 'cgm',
  CgmBundleFixed = 'cgm_bundle_fixed',
  CompoundedSemaglutide = 'compounded_semaglutide',
  CompoundedSemaglutideWithSupport = 'compounded_semaglutide_with_support',
  DexcomCgm = 'dexcom_cgm',
  DexcomPatch = 'dexcom_patch',
  DmDietitian_4Video_30Min = 'dm_dietitian_4_video_30_min',
  DmDietitianVideo_30Min = 'dm_dietitian_video_30_min',
  DmMealPlan = 'dm_meal_plan',
  DmQGlucoseCompare = 'dm_q_glucose_compare',
  DmQGlucoseEvent = 'dm_q_glucose_event',
  DmQGlucoseFasting = 'dm_q_glucose_fasting',
  DmQGlucoseMetrics = 'dm_q_glucose_metrics',
  DmQGlucoseTrends = 'dm_q_glucose_trends',
  DmSupplementReview = 'dm_supplement_review',
  DmWeeklyGoals = 'dm_weekly_goals',
  DowngradeFee = 'downgrade_fee',
  DowngradeFee_6To_3Cycle_1 = 'downgrade_fee_6_to_3_cycle_1',
  DowngradeFee_6To_3Cycle_2 = 'downgrade_fee_6_to_3_cycle_2',
  DowngradeFee_12To_3Cycle_1 = 'downgrade_fee_12_to_3_cycle_1',
  DowngradeFee_12To_3Cycle_2 = 'downgrade_fee_12_to_3_cycle_2',
  DowngradeFee_12To_6Cycle_1 = 'downgrade_fee_12_to_6_cycle_1',
  DowngradeFee_12To_6Cycle_2 = 'downgrade_fee_12_to_6_cycle_2',
  DowngradeFee_12To_6Cycle_3 = 'downgrade_fee_12_to_6_cycle_3',
  DowngradeFee_12To_6Cycle_4 = 'downgrade_fee_12_to_6_cycle_4',
  DowngradeFee_12To_6Cycle_5 = 'downgrade_fee_12_to_6_cycle_5',
  FlexNutrisenseMonthly = 'flex_nutrisense_monthly',
  FlexNutrisenseMonthly_3 = 'flex_nutrisense_monthly_3',
  FlexNutrisenseMonthly_6 = 'flex_nutrisense_monthly_6',
  FreeCgmReplacement = 'free_cgm_replacement',
  FreeSoftwareOnlyDppAnnualMembership = 'free_software_only_dpp_annual_membership',
  FreeSoftwareOnlyMedicalAnnualMembership = 'free_software_only_medical_annual_membership',
  FreeSoftwareOnlyOwnSensorAnnualMembership = 'free_software_only_own_sensor_annual_membership',
  FreeSoftwareOnlyVideoCallsAnnualMembership = 'free_software_only_video_calls_annual_membership',
  FullscriptComprehensive = 'fullscript_comprehensive',
  FullscriptComprehensiveEvery_3Months = 'fullscript_comprehensive_every_3_months',
  FullscriptComprehensiveEvery_6Months = 'fullscript_comprehensive_every_6_months',
  FullscriptCore = 'fullscript_core',
  FullscriptCoreEvery_3Months = 'fullscript_core_every_3_months',
  FullscriptCoreEvery_6Months = 'fullscript_core_every_6_months',
  FullscriptElite = 'fullscript_elite',
  FullscriptEliteEvery_3Months = 'fullscript_elite_every_3_months',
  FullscriptEliteEvery_6Months = 'fullscript_elite_every_6_months',
  Influencer_1 = 'influencer_1',
  Influencer_2 = 'influencer_2',
  InternationalOptionExercise = 'international_option_exercise',
  MedicalConsultAddon = 'medical_consult_addon',
  MedicalConsultLateCancellationFee = 'medical_consult_late_cancellation_fee',
  MedicalConsultLateRescheduleFee = 'medical_consult_late_reschedule_fee',
  MedicalConsultNoShowFee = 'medical_consult_no_show_fee',
  NonRecurring_1_16Rd = 'non_recurring_1_16_rd',
  NonRecurring_1_32Rd = 'non_recurring_1_32_rd',
  NonRecurring_1NoRd = 'non_recurring_1_no_rd',
  NonRecurring_2_32Rd = 'non_recurring_2_32_rd',
  NonRecurring_2Cgm_1Call = 'non_recurring_2_cgm_1_call',
  NonRecurring_2NoRd = 'non_recurring_2_no_rd',
  NonTaxablePrepaidNutrisenseMonthly_1 = 'non_taxable_prepaid_nutrisense_monthly_1',
  NonTaxablePrepaidNutrisenseMonthly_3 = 'non_taxable_prepaid_nutrisense_monthly_3',
  NonTaxablePrepaidNutrisenseMonthly_6 = 'non_taxable_prepaid_nutrisense_monthly_6',
  NonTaxablePrepaidNutrisenseMonthly_12 = 'non_taxable_prepaid_nutrisense_monthly_12',
  NutrisenseDietitian = 'nutrisense_dietitian',
  NutrisenseDietitianLimited = 'nutrisense_dietitian_limited',
  NutrisenseMonthly = 'nutrisense_monthly',
  NutrisenseMonthly_2Calls = 'nutrisense_monthly_2_calls',
  NutrisenseMonthly_3 = 'nutrisense_monthly_3',
  NutrisenseMonthly_4 = 'nutrisense_monthly_4',
  NutrisenseMonthly_6 = 'nutrisense_monthly_6',
  NutrisenseMonthly_6BuyNowPayLater = 'nutrisense_monthly_6_buy_now_pay_later',
  NutrisenseMonthly_12 = 'nutrisense_monthly_12',
  NutrisenseMonthly_12BuyNowPayLater = 'nutrisense_monthly_12_buy_now_pay_later',
  NutrisenseMonthlyChurnRecovery = 'nutrisense_monthly_churn_recovery',
  NutrisenseMonthlyPreInsurance = 'nutrisense_monthly_pre_insurance',
  NutrisensePeriodic_1_3 = 'nutrisense_periodic_1_3',
  NutrisensePeriodic_1_6 = 'nutrisense_periodic_1_6',
  NutrisensePeriodic_2_3 = 'nutrisense_periodic_2_3',
  NutrisensePeriodic_2_6 = 'nutrisense_periodic_2_6',
  NutrisenseSoftwareOnly = 'nutrisense_software_only',
  NutrisenseTier_1Monthly_6 = 'nutrisense_tier_1_monthly_6',
  NutrisenseTier_2BasicMonthly_6 = 'nutrisense_tier_2_basic_monthly_6',
  NutrisenseTier_2PremiumMonthly_6 = 'nutrisense_tier_2_premium_monthly_6',
  NutrisenseTier_3BasicMonthly_6 = 'nutrisense_tier_3_basic_monthly_6',
  NutrisenseTier_3PremiumMonthly_6 = 'nutrisense_tier_3_premium_monthly_6',
  NutritionCoachFocused = 'nutrition_coach_focused',
  OneMonthCgm = 'one_month_cgm',
  PaidCgmReplacement = 'paid_cgm_replacement',
  PaidDexcomPatch = 'paid_dexcom_patch',
  PaidPatch = 'paid_patch',
  PaidReshipCgmReplacement = 'paid_reship_cgm_replacement',
  Patch = 'patch',
  PrepaidNutrisenseMonthly_1 = 'prepaid_nutrisense_monthly_1',
  PrepaidNutrisenseMonthly_3 = 'prepaid_nutrisense_monthly_3',
  PrepaidNutrisenseMonthly_6 = 'prepaid_nutrisense_monthly_6',
  PrepaidNutrisenseMonthly_12 = 'prepaid_nutrisense_monthly_12',
  ReshipCgmReplacement = 'reship_cgm_replacement',
  ShippingFee = 'shipping_fee',
  SoftwareOnlyAnnualMembership = 'software_only_annual_membership',
  SoftwareOnlyOwnSensorAnnualMembership = 'software_only_own_sensor_annual_membership',
  SoftwareOnlyOwnSensorAnnualMembershipChurnRecovery = 'software_only_own_sensor_annual_membership_churn_recovery',
  SoftwareOnlyOwnSensorMonthlyMembership = 'software_only_own_sensor_monthly_membership',
  SoftwareOnlyOwnSensorMonthlyMembershipChurnRecovery = 'software_only_own_sensor_monthly_membership_churn_recovery',
  SteloCgm_1 = 'stelo_cgm_1',
  SteloCgm_2 = 'stelo_cgm_2',
  SteloCgm_2Monthly = 'stelo_cgm_2_monthly',
  StressManagementCall_60Min_1 = 'stress_management_call_60_min_1',
  SupplementMg_2 = 'supplement_mg_2',
  SupplementMg_6 = 'supplement_mg_6',
  SupplementMvt_2 = 'supplement_mvt_2',
  SupplementMvt_6 = 'supplement_mvt_6',
  SupplementQ10_2 = 'supplement_q10_2',
  SupplementQ10_6 = 'supplement_q10_6',
  Tax = 'tax',
  UhcVideoCalls_30Min_2Monthly = 'uhc_video_calls_30_min_2_monthly',
  UhcVideoCalls_30Min_2NonRecurring = 'uhc_video_calls_30_min_2_non_recurring',
  Unknown = 'unknown',
  UpsellNutrisenseMonthly = 'upsell_nutrisense_monthly',
  UpsellNutrisenseMonthly_3 = 'upsell_nutrisense_monthly_3',
  UpsellNutrisenseMonthly_6 = 'upsell_nutrisense_monthly_6',
  VideoCall_30Min_1 = 'video_call_30_min_1',
  VideoCallLateCancellationFee = 'video_call_late_cancellation_fee',
  VideoCallLateRescheduleFee = 'video_call_late_reschedule_fee',
  VideoCallNoShowFee = 'video_call_no_show_fee',
  VideoCallPayAsYouGoMnt_30Min = 'video_call_pay_as_you_go_mnt_30_min',
  VideoCallPayAsYouGoMnt_60Min = 'video_call_pay_as_you_go_mnt_60_min',
  VideoCallPayAsYouGoStressManagement_60Min = 'video_call_pay_as_you_go_stress_management_60_min',
  VideoCalls_30Min_2 = 'video_calls_30_min_2',
  WelcomeKit = 'welcome_kit'
}

export enum BillingProductGroupKind {
  Commitment = 'commitment',
  Dropdown = 'dropdown'
}

export enum BillingProductInterval {
  Every_3Months = 'every_3_months',
  Every_6Months = 'every_6_months',
  Monthly = 'monthly',
  NoInterval = 'no_interval',
  NonRecurring_1M = 'non_recurring_1_m',
  NonRecurring_2M = 'non_recurring_2_m',
  Yearly = 'yearly'
}

export type IBiomarkerConfig = {
  __typename?: 'BiomarkerConfig'
  kind: HealthDataMetricBiomarker
  label: Scalars['String']['output']
  unit?: Maybe<Scalars['String']['output']>
}

export type IBiteAi = {
  __typename?: 'BiteAi'
  dailyValues: Array<IKeyValuePairFloat>
  units: Array<IBiteAiKeyValuePairString>
}

export type IBiteAiKeyValuePairString = {
  __typename?: 'BiteAiKeyValuePairString'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type IBloodPressureMeasurement = {
  __typename?: 'BloodPressureMeasurement'
  diastolic: Scalars['Float']['output']
  systolic: Scalars['Float']['output']
}

export type IBulkAssign = {
  __typename?: 'BulkAssign'
  coachAssignments: Array<ICoachAssignment>
}

export type IBulkCreatePendingCoaches = {
  __typename?: 'BulkCreatePendingCoaches'
  createdUsers: Array<IUser>
  summary: ICoachInviteSummary
}

export type IBulkCreateShipment = {
  lotNumber?: InputMaybe<Scalars['String']['input']>
  orderId: Scalars['Int']['input']
  shippedAt?: InputMaybe<Scalars['ISO8601Date']['input']>
  trackingNumber?: InputMaybe<Scalars['String']['input']>
  trackingUrl?: InputMaybe<Scalars['String']['input']>
}

export type ICalculateDuplicateAccountCredit = {
  __typename?: 'CalculateDuplicateAccountCredit'
  creditAmountInCents: Scalars['Int']['output']
}

export type ICalendarDate = {
  __typename?: 'CalendarDate'
  date: Scalars['ISO8601Date']['output']
  score?: Maybe<Scalars['Int']['output']>
}

export type ICancelSubscriptionRequestPayload = {
  cancellationReason: OpsAccountRequestKindsCancelSubscriptionReason
  cancellationType: AccountRequestCancelSubscriptionRequestPayloadCancellationType
  subscriptionId: Scalars['ID']['input']
  waiveEarlyCancellationFee: Scalars['Boolean']['input']
  waiveEarlyCancellationSurcharge: Scalars['Boolean']['input']
}

export type ICancelSubscriptionResponsePayload = {
  __typename?: 'CancelSubscriptionResponsePayload'
  cancellationReason: OpsAccountRequestKindsCancelSubscriptionReason
  cancellationType: AccountRequestCancelSubscriptionRequestPayloadCancellationType
  subscriptionId: Scalars['ID']['output']
  waiveEarlyCancellationFee: Scalars['Boolean']['output']
  waiveEarlyCancellationSurcharge: Scalars['Boolean']['output']
}

export type IChangeSubscriptionBillingCycleRequestPayload = {
  billingCycleAnchor: Scalars['ISO8601DateTime']['input']
  subscriptionId: Scalars['ID']['input']
}

export type IChangeSubscriptionBillingCycleResponsePayload = {
  __typename?: 'ChangeSubscriptionBillingCycleResponsePayload'
  billingCycleAnchor: Scalars['ISO8601DateTime']['output']
  subscriptionId: Scalars['ID']['output']
}

export type ICharge = {
  __typename?: 'Charge'
  amount: Scalars['Float']['output']
  amountCaptured?: Maybe<Scalars['Float']['output']>
  amountRefunded: Scalars['Float']['output']
  created: Scalars['ISO8601DateTime']['output']
  disputeStripeId?: Maybe<Scalars['String']['output']>
  disputed: Scalars['Boolean']['output']
  failureMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  invoice?: Maybe<IInvoice>
  paid: Scalars['Boolean']['output']
  providerPaymentMethodId?: Maybe<Scalars['String']['output']>
  refundable: Scalars['Boolean']['output']
  refunded: Scalars['Boolean']['output']
  status: Scalars['String']['output']
  stripeId: Scalars['String']['output']
  user: IUser
}

export type IChargeCollection = {
  __typename?: 'ChargeCollection'
  charges: Array<ICharge>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IChargeDynamicFilter = {
  field: ChargeDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum ChargeDynamicFilterField {
  Amount = 'amount',
  AmountRefunded = 'amount_refunded',
  Created = 'created',
  DisputeStripeId = 'dispute_stripe_id',
  Disputed = 'disputed',
  FailureMessage = 'failure_message',
  Id = 'id',
  InvoiceStripeId = 'invoice_stripe_id',
  InvoiceSubscriptionStripeId = 'invoice_subscription_stripe_id',
  Paid = 'paid',
  Refunded = 'refunded',
  Status = 'status',
  StripeId = 'stripe_id',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name',
  UserId = 'user_id',
  UserPhoneNumber = 'user_phone_number'
}

export type IChargeDynamicFilterItem = {
  items: Array<IChargeDynamicFilter>
  operator: DynamicFilterOperator
}

export type IChargeSort = {
  direction: SortDirection
  field: ChargeSortField
}

export enum ChargeSortField {
  Amount = 'amount',
  AmountRefunded = 'amount_refunded',
  Created = 'created',
  DisputeStripeId = 'dispute_stripe_id',
  Disputed = 'disputed',
  FailureMessage = 'failure_message',
  Id = 'id',
  InvoiceStripeId = 'invoice_stripe_id',
  InvoiceSubscriptionStripeId = 'invoice_subscription_stripe_id',
  Paid = 'paid',
  Refunded = 'refunded',
  Status = 'status',
  StripeId = 'stripe_id',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name',
  UserPhoneNumber = 'user_phone_number'
}

export type IChart = {
  __typename?: 'Chart'
  description: Scalars['String']['output']
  meta: IChartMeta
  range: IChartRange
  title: Scalars['String']['output']
  type: Scalars['String']['output']
  values: Array<IValuePair>
  xAxis: Scalars['String']['output']
  yAxis: Scalars['String']['output']
}

export type IChartMeta = {
  __typename?: 'ChartMeta'
  key?: Maybe<Scalars['String']['output']>
  section?: Maybe<Scalars['String']['output']>
  tag?: Maybe<Scalars['String']['output']>
}

export type IChartRange = {
  __typename?: 'ChartRange'
  goal?: Maybe<Scalars['Float']['output']>
  goalMax?: Maybe<Scalars['Float']['output']>
  goalMin?: Maybe<Scalars['Float']['output']>
  max?: Maybe<Scalars['Float']['output']>
  min?: Maybe<Scalars['Float']['output']>
  tickCount?: Maybe<Scalars['Int']['output']>
}

export type ICharts = {
  __typename?: 'Charts'
  charts: Array<IChart>
}

export type IChartsConfig = {
  __typename?: 'ChartsConfig'
  filters: IChartsFilters
}

export type IChartsFilters = {
  __typename?: 'ChartsFilters'
  types: Array<IKeyValuePairStringArray>
}

export type IChatConversation = {
  __typename?: 'ChatConversation'
  assignee?: Maybe<IUser>
  candidateRead: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  intercomBackfillState?: Maybe<ChatConversationIntercomBackfillState>
  intercomCreatedAt: Scalars['ISO8601DateTime']['output']
  intercomId: Scalars['String']['output']
  kind: ChatConversationKind
  lastMessage?: Maybe<IChatConversationMessage>
  lastNote?: Maybe<IChatConversationNote>
  lastUserMessage?: Maybe<IChatConversationMessage>
  read: Scalars['Boolean']['output']
  state: ChatConversationState
  user: IUser
}

export type IChatConversationEvent = {
  __typename?: 'ChatConversationEvent'
  assignedTo?: Maybe<IUser>
  id: Scalars['ID']['output']
  kind: ChatConversationEventKind
  message?: Maybe<IChatConversationMessage>
  note?: Maybe<IChatConversationNote>
  occurredAt: Scalars['ISO8601DateTime']['output']
  performedBy?: Maybe<IUser>
  snoozedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export enum ChatConversationEventKind {
  Assignment = 'assignment',
  Close = 'close',
  Message = 'message',
  Note = 'note',
  Open = 'open',
  Snoozed = 'snoozed',
  TimerUnsnooze = 'timer_unsnooze',
  Unsnooze = 'unsnooze'
}

export type IChatConversationEventSort = {
  direction: SortDirection
  field: ChatConversationEventSortField
}

export enum ChatConversationEventSortField {
  OccurredAt = 'occurred_at'
}

export type IChatConversationEventsCollection = {
  __typename?: 'ChatConversationEventsCollection'
  chatConversationEvents: Array<IChatConversationEvent>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export enum ChatConversationIntercomBackfillState {
  Completed = 'completed',
  InProgress = 'in_progress',
  Pending = 'pending'
}

export enum ChatConversationKind {
  Mnt = 'mnt',
  StressManagement = 'stress_management',
  Support = 'support'
}

export type IChatConversationMessage = {
  __typename?: 'ChatConversationMessage'
  id: Scalars['ID']['output']
  sender?: Maybe<IUser>
  senderKind: ChatConversationMessageSenderKind
  sentAt: Scalars['ISO8601DateTime']['output']
  value: Scalars['String']['output']
}

export enum ChatConversationMessageSenderKind {
  Automated = 'automated',
  Unknown = 'unknown',
  User = 'user'
}

export type IChatConversationMessageTemplate = {
  __typename?: 'ChatConversationMessageTemplate'
  automatic: Scalars['Boolean']['output']
  createdBy?: Maybe<IUser>
  id: Scalars['ID']['output']
  kind: ChatConversationMessageTemplateKind
  name: Scalars['String']['output']
  private: Scalars['Boolean']['output']
  value: Scalars['String']['output']
}

export enum ChatConversationMessageTemplateKind {
  AutoCoachSwitch_3DayNudge = 'auto_coach_switch_3_day_nudge',
  AutoCoachSwitch_7DayNudge = 'auto_coach_switch_7_day_nudge',
  AutoCoachSwitchGoodbye = 'auto_coach_switch_goodbye',
  AutoCoachSwitchWelcome = 'auto_coach_switch_welcome',
  BasicInitial = 'basic_initial',
  CgmReviewVideoCallsUpsell = 'cgm_review_video_calls_upsell',
  Custom = 'custom',
  DietitianMenuMealPlanInitial = 'dietitian_menu_meal_plan_initial',
  DietitianMenuSupplementReviewInitial = 'dietitian_menu_supplement_review_initial',
  DppInitial = 'dpp_initial',
  DppPostClass = 'dpp_post_class',
  DppPreClass = 'dpp_pre_class',
  Engagement = 'engagement',
  FixedEightWeeksInitial = 'fixed_eight_weeks_initial',
  FreeCallGranted = 'free_call_granted',
  InsuranceVideoCallOptionReminder = 'insurance_video_call_option_reminder',
  LowDailyScoreVideoCallsUpsell = 'low_daily_score_video_calls_upsell',
  MonthlyWrapUp = 'monthly_wrap_up',
  NutritionVideoInitial = 'nutrition_video_initial',
  NutritionistOutOfOffice = 'nutritionist_out_of_office',
  PossibilityOfOpeningVideoCallAvailability = 'possibility_of_opening_video_call_availability',
  PremiumInitial = 'premium_initial',
  PremiumInitialPaid = 'premium_initial_paid',
  StressVideoInitial = 'stress_video_initial',
  ThirtyMinVideoCallPossibility = 'thirty_min_video_call_possibility',
  VideoCallCancelled = 'video_call_cancelled',
  VideoInitialHealthCoaching = 'video_initial_health_coaching',
  VideoPostFreeCall = 'video_post_free_call',
  VideoPreFreeCall = 'video_pre_free_call',
  VideoReminder = 'video_reminder',
  VideoWrapUp = 'video_wrap_up'
}

export type IChatConversationMessageTemplateVariable = {
  __typename?: 'ChatConversationMessageTemplateVariable'
  id: Scalars['ID']['output']
  key: Scalars['String']['output']
}

export type IChatConversationMessageTemplateVariableCollection = {
  __typename?: 'ChatConversationMessageTemplateVariableCollection'
  chatConversationMessageTemplateVariables: Array<IChatConversationMessageTemplateVariable>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IChatConversationNote = {
  __typename?: 'ChatConversationNote'
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: IUser
  id: Scalars['ID']['output']
  value: Scalars['String']['output']
}

export type IChatConversationSort = {
  direction: SortDirection
  field: ChatConversationSortField
}

export enum ChatConversationSortField {
  LastMessageOrNoteSentAt = 'last_message_or_note_sent_at',
  LastMessageSentAt = 'last_message_sent_at',
  LastUserMessageSentAt = 'last_user_message_sent_at',
  UserCreatedAt = 'user_created_at',
  WaitingSince = 'waiting_since'
}

export enum ChatConversationState {
  Closed = 'closed',
  Open = 'open',
  Snoozed = 'snoozed'
}

export type IChatConversationsCollection = {
  __typename?: 'ChatConversationsCollection'
  chatConversations: Array<IChatConversation>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IChatbot = {
  __typename?: 'Chatbot'
  /** AI-usage disclosure shown wherever the AI assistant is surfaced */
  disclosure: Scalars['String']['output']
  lastShownCutoffAt: Scalars['ISO8601DateTime']['output']
  responseTimeoutInSeconds: Scalars['Int']['output']
}

export type IChatbotMessageReport = {
  __typename?: 'ChatbotMessageReport'
  botMessageContent?: Maybe<Scalars['String']['output']>
  chatbotMessageId: Scalars['ID']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  note?: Maybe<Scalars['String']['output']>
  reason: ChatbotMessageReportReason
  resolutionNote?: Maybe<Scalars['String']['output']>
  resolutionRef?: Maybe<Scalars['String']['output']>
  resolvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  resolvedById?: Maybe<Scalars['ID']['output']>
  status: ChatbotMessageReportStatus
  userId: Scalars['ID']['output']
}

export type IChatbotMessageReportDynamicFilter = {
  field: ChatbotMessageReportDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum ChatbotMessageReportDynamicFilterField {
  ChatbotMessageId = 'chatbot_message_id',
  CreatedAt = 'created_at',
  Id = 'id',
  Reason = 'reason',
  ResolvedAt = 'resolved_at',
  ResolvedById = 'resolved_by_id',
  Status = 'status',
  UserId = 'user_id'
}

export type IChatbotMessageReportDynamicFilterItem = {
  items: Array<IChatbotMessageReportDynamicFilter>
  operator: DynamicFilterOperator
}

export enum ChatbotMessageReportReason {
  Harmful = 'harmful',
  Inaccurate = 'inaccurate',
  Inappropriate = 'inappropriate',
  Other = 'other'
}

export type IChatbotMessageReportSort = {
  direction: SortDirection
  field: ChatbotMessageReportSortField
}

export enum ChatbotMessageReportSortField {
  CreatedAt = 'created_at',
  Id = 'id',
  Reason = 'reason',
  ResolvedAt = 'resolved_at',
  Status = 'status',
  UpdatedAt = 'updated_at'
}

export enum ChatbotMessageReportStatus {
  Dismissed = 'dismissed',
  InReview = 'in_review',
  Pending = 'pending',
  Resolved = 'resolved'
}

export type ICheckoutOption = {
  __typename?: 'CheckoutOption'
  kind: SubscriptionCheckoutOptionKind
}

export type IClientConfig = {
  __typename?: 'ClientConfig'
  actionGoalOptions: Array<IActionGoalOption>
  activityTypes: Array<Scalars['String']['output']>
  appointmentKinds: Array<IClientConfigEhrAppointmentKind>
  biomarkers: Array<IBiomarkerConfig>
  biteAi: IBiteAi
  caProvinces: Array<IState>
  charts: IChartsConfig
  chatbot: IChatbot
  coaches: ICoachesConfig
  customIngredients: ICustomIngredients
  dayTabs: Array<IKeyValuePairString>
  dexcomClientId: Scalars['String']['output']
  dexcomSteloClientId: Scalars['String']['output']
  education: IEducation
  events: IEvents
  featureFlags: Array<IFeatureFlag>
  goalMetricOptions: Array<IGoalMetricOption>
  goalOptions: Array<IGoalOption>
  googleFit: IGoogleFit
  healthData: IHealthDataConfig
  healthKit: IHealthKit
  /** @deprecated health_metrics is replaced by biomarkers */
  healthMetrics: Array<IHealthMetricType>
  healthSettings: IHealthSettings
  /** @deprecated history is replaced by events in mobile app v3.7.2 */
  history: IHistory
  insights: IConfig
  insuranceKinds: IInsuranceKinds
  journal: IJournalConfig
  labResults: ILabResultsConfig
  mealTypes: Array<Scalars['String']['output']>
  meals: IMeals
  measurements: Array<IMeasurementConfig>
  onboarding: IOnboarding
  privacyCenterUrl: Scalars['String']['output']
  questionnaireUrl: Scalars['String']['output']
  referral: IReferral
  reminders: Array<IReminderKind>
  remindersSettings: IRemindersSettings
  researchFaqs: IResearchFaqs
  score: IScore
  sensorSettings: ISensorSettings
  settings: ISettings
  signup: ISignup
  specialtyKinds: Array<IEhrCoachSpecialtyDef>
  stats: IStatsConfig
  tickets: ITickets
  timeZones: Array<Scalars['String']['output']>
  tutorials: Array<ITutorials>
  uhcDeepLinks: IUhcDeepLinks
  /** @deprecated us_states from client_config is replaced by a public us_states query */
  usStates: Array<IState>
}

export type IClientConfigEhrAppointmentKind = {
  __typename?: 'ClientConfigEhrAppointmentKind'
  coachingKind: ICoachesCoachingKindDef
  duration: Scalars['String']['output']
  /** @deprecated Use coaching_kind instead */
  healthCoaching: Scalars['Boolean']['output']
  key: EhrAppointmentKind
  /** @deprecated Use coaching_kind instead */
  mnt: Scalars['Boolean']['output']
  title: Scalars['String']['output']
}

export type ICoach = {
  __typename?: 'Coach'
  active: Scalars['Boolean']['output']
  bio?: Maybe<Scalars['String']['output']>
  coachId: Scalars['ID']['output']
  credentials?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601Date']['output']>
  fullName: Scalars['String']['output']
  getHealthieId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  kind: EhrAppointmentProviderKind
  manager?: Maybe<IUser>
  outOfOffice: Scalars['Boolean']['output']
  photo?: Maybe<Scalars['String']['output']>
  priorityChangedAt?: Maybe<Scalars['ISO8601Date']['output']>
  schedulingPriority?: Maybe<Scalars['Int']['output']>
  specialties: Array<IEhrCoachSpecialtyDef>
  startDate?: Maybe<Scalars['ISO8601Date']['output']>
  stateLicences: Array<Scalars['String']['output']>
  stressBio?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601Date']['output']
}

export type ICoachAssign = {
  coachId: Scalars['ID']['input']
  coachingKind?: InputMaybe<CoachesCoachingKind>
  id?: InputMaybe<Scalars['ID']['input']>
  supportType: CoachAssignmentSupportType
  userId: Scalars['ID']['input']
}

export type ICoachAssignment = {
  __typename?: 'CoachAssignment'
  assignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  canSendEngagementMessage: Scalars['Boolean']['output']
  coach?: Maybe<IUser>
  coachingKind: ICoachesCoachingKindDef
  createdAt: Scalars['ISO8601DateTime']['output']
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  dietitianMenu: Scalars['Boolean']['output']
  ehrAppointment?: Maybe<IEhrAppointment>
  id: Scalars['ID']['output']
  kind?: Maybe<CoachAssignmentKind>
  last: Scalars['Boolean']['output']
  lastCoachMessageDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  referralUrl?: Maybe<Scalars['String']['output']>
  state: CoachAssignmentState
  supportType: CoachAssignmentSupportType
  user: IUser
}

export type ICoachAssignmentDynamicFilter = {
  field: CoachAssignmentDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum CoachAssignmentDynamicFilterField {
  AssignedAt = 'assigned_at',
  ChatConversationLastCoachMessageSentAt = 'chat_conversation_last_coach_message_sent_at',
  CoachId = 'coach_id',
  CoachingKind = 'coaching_kind',
  DeactivatedAt = 'deactivated_at',
  Id = 'id',
  Kind = 'kind',
  Last = 'last',
  LastCoachMessageDate = 'last_coach_message_date',
  State = 'state',
  SupportType = 'support_type',
  UserCommunicationFrequencyValue = 'user_communication_frequency_value',
  UserDietitianRequestValue = 'user_dietitian_request_value',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name',
  UserGoalKind = 'user_goal_kind',
  UserHealthGoalValue = 'user_health_goal_value',
  UserKind = 'user_kind',
  UserLastAppointmentDate = 'user_last_appointment_date',
  UserLastCoreSubscriptionLatestInvoiceLatestChargeCreated = 'user_last_core_subscription_latest_invoice_latest_charge_created',
  UserLastCoreSubscriptionLatestInvoiceLatestChargeStatus = 'user_last_core_subscription_latest_invoice_latest_charge_status',
  UserLastCoreSubscriptionStripeStatus = 'user_last_core_subscription_stripe_status',
  UserLastDietitianSubscriptionStatus = 'user_last_dietitian_subscription_status',
  /** @deprecated use user_last_dietitian_subscription_status */
  UserLastDietitianSubscriptionStripeStatus = 'user_last_dietitian_subscription_stripe_status',
  UserNextAppointmentDate = 'user_next_appointment_date',
  UserNutritionistGroupValue = 'user_nutritionist_group_value',
  UserOneMonthActiveFeedbackDietitianValue = 'user_one_month_active_feedback_dietitian_value',
  UserOngoingDietitianSubscriptionCancelAt = 'user_ongoing_dietitian_subscription_cancel_at',
  UserOngoingDietitianSubscriptionPlansNickname = 'user_ongoing_dietitian_subscription_plans_nickname',
  UserOngoingDietitianSubscriptionPlansProduct = 'user_ongoing_dietitian_subscription_plans_product',
  UserScheduledVideoCallStatusValue = 'user_scheduled_video_call_status_value',
  UserSensorInfoFirstStartTime = 'user_sensor_info_first_start_time',
  UserSensorInfoLastSensorExpirationDate = 'user_sensor_info_last_sensor_expiration_date',
  UserSensorInfoLastSensorExpired = 'user_sensor_info_last_sensor_expired',
  UserSensorInfoReplacementRequestsCount = 'user_sensor_info_replacement_requests_count',
  UserSensorInfoTotalCount = 'user_sensor_info_total_count',
  UserTestGroupValue = 'user_test_group_value',
  UserUserPropertiesDietitianSensorCountNotes = 'user_user_properties_dietitian_sensor_count_notes'
}

export type ICoachAssignmentDynamicFilterItem = {
  items: Array<ICoachAssignmentDynamicFilter>
  operator: DynamicFilterOperator
}

export type ICoachAssignmentInfo = {
  __typename?: 'CoachAssignmentInfo'
  activeAssignmentsCount: Scalars['Int']['output']
  coachId: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum CoachAssignmentKind {
  AnnualMembership = 'annual_membership',
  CoachingPlan = 'coaching_plan',
  Fixed_8Weeks = 'fixed_8_weeks',
  Influencer = 'influencer',
  NoCoreSubscription = 'no_core_subscription',
  NonRecurring = 'non_recurring',
  Recurring_12Weeks = 'recurring_12_weeks',
  Regular = 'regular'
}

export type ICoachAssignmentSort = {
  direction: SortDirection
  field: CoachAssignmentSortField
}

export enum CoachAssignmentSortField {
  AssignedAt = 'assigned_at',
  ChatConversationLastCoachMessageSentAt = 'chat_conversation_last_coach_message_sent_at',
  CoachFullName = 'coach_full_name',
  CoachingKind = 'coaching_kind',
  DeactivatedAt = 'deactivated_at',
  Id = 'id',
  Kind = 'kind',
  State = 'state',
  SupportType = 'support_type',
  UserCommunicationFrequencyValue = 'user_communication_frequency_value',
  UserDietitianRequestValue = 'user_dietitian_request_value',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name',
  UserGoalKind = 'user_goal_kind',
  UserHealthGoalValue = 'user_health_goal_value',
  UserKind = 'user_kind',
  UserLastAppointmentDate = 'user_last_appointment_date',
  UserLastCoreSubscriptionLatestInvoiceLatestChargeCreated = 'user_last_core_subscription_latest_invoice_latest_charge_created',
  UserLastCoreSubscriptionLatestInvoiceLatestChargeStatus = 'user_last_core_subscription_latest_invoice_latest_charge_status',
  UserLastCoreSubscriptionStripeStatus = 'user_last_core_subscription_stripe_status',
  UserLastDietitianSubscriptionStatus = 'user_last_dietitian_subscription_status',
  /** @deprecated use user_last_dietitian_subscription_status */
  UserLastDietitianSubscriptionStripeStatus = 'user_last_dietitian_subscription_stripe_status',
  UserNextAppointmentDate = 'user_next_appointment_date',
  UserNutritionistGroupValue = 'user_nutritionist_group_value',
  UserOneMonthActiveFeedbackDietitianValue = 'user_one_month_active_feedback_dietitian_value',
  UserOngoingDietitianSubscriptionCancelAt = 'user_ongoing_dietitian_subscription_cancel_at',
  UserOngoingDietitianSubscriptionPlansNickname = 'user_ongoing_dietitian_subscription_plans_nickname',
  UserOngoingDietitianSubscriptionPlansProduct = 'user_ongoing_dietitian_subscription_plans_product',
  UserScheduledVideoCallStatusValue = 'user_scheduled_video_call_status_value',
  UserSensorInfoFirstStartTime = 'user_sensor_info_first_start_time',
  UserSensorInfoLastSensorExpirationDate = 'user_sensor_info_last_sensor_expiration_date',
  UserSensorInfoLastSensorExpired = 'user_sensor_info_last_sensor_expired',
  UserSensorInfoReplacementRequestsCount = 'user_sensor_info_replacement_requests_count',
  UserSensorInfoTotalCount = 'user_sensor_info_total_count',
  UserTestGroupValue = 'user_test_group_value',
  UserUserPropertiesDietitianSensorCountNotes = 'user_user_properties_dietitian_sensor_count_notes'
}

export enum CoachAssignmentState {
  Active = 'active',
  Inactive = 'inactive',
  Paused = 'paused',
  Pending = 'pending'
}

export enum CoachAssignmentSupportType {
  AsyncChat = 'async_chat',
  MealPlan = 'meal_plan',
  SupplementReview = 'supplement_review',
  VideoCall = 'video_call',
  VideoChat = 'video_chat'
}

export type ICoachAssignmentsCollection = {
  __typename?: 'CoachAssignmentsCollection'
  coachAssignments: Array<ICoachAssignment>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type ICoachBillableItem = {
  __typename?: 'CoachBillableItem'
  calculatedFee: Scalars['Float']['output']
  id: Scalars['ID']['output']
  stateSnapshotUserId: Scalars['ID']['output']
}

export type ICoachBillingInvoice = {
  __typename?: 'CoachBillingInvoice'
  adminTotal: Scalars['Float']['output']
  billableTotal: Scalars['Float']['output']
  coach: IUserMin
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  number: Scalars['String']['output']
  periodEnd: Scalars['ISO8601Date']['output']
  periodStart: Scalars['ISO8601Date']['output']
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  submittedAt: Scalars['ISO8601DateTime']['output']
  total: Scalars['Float']['output']
}

export type ICoachBillingInvoiceCollection = {
  __typename?: 'CoachBillingInvoiceCollection'
  invoices: Array<ICoachBillingInvoice>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type ICoachBillingInvoiceDynamicFilter = {
  field: CoachBillingInvoiceDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum CoachBillingInvoiceDynamicFilterField {
  AdminTotal = 'admin_total',
  BillableTotal = 'billable_total',
  CoachId = 'coach_id',
  CreatedAt = 'created_at',
  CreatedById = 'created_by_id',
  Id = 'id',
  Number = 'number',
  PeriodEnd = 'period_end',
  PeriodStart = 'period_start',
  SentAt = 'sent_at',
  SubmittedAt = 'submitted_at',
  Total = 'total',
  UpdatedAt = 'updated_at'
}

export type ICoachBillingInvoiceDynamicFilterItem = {
  items: Array<ICoachBillingInvoiceDynamicFilter>
  operator: DynamicFilterOperator
}

export type ICoachBillingInvoiceItem = {
  __typename?: 'CoachBillingInvoiceItem'
  billableItem?: Maybe<ICoachBillableItem>
  coach: IUserMin
  createdAt: Scalars['ISO8601DateTime']['output']
  date: Scalars['ISO8601Date']['output']
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  itemKey: Scalars['String']['output']
  kind: CoachesBillingInvoiceItemKind
  quantity: Scalars['Float']['output']
  rate: Scalars['Float']['output']
  state: CoachesBillingInvoiceItemState
  total: Scalars['Float']['output']
}

export type ICoachBillingInvoiceItemCollection = {
  __typename?: 'CoachBillingInvoiceItemCollection'
  items: Array<ICoachBillingInvoiceItem>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type ICoachBillingInvoiceItemDynamicFilter = {
  field: CoachBillingInvoiceItemDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum CoachBillingInvoiceItemDynamicFilterField {
  BillableItemStateSnapshotUserId = 'billable_item_state_snapshot_user_id',
  Date = 'date',
  Description = 'description',
  Id = 'id',
  ItemKey = 'item_key',
  Kind = 'kind',
  Quantity = 'quantity',
  Rate = 'rate',
  State = 'state',
  Total = 'total'
}

export type ICoachBillingInvoiceItemDynamicFilterItem = {
  items: Array<ICoachBillingInvoiceItemDynamicFilter>
  operator: DynamicFilterOperator
}

export type ICoachBillingInvoiceItemKindCollection = {
  __typename?: 'CoachBillingInvoiceItemKindCollection'
  kinds: Array<ICoachesBillingInvoiceItemKindDef>
}

export type ICoachBillingInvoiceItemSort = {
  direction: SortDirection
  field: CoachBillingInvoiceItemSortField
}

export enum CoachBillingInvoiceItemSortField {
  BillableItemStateSnapshotUserId = 'billable_item_state_snapshot_user_id',
  Date = 'date',
  Description = 'description',
  Id = 'id',
  ItemKey = 'item_key',
  Kind = 'kind',
  Quantity = 'quantity',
  Rate = 'rate',
  State = 'state',
  Total = 'total'
}

export type ICoachBillingInvoiceItemTotal = {
  __typename?: 'CoachBillingInvoiceItemTotal'
  count: Scalars['Int']['output']
  kind: CoachesBillingInvoiceItemKind
  quantity: Scalars['Int']['output']
  total: Scalars['Float']['output']
}

export type ICoachBillingInvoiceItemTotals = {
  __typename?: 'CoachBillingInvoiceItemTotals'
  adminTotal: Scalars['Float']['output']
  billableTotal: Scalars['Float']['output']
  items: Array<ICoachBillingInvoiceItemTotal>
  total: Scalars['Float']['output']
}

export type ICoachBillingInvoiceReview = {
  __typename?: 'CoachBillingInvoiceReview'
  coach: IUserMin
  id: Scalars['ID']['output']
  kind: CoachesBillingInvoiceReviewKind
  periodEnd: Scalars['ISO8601Date']['output']
  periodStart: Scalars['ISO8601Date']['output']
  reviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  reviewedBy: IUserMin
}

export type ICoachBillingInvoiceReviewCollection = {
  __typename?: 'CoachBillingInvoiceReviewCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  reviews: Array<ICoachBillingInvoiceReview>
  totalCount: Scalars['Int']['output']
}

export type ICoachBillingInvoiceReviewDynamicFilter = {
  field: CoachBillingInvoiceReviewDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum CoachBillingInvoiceReviewDynamicFilterField {
  Id = 'id',
  Kind = 'kind',
  ReviewedAt = 'reviewed_at',
  ReviewedByEmail = 'reviewed_by_email',
  ReviewedByFullName = 'reviewed_by_full_name',
  ReviewedById = 'reviewed_by_id'
}

export type ICoachBillingInvoiceReviewDynamicFilterItem = {
  items: Array<ICoachBillingInvoiceReviewDynamicFilter>
  operator: DynamicFilterOperator
}

export type ICoachBillingInvoiceReviewSort = {
  direction: SortDirection
  field: CoachBillingInvoiceReviewSortField
}

export enum CoachBillingInvoiceReviewSortField {
  Id = 'id',
  Kind = 'kind',
  ReviewedAt = 'reviewed_at',
  ReviewedByEmail = 'reviewed_by_email',
  ReviewedByFullName = 'reviewed_by_full_name',
  ReviewedById = 'reviewed_by_id'
}

export type ICoachBillingInvoiceSort = {
  direction: SortDirection
  field: CoachBillingInvoiceSortField
}

export enum CoachBillingInvoiceSortField {
  AdminTotal = 'admin_total',
  BillableTotal = 'billable_total',
  CoachId = 'coach_id',
  CreatedAt = 'created_at',
  CreatedById = 'created_by_id',
  Id = 'id',
  Number = 'number',
  PeriodEnd = 'period_end',
  PeriodStart = 'period_start',
  SentAt = 'sent_at',
  SubmittedAt = 'submitted_at',
  Total = 'total',
  UpdatedAt = 'updated_at'
}

export type ICoachBillingInvoiceUser = {
  __typename?: 'CoachBillingInvoiceUser'
  billingPeriodState: CoachBillingInvoiceUserBillingPeriodStates
  id: Scalars['ID']['output']
  lastCoachReview?: Maybe<ICoachBillingInvoiceReview>
  lastInvoice?: Maybe<ICoachBillingInvoice>
  periodEnd: Scalars['ISO8601Date']['output']
  periodStart: Scalars['ISO8601Date']['output']
  total: Scalars['Float']['output']
  user: IUserMin
}

export enum CoachBillingInvoiceUserBillingPeriodStates {
  CoachReviewed = 'coach_reviewed',
  Inactive = 'inactive',
  Invoiced = 'invoiced',
  Pending = 'pending'
}

export type ICoachBillingInvoiceUserCollection = {
  __typename?: 'CoachBillingInvoiceUserCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
  users: Array<ICoachBillingInvoiceUser>
}

export type ICoachBillingInvoiceUserDynamicFilter = {
  field: CoachBillingInvoiceUserDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum CoachBillingInvoiceUserDynamicFilterField {
  BillingPeriodState = 'billing_period_state',
  Email = 'email',
  FullName = 'full_name',
  Id = 'id'
}

export type ICoachBillingInvoiceUserDynamicFilterItem = {
  items: Array<ICoachBillingInvoiceUserDynamicFilter>
  operator: DynamicFilterOperator
}

export type ICoachBillingInvoiceUserSort = {
  direction: SortDirection
  field: CoachBillingInvoiceUserSortField
}

export enum CoachBillingInvoiceUserSortField {
  Email = 'email',
  FullName = 'full_name',
  Id = 'id',
  InvoiceItemsTotal = 'invoice_items_total'
}

export type ICoachBillingRates = {
  __typename?: 'CoachBillingRates'
  adminTimeRate: Scalars['Float']['output']
  asyncSupportRate: Scalars['Float']['output']
  coachId: Scalars['ID']['output']
  completedCallRate: Scalars['Float']['output']
  incompleteCallRate: Scalars['Float']['output']
  mealPlanRate: Scalars['Float']['output']
  memberReferralBonusRate: Scalars['Float']['output']
  supplementReviewRate: Scalars['Float']['output']
}

export type ICoachConversationMessagePreview = {
  __typename?: 'CoachConversationMessagePreview'
  value: Scalars['String']['output']
}

export type ICoachConversationScheduledMessage = {
  __typename?: 'CoachConversationScheduledMessage'
  coachAssignment: ICoachAssignment
  id: Scalars['ID']['output']
  kind: ChatConversationMessageTemplateKind
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  state: CoachesConversationScheduledMessageState
  value: Scalars['String']['output']
}

export type ICoachConversationScheduledMessageCollection = {
  __typename?: 'CoachConversationScheduledMessageCollection'
  coachConversationScheduledMessages: Array<ICoachConversationScheduledMessage>
}

export type ICoachConversationScheduledMessageSort = {
  direction: SortDirection
  field: CoachConversationScheduledMessageSortField
}

export enum CoachConversationScheduledMessageSortField {
  SendAt = 'send_at'
}

export type ICoachInviteResult = {
  __typename?: 'CoachInviteResult'
  classification: EhrCoachesClassifyInvitesServiceClassification
  email: Scalars['String']['output']
}

export type ICoachInviteSummary = {
  __typename?: 'CoachInviteSummary'
  errorExistingNonCoachUser: Scalars['Int']['output']
  skipExistingCoach: Scalars['Int']['output']
  skipMalformed: Scalars['Int']['output']
  skipNonNutrisenseEmail: Scalars['Int']['output']
  willCreate: Scalars['Int']['output']
}

export type ICoachProfile = {
  __typename?: 'CoachProfile'
  /** @deprecated Use `state` instead */
  active: Scalars['Boolean']['output']
  additionalLanguages?: Maybe<Scalars['String']['output']>
  averageRating?: Maybe<Scalars['Float']['output']>
  bio?: Maybe<Scalars['String']['output']>
  cdrCnsCard?: Maybe<Scalars['String']['output']>
  cdrCnsExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>
  cdrCnsNumber?: Maybe<Scalars['String']['output']>
  coachId: Scalars['ID']['output']
  credentials?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601Date']['output']>
  ethnicity?: Maybe<Scalars['String']['output']>
  fullName: Scalars['String']['output']
  gender?: Maybe<EhrCoachGender>
  getHealthieId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  licenceMode?: Maybe<EhrCoachLicenceMode>
  manager?: Maybe<IUser>
  outOfOffice: Scalars['Boolean']['output']
  pendingRegisterNote?: Maybe<Scalars['String']['output']>
  photo?: Maybe<Scalars['String']['output']>
  premium: Scalars['Boolean']['output']
  priorityChangedAt?: Maybe<Scalars['ISO8601Date']['output']>
  registrationStatus: EhrCoachRegistrationStatus
  reviewsCount: Scalars['Int']['output']
  schedulingPriority?: Maybe<Scalars['Int']['output']>
  specialties: Array<IEhrCoachSpecialtyDef>
  startDate?: Maybe<Scalars['ISO8601Date']['output']>
  state: EhrCoachState
  stateLicenceDetails: Array<IStateLicence>
  stateLicences: Array<Scalars['String']['output']>
  stateOfResidence?: Maybe<Scalars['String']['output']>
  stressBio?: Maybe<Scalars['String']['output']>
  stressLicenceMode?: Maybe<EhrCoachLicenceMode>
  unlimitedChatSupport: Scalars['Boolean']['output']
  updatedAt: Scalars['ISO8601Date']['output']
}

export type ICoachProfileCollection = {
  __typename?: 'CoachProfileCollection'
  coachProfiles: Array<ICoachProfile>
}

export type ICoachSharedAsset = {
  __typename?: 'CoachSharedAsset'
  category: CoachesSharedAssetCategory
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: IUser
  description?: Maybe<Scalars['String']['output']>
  fileName: Scalars['String']['output']
  fileType: Scalars['String']['output']
  id: Scalars['ID']['output']
  permanentUrl: Scalars['String']['output']
  tags: Array<Scalars['String']['output']>
  title: Scalars['String']['output']
  visibility: CoachesSharedAssetVisibility
}

export type ICoachSharedAssetCollection = {
  __typename?: 'CoachSharedAssetCollection'
  coachSharedAssets: Array<ICoachSharedAsset>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type ICoachSharedAssetDynamicFilter = {
  field: CoachSharedAssetDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum CoachSharedAssetDynamicFilterField {
  Category = 'category',
  CreatedAt = 'created_at',
  Id = 'id',
  Title = 'title',
  Visibility = 'visibility'
}

export type ICoachSharedAssetDynamicFilterItem = {
  items: Array<ICoachSharedAssetDynamicFilter>
  operator: DynamicFilterOperator
}

export type ICoachSharedAssetSort = {
  direction: SortDirection
  field: CoachSharedAssetSortField
}

export enum CoachSharedAssetSortField {
  CreatedAt = 'created_at',
  Id = 'id',
  Title = 'title'
}

export enum CoachesBillingInvoiceItemKind {
  AddOnSupport = 'add_on_support',
  AdminTime = 'admin_time',
  CgmReferralBonus = 'cgm_referral_bonus',
  CompletedCall = 'completed_call',
  Glp1ReferralBonus = 'glp1_referral_bonus',
  JourneyCommission = 'journey_commission',
  LateCancellationFee = 'late_cancellation_fee',
  LateRescheduleFee = 'late_reschedule_fee',
  MealPlan = 'meal_plan',
  MemberReferralBonus = 'member_referral_bonus',
  MonthlyBenchmarkBonus = 'monthly_benchmark_bonus',
  NoShowFees = 'no_show_fees',
  OnboardingBonus = 'onboarding_bonus',
  QuarterlyBenchmarkBonus = 'quarterly_benchmark_bonus',
  SpotBonus = 'spot_bonus',
  SupplementReview = 'supplement_review'
}

export type ICoachesBillingInvoiceItemKindDef = {
  __typename?: 'CoachesBillingInvoiceItemKindDef'
  admin: Scalars['Boolean']['output']
  billable: Scalars['Boolean']['output']
  key: CoachesBillingInvoiceItemKind
  name: Scalars['String']['output']
  selfReportable: Scalars['Boolean']['output']
}

export enum CoachesBillingInvoiceItemState {
  Active = 'active',
  Deleted = 'deleted'
}

export enum CoachesBillingInvoiceReviewKind {
  Coach = 'coach'
}

export enum CoachesCoachingKind {
  HealthCoaching = 'health_coaching',
  Medical = 'medical',
  Mnt = 'mnt',
  StressManagement = 'stress_management'
}

export enum CoachesCoachingKindAssignmentState {
  Active = 'active',
  Inactive = 'inactive'
}

export type ICoachesCoachingKindDef = {
  __typename?: 'CoachesCoachingKindDef'
  clinical: Scalars['Boolean']['output']
  coachTitle: Scalars['String']['output']
  hubTitle: Scalars['String']['output']
  insuranceReimbursable: Scalars['Boolean']['output']
  key: CoachesCoachingKind
  primary: Scalars['Boolean']['output']
  serviceTitle: Scalars['String']['output']
  shortCoachTitle: Scalars['String']['output']
  shortHubTitle: Scalars['String']['output']
}

export type ICoachesConfig = {
  __typename?: 'CoachesConfig'
  coachSwitchMaxSpecialtiesSelection: Scalars['Int']['output']
}

export enum CoachesConversationScheduledMessageState {
  Canceled = 'canceled',
  Failed = 'failed',
  Pending = 'pending',
  Sent = 'sent'
}

export enum CoachesSharedAssetCategory {
  Activity = 'activity',
  Education = 'education',
  Infographic = 'infographic',
  Recipe = 'recipe'
}

export enum CoachesSharedAssetVisibility {
  Personal = 'personal',
  Shared = 'shared'
}

export type ICompletedScreen = {
  __typename?: 'CompletedScreen'
  footnote?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  icon?: Maybe<UiIcon>
  /** @deprecated use intro_markdown */
  intro?: Maybe<Scalars['String']['output']>
  introMarkdown?: Maybe<Scalars['String']['output']>
  primaryActionText?: Maybe<Scalars['String']['output']>
  secondaryActionLink?: Maybe<ILink>
  showCoachPhoto: Scalars['Boolean']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type IConfig = {
  __typename?: 'Config'
  filters: IStatsFilters
  statistics: Array<IStatistics>
}

export type IConfigUnit = {
  __typename?: 'ConfigUnit'
  precision: Scalars['Int']['output']
  ranges: Array<IRangeUnit>
  units: Scalars['String']['output']
}

export type IConversation = {
  __typename?: 'Conversation'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  providerId: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  userId: Scalars['ID']['output']
}

export type IConversationMessageTemplateCollection = {
  __typename?: 'ConversationMessageTemplateCollection'
  chatConversationMessageTemplates: Array<IChatConversationMessageTemplate>
  /** @deprecated use conversationMessageTemplates */
  coachConversationMessageTemplates: Array<IChatConversationMessageTemplate>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type ICreateActionGoal = {
  goalText?: InputMaybe<Scalars['String']['input']>
  kind: ActionGoalKind
  metricKind: ActionGoalMetricKind
  metricValue?: InputMaybe<Scalars['Float']['input']>
  numberDays: Scalars['Int']['input']
}

export type ICreditRequestPayload = {
  centsAmount: Scalars['Int']['input']
}

export type ICreditResponsePayload = {
  __typename?: 'CreditResponsePayload'
  centsAmount: Scalars['Int']['output']
}

export type ICustomIngredients = {
  __typename?: 'CustomIngredients'
  macros: Array<IMacro>
}

export type IDailyScore = {
  __typename?: 'DailyScore'
  score?: Maybe<Scalars['Int']['output']>
  scoreMean?: Maybe<Scalars['Int']['output']>
  scorePeak?: Maybe<Scalars['Int']['output']>
  scoreStdDev?: Maybe<Scalars['Int']['output']>
  scoreTimeOutsideRange?: Maybe<Scalars['Int']['output']>
}

export type IDateFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>
  endHour?: InputMaybe<Scalars['Int']['input']>
  excludeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  graph?: InputMaybe<Scalars['String']['input']>
  includeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  order?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  scope?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  startHour?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<IKeyValueStringArray>>
}

export type IDeleteDuplicateAccountRequestPayload = {
  creditAmountInCents: Scalars['Int']['input']
  duplicateUserId: Scalars['ID']['input']
  replaceWithDuplicateUserEmail?: InputMaybe<Scalars['Boolean']['input']>
}

export type IDeleteDuplicateAccountResponsePayload = {
  __typename?: 'DeleteDuplicateAccountResponsePayload'
  creditAmountInCents: Scalars['Int']['output']
  duplicateUserId: Scalars['ID']['output']
  replaceWithDuplicateUserEmail?: Maybe<Scalars['Boolean']['output']>
}

export type IDelimiter = {
  __typename?: 'Delimiter'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
}

export type IDexcomConnection = {
  __typename?: 'DexcomConnection'
  createdAt: Scalars['ISO8601DateTime']['output']
  kind: DexcomConnectionKind
  lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  status: DexcomConnectionStatus
}

export enum DexcomConnectionKind {
  Research = 'research',
  Stelo = 'stelo'
}

export enum DexcomConnectionStatus {
  Active = 'active',
  Invalidated = 'invalidated'
}

export type IDexcomConnectionStatusCheckResult = {
  __typename?: 'DexcomConnectionStatusCheckResult'
  connection?: Maybe<IDexcomConnection>
  latestGlucoseMeasurementAt?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type IDexcomConnectionType = {
  __typename?: 'DexcomConnectionType'
  accessToken: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  dexcomUserId?: Maybe<Scalars['String']['output']>
  kind: DexcomConnectionKind
  lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  status: DexcomConnectionStatus
}

export type IDietitianSession = {
  __typename?: 'DietitianSession'
  dietitianId: Scalars['ID']['output']
  durationInSeconds: Scalars['Float']['output']
  endedAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  startedAt: Scalars['ISO8601DateTime']['output']
  userId?: Maybe<Scalars['ID']['output']>
}

export type IDirectUpload = {
  __typename?: 'DirectUpload'
  headers: Array<IKeyValuePairString>
  signedId: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type IDirectUploadCollection = {
  __typename?: 'DirectUploadCollection'
  directUploads: Array<IDirectUpload>
}

export enum DirectUploadReason {
  IntercomAttachment = 'intercom_attachment',
  MealPhoto = 'meal_photo'
}

export type IDoctor = {
  __typename?: 'Doctor'
  avatar?: Maybe<Scalars['String']['output']>
  bio?: Maybe<Scalars['String']['output']>
  credentials?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  getHealthieId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  kind: EhrAppointmentProviderKind
  lastName?: Maybe<Scalars['String']['output']>
  state: EhrDoctorState
}

export type IDoctorAssignment = {
  __typename?: 'DoctorAssignment'
  doctor: IDoctor
  id: Scalars['ID']['output']
  state: EhrDoctorAssignmentState
}

export enum DynamicFilterItemOperation {
  Blank = 'blank',
  Cont = 'cont',
  ContAll = 'cont_all',
  ContAny = 'cont_any',
  DoesNotMatch = 'does_not_match',
  DoesNotMatchAll = 'does_not_match_all',
  DoesNotMatchAny = 'does_not_match_any',
  End = 'end',
  EndAll = 'end_all',
  EndAny = 'end_any',
  Eq = 'eq',
  Gt = 'gt',
  GtAll = 'gt_all',
  GtAny = 'gt_any',
  Gteq = 'gteq',
  GteqAll = 'gteq_all',
  GteqAny = 'gteq_any',
  ICont = 'i_cont',
  IContAll = 'i_cont_all',
  IContAny = 'i_cont_any',
  In = 'in',
  IsNull = 'is_null',
  Lt = 'lt',
  LtAll = 'lt_all',
  LtAny = 'lt_any',
  Lteq = 'lteq',
  LteqAll = 'lteq_all',
  LteqAny = 'lteq_any',
  Matches = 'matches',
  MatchesAll = 'matches_all',
  MatchesAny = 'matches_any',
  NotCont = 'not_cont',
  NotContAll = 'not_cont_all',
  NotContAny = 'not_cont_any',
  NotEnd = 'not_end',
  NotEndAll = 'not_end_all',
  NotEndAny = 'not_end_any',
  NotEq = 'not_eq',
  NotEqAll = 'not_eq_all',
  NotICont = 'not_i_cont',
  NotIContAll = 'not_i_cont_all',
  NotIContAny = 'not_i_cont_any',
  NotIn = 'not_in',
  NotNull = 'not_null',
  NotStart = 'not_start',
  NotStartAll = 'not_start_all',
  NotStartAny = 'not_start_any',
  Present = 'present',
  Start = 'start',
  StartAll = 'start_all',
  StartAny = 'start_any'
}

export enum DynamicFilterOperator {
  And = 'and',
  Or = 'or'
}

export type IEducation = {
  __typename?: 'Education'
  collections: Array<IEducationCollection>
}

export type IEducationArticle = {
  __typename?: 'EducationArticle'
  author: Scalars['String']['output']
  imageUrl: Scalars['String']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type IEducationCollection = {
  __typename?: 'EducationCollection'
  articles: Array<IEducationArticle>
  imageUrl: Scalars['String']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type IEhrAppointment = {
  __typename?: 'EhrAppointment'
  addToGcalLink?: Maybe<Scalars['String']['output']>
  attendances: Array<IEhrAppointmentAttendance>
  category: EhrAppointmentCategory
  coachRating?: Maybe<Scalars['Int']['output']>
  coachingKind: CoachesCoachingKind
  forbidLateReschedule: Scalars['Boolean']['output']
  getHealthieId?: Maybe<Scalars['ID']['output']>
  getHealthieInstanceKind: EhrGetHealthieInstanceKind
  id: Scalars['ID']['output']
  joinUrl?: Maybe<Scalars['String']['output']>
  kind: EhrAppointmentKind
  lastState: IEhrAppointmentState
  lateCancellationFeeProduct?: Maybe<BillingProduct>
  lateRescheduleFeeProduct?: Maybe<BillingProduct>
  meetingAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  noShowFeeProduct?: Maybe<BillingProduct>
  payAsYouGoProduct?: Maybe<IProduct>
  providerName?: Maybe<Scalars['String']['output']>
  providers: Array<IEhrProvider>
  /** @deprecated Use `recurring` field instead */
  recurrent: Scalars['Boolean']['output']
  recurring: Scalars['Boolean']['output']
  startUrl?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  unauthenticatedIcsLink?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type IEhrAppointmentAttendance = {
  __typename?: 'EhrAppointmentAttendance'
  agenda?: Maybe<Scalars['String']['output']>
  chargeKind: EhrAppointmentAttendanceChargeKind
  feeInvoice?: Maybe<IInvoice>
  id: Scalars['ID']['output']
  imposesLateChangeFees: Scalars['Boolean']['output']
  insurancePolicy?: Maybe<IInsurancePolicy>
  invoice?: Maybe<IInvoice>
  state: EhrAppointmentAttendanceState
  user: IUser
}

export enum EhrAppointmentAttendanceChargeKind {
  BsAllowanceCovered = 'bs_allowance_covered',
  BsFree = 'bs_free',
  BsInsuranceCovered = 'bs_insurance_covered',
  BsPaid = 'bs_paid',
  BsSelfPay = 'bs_self_pay',
  NsPaid = 'ns_paid'
}

export enum EhrAppointmentAttendanceState {
  Attended = 'attended',
  Pending = 'pending',
  Unattended = 'unattended'
}

export enum EhrAppointmentCategory {
  Coaching = 'coaching',
  Dpp = 'dpp',
  GroupMnt = 'group_mnt',
  Medical = 'medical'
}

export type IEhrAppointmentCollection = {
  __typename?: 'EhrAppointmentCollection'
  appointments: Array<IHealthPortalEhrAppointment>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IEhrAppointmentCredits = {
  __typename?: 'EhrAppointmentCredits'
  count: Scalars['Int']['output']
  countBySubscriptionId: Scalars['JSON']['output']
}

export type IEhrAppointmentDynamicFilter = {
  field: AppointmentDynamicEhrFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export type IEhrAppointmentDynamicFilterItem = {
  items: Array<IEhrAppointmentDynamicFilter>
  operator: DynamicFilterOperator
}

export enum EhrAppointmentKind {
  DpWebinarSession = 'dp_webinar_session',
  DppSession = 'dpp_session',
  Followup = 'followup',
  Followup_30 = 'followup_30',
  Followup_45 = 'followup_45',
  Followup_90 = 'followup_90',
  GlpSession = 'glp_session',
  GlpSession_10 = 'glp_session_10',
  Initial = 'initial',
  Initial_60 = 'initial_60',
  NoneCovered = 'none_covered',
  StressManagement = 'stress_management',
  StressManagementMnt = 'stress_management_mnt',
  UhcHealthCoaching = 'uhc_health_coaching'
}

export enum EhrAppointmentProviderKind {
  Coach = 'coach',
  Doctor = 'doctor'
}

export enum EhrAppointmentProviderState {
  Active = 'active',
  Inactive = 'inactive'
}

export enum EhrAppointmentReason {
  BerryStreetAutomation = 'berry_street_automation',
  BillingSideEffect = 'billing_side_effect',
  BookingKindOverride = 'booking_kind_override',
  CancellationSideEffect = 'cancellation_side_effect',
  CoachSwitch = 'coach_switch',
  CoachesBillableMissingData = 'coaches_billable_missing_data',
  Console = 'console',
  FreeCallGranted = 'free_call_granted',
  FreeCallTrialUpsert = 'free_call_trial_upsert',
  GetHealthie = 'get_healthie',
  GlpIntakeSurveyRestarted = 'glp_intake_survey_restarted',
  HealthPortal = 'health_portal',
  InsuranceDomainMigration = 'insurance_domain_migration',
  InsuranceSideEffect = 'insurance_side_effect',
  NoShowFeePaymentFailed = 'no_show_fee_payment_failed',
  OpsAccountRequest = 'ops_account_request',
  PaymentMethodMissing = 'payment_method_missing',
  PreauthorizationFailed = 'preauthorization_failed',
  RecurrenceDelete = 'recurrence_delete',
  RecurrenceForceUpsert = 'recurrence_force_upsert',
  RecurrenceUpsert = 'recurrence_upsert',
  RestoredAsFreeFromBerryStreetAutomation = 'restored_as_free_from_berry_street_automation',
  RestoredFromBerryStreetAutomation = 'restored_from_berry_street_automation',
  StaleFreePending = 'stale_free_pending',
  SubscriptionExpired = 'subscription_expired',
  UpcomingAppointmentRefresh = 'upcoming_appointment_refresh',
  User = 'user',
  UserCoachSwitch = 'user_coach_switch'
}

export type IEhrAppointmentRecurrence = {
  __typename?: 'EhrAppointmentRecurrence'
  appointmentKind?: Maybe<EhrAppointmentKind>
  cadence: EhrAppointmentRecurrenceCadence
  days: Array<EhrAppointmentRecurrenceDay>
  id: Scalars['ID']['output']
  numberOfCalls: Scalars['Int']['output']
  timeSlots?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>
}

export enum EhrAppointmentRecurrenceCadence {
  BiWeekly = 'bi_weekly',
  Monthly = 'monthly',
  OneTime = 'one_time',
  Weekly = 'weekly'
}

export enum EhrAppointmentRecurrenceDay {
  All = 'all',
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

export enum EhrAppointmentSchedulingRule {
  BsFreeSingle = 'bs_free_single',
  BsPaidBundle = 'bs_paid_bundle',
  BsPaidDouble = 'bs_paid_double',
  BsPaidSingle = 'bs_paid_single',
  NoScheduling = 'no_scheduling',
  StressManagementSingle = 'stress_management_single',
  UhcHealthCoachingDouble = 'uhc_health_coaching_double',
  UhcHealthCoachingSingle = 'uhc_health_coaching_single'
}

export type IEhrAppointmentSchedulingRuleDef = {
  __typename?: 'EhrAppointmentSchedulingRuleDef'
  additionalPaidCallsAllowed: Scalars['Boolean']['output']
  appointmentKind?: Maybe<EhrAppointmentKind>
  chargeKind?: Maybe<EhrAppointmentAttendanceChargeKind>
  count?: Maybe<Scalars['Int']['output']>
  key: EhrAppointmentSchedulingRule
}

export type IEhrAppointmentSort = {
  direction: SortDirection
  field: AppointmentEhrSortField
}

export type IEhrAppointmentState = {
  __typename?: 'EhrAppointmentState'
  appointmentId: Scalars['ID']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  creditUsed: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  kind: EhrAppointmentStateKind
  reason: EhrAppointmentReason
  terminal: Scalars['Boolean']['output']
}

export enum EhrAppointmentStateKind {
  Cancelled = 'cancelled',
  Deleted = 'deleted',
  InReview = 'in_review',
  LateCancellation = 'late_cancellation',
  LateReschedule = 'late_reschedule',
  NoShow = 'no_show',
  Occurred = 'occurred',
  PendingReschedule = 'pending_reschedule',
  PendingSchedule = 'pending_schedule',
  Rescheduled = 'rescheduled',
  Scheduled = 'scheduled'
}

export enum EhrCoachGender {
  Female = 'female',
  Genderqueer = 'genderqueer',
  Male = 'male',
  NonBinary = 'non_binary',
  PreferNotToSay = 'prefer_not_to_say',
  PreferToSelfDescribe = 'prefer_to_self_describe'
}

export enum EhrCoachLicenceMode {
  LegacyState = 'legacy_state',
  PayerLicence = 'payer_licence',
  StateAndPayerLicence = 'state_and_payer_licence',
  StateLicence = 'state_licence'
}

export enum EhrCoachRegistrationStatus {
  Approved = 'approved',
  PendingApproval = 'pending_approval',
  PendingRegister = 'pending_register'
}

export enum EhrCoachSpecialty {
  AutoimmuneConditions = 'autoimmune_conditions',
  Bariatric = 'bariatric',
  Cancer = 'cancer',
  ChronicFatigue = 'chronic_fatigue',
  EatingDisorders = 'eating_disorders',
  Fertility = 'fertility',
  FoodAllergies = 'food_allergies',
  GutHealth = 'gut_health',
  HealthOptimization = 'health_optimization',
  HealthyAging = 'healthy_aging',
  HeartDisease = 'heart_disease',
  HormonalHealth = 'hormonal_health',
  IntegrativeFunctionalNutrition = 'integrative_functional_nutrition',
  KidneyStones = 'kidney_stones',
  MensHealth = 'mens_health',
  MetabolicHealth = 'metabolic_health',
  MindfulEating = 'mindful_eating',
  Osteoporosis = 'osteoporosis',
  PrediabetesDiabetes = 'prediabetes_diabetes',
  PrenatalNutrition = 'prenatal_nutrition',
  SportsPerformance = 'sports_performance',
  StressManagement = 'stress_management',
  ThyroidDisorders = 'thyroid_disorders',
  WeightConcerns = 'weight_concerns',
  WomensHealth = 'womens_health'
}

export type IEhrCoachSpecialtyDef = {
  __typename?: 'EhrCoachSpecialtyDef'
  key: EhrCoachSpecialty
  name: Scalars['String']['output']
}

export enum EhrCoachState {
  Active = 'active',
  Inactive = 'inactive'
}

export enum EhrCoachesClassifyInvitesServiceClassification {
  ErrorExistingNonCoachUser = 'error_existing_non_coach_user',
  SkipExistingCoach = 'skip_existing_coach',
  SkipMalformed = 'skip_malformed',
  SkipNonNutrisenseEmail = 'skip_non_nutrisense_email',
  WillCreate = 'will_create'
}

export enum EhrDoctorAssignmentState {
  Active = 'active',
  Inactive = 'inactive'
}

export enum EhrDoctorState {
  Active = 'active',
  Inactive = 'inactive'
}

export enum EhrGetHealthieInstanceKind {
  BerryStreet = 'berry_street',
  Nutrisense = 'nutrisense'
}

export type IEhrProvider = {
  __typename?: 'EhrProvider'
  appointment: IEhrAppointment
  coach?: Maybe<ICoach>
  doctor?: Maybe<IDoctor>
  id: Scalars['ID']['output']
  kind: EhrAppointmentProviderKind
  state: EhrAppointmentProviderState
}

export type IEligibleUpdateProduct = {
  __typename?: 'EligibleUpdateProduct'
  feeRules?: Maybe<Array<IFeeRule>>
  product: IProductMin
}

export type IEligibleUpdateProducts = {
  __typename?: 'EligibleUpdateProducts'
  eligibleUpdateProducts: Array<IEligibleUpdateProduct>
}

export type IEntryGlucose = {
  __typename?: 'EntryGlucose'
  /** @deprecated Removed in v4.0.2 */
  healthyRange: Array<Scalars['Float']['output']>
  /** @deprecated Removed in v4.0.2 */
  range: Array<Scalars['Float']['output']>
  values: Array<IEntryGlucoseValue>
}

export type IEntryGlucoseValue = {
  __typename?: 'EntryGlucoseValue'
  displayValue?: Maybe<Scalars['String']['output']>
  timestamp: Scalars['ISO8601DateTime']['output']
  value?: Maybe<Scalars['Float']['output']>
}

export type IEntryStatistics = {
  __typename?: 'EntryStatistics'
  aucScore?: Maybe<Scalars['Float']['output']>
  glucose2hrDelta?: Maybe<Scalars['Float']['output']>
  glucoseDelta?: Maybe<Scalars['Float']['output']>
  glucoseMax?: Maybe<Scalars['String']['output']>
  glucoseMin?: Maybe<Scalars['String']['output']>
  glucoseScore?: Maybe<Scalars['Int']['output']>
  glucoseScore2hrDelta?: Maybe<Scalars['Int']['output']>
  glucoseScoreAuc?: Maybe<Scalars['Int']['output']>
  glucoseScoreDelta?: Maybe<Scalars['Int']['output']>
  glucoseScorePeak?: Maybe<Scalars['Int']['output']>
}

export type IEvent = IActivity | IJournalEntry | IMeal | IMeasurement | INote

export type IEventCollection = {
  __typename?: 'EventCollection'
  events: Array<IEvent>
}

export type IEvents = {
  __typename?: 'Events'
  filters: IEventsFilters
}

export type IEventsData = {
  __typename?: 'EventsData'
  events: IEventCollection
}

export type IEventsFilters = {
  __typename?: 'EventsFilters'
  order: Array<Scalars['String']['output']>
  orderBy: Array<Scalars['String']['output']>
  types: Array<IKeyValuePairStringArray>
}

export type IExpandableModule = {
  __typename?: 'ExpandableModule'
  contentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  lessons?: Maybe<Array<ILesson>>
  position?: Maybe<Scalars['Int']['output']>
  progress?: Maybe<IProgress>
}

export type IExpandableProgram = {
  __typename?: 'ExpandableProgram'
  contentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  modules?: Maybe<Array<IExpandableModule>>
  position?: Maybe<Scalars['Int']['output']>
  progress?: Maybe<IProgress>
}

export type IFeatureFlag = {
  __typename?: 'FeatureFlag'
  enabled: Scalars['Boolean']['output']
  key: Scalars['String']['output']
}

export enum FeatureGrant {
  ActionGoals = 'action_goals',
  ActionGoalsManagement = 'action_goals_management',
  AdminPanelManageNutritionistAssignment = 'admin_panel_manage_nutritionist_assignment',
  AdminPanelMembers = 'admin_panel_members',
  AdminPanelResetVideoChatAssignment = 'admin_panel_reset_video_chat_assignment',
  AdminPanelViewNutritionistAssignment = 'admin_panel_view_nutritionist_assignment',
  AdminPanelViewNutritionistNotifications = 'admin_panel_view_nutritionist_notifications',
  AuthorizationManagement = 'authorization_management',
  BillingDashboard = 'billing_dashboard',
  Chat = 'chat',
  ChatManagement = 'chat_management',
  ChatToggleCoachingKind = 'chat_toggle_coaching_kind',
  ChatToggleCoachingKindBypass = 'chat_toggle_coaching_kind_bypass',
  ChatbotAssistant = 'chatbot_assistant',
  ChatbotManageKnowledgeBase = 'chatbot_manage_knowledge_base',
  ChatbotMessageReports = 'chatbot_message_reports',
  ChatbotUserHistory = 'chatbot_user_history',
  ChatbotViewKnowledgeBase = 'chatbot_view_knowledge_base',
  CoachAvailability = 'coach_availability',
  CoachesBillingDashboard = 'coaches_billing_dashboard',
  CoachesBillingDetails = 'coaches_billing_details',
  CoachesBillingReviewOwnItems = 'coaches_billing_review_own_items',
  DexcomConnectionsViewAccountData = 'dexcom_connections_view_account_data',
  EditHealthTeamStructure = 'edit_health_team_structure',
  Files = 'files',
  Financials = 'financials',
  Formulas = 'formulas',
  HealthDataReport = 'health_data_report',
  HealthMetrics = 'health_metrics',
  HealthMetricsManagement = 'health_metrics_management',
  History = 'history',
  Home = 'home',
  HomeCallScheduling = 'home_call_scheduling',
  HomeMobileAppPresentationMode = 'home_mobile_app_presentation_mode',
  HomeSidebar = 'home_sidebar',
  HomeTimeTracker = 'home_time_tracker',
  HomeView = 'home_view',
  Insights = 'insights',
  MembersManagement = 'members_management',
  MembersManagementNutritionistSelection = 'members_management_nutritionist_selection',
  NutritionistHome = 'nutritionist_home',
  NutritionistHomeImpersonate = 'nutritionist_home_impersonate',
  OrganizationMembers = 'organization_members',
  Questionnaire = 'questionnaire',
  SensorsReplacementRequests = 'sensors_replacement_requests',
  ShipmentsManagement = 'shipments_management',
  ShipmentsViewUser = 'shipments_view_user',
  SupportAccountRequests = 'support_account_requests',
  SupportAccountRequestsCreate = 'support_account_requests_create',
  SupportAccountRequestsProcessCancelSubscriptionAtCommitmentEnd = 'support_account_requests_process_cancel_subscription_at_commitment_end',
  SupportAccountRequestsProcessCancelSubscriptionAtPeriodEnd = 'support_account_requests_process_cancel_subscription_at_period_end',
  SupportAccountRequestsProcessCancelSubscriptionImmediately = 'support_account_requests_process_cancel_subscription_immediately',
  SupportAccountRequestsProcessChangeSubscriptionBillingCycle = 'support_account_requests_process_change_subscription_billing_cycle',
  SupportAccountRequestsProcessCredit = 'support_account_requests_process_credit',
  SupportAccountRequestsProcessDeleteDuplicateAccount = 'support_account_requests_process_delete_duplicate_account',
  SupportAccountRequestsProcessGrantFreeVideoCall = 'support_account_requests_process_grant_free_video_call',
  SupportAccountRequestsProcessMiscRequest = 'support_account_requests_process_misc_request',
  SupportAccountRequestsProcessOneOffAddon = 'support_account_requests_process_one_off_addon',
  SupportAccountRequestsProcessPauseSubscription = 'support_account_requests_process_pause_subscription',
  SupportAccountRequestsProcessRefund = 'support_account_requests_process_refund',
  SupportAccountRequestsProcessUncancelSubscription = 'support_account_requests_process_uncancel_subscription',
  SupportAccountRequestsProcessUnpauseSubscription = 'support_account_requests_process_unpause_subscription',
  SupportAccountRequestsProcessUpdateSubscription = 'support_account_requests_process_update_subscription',
  SupportAccountRequestsReviewCancelSubscriptionAtCommitmentEnd = 'support_account_requests_review_cancel_subscription_at_commitment_end',
  SupportAccountRequestsReviewCancelSubscriptionAtPeriodEnd = 'support_account_requests_review_cancel_subscription_at_period_end',
  SupportAccountRequestsReviewCancelSubscriptionImmediately = 'support_account_requests_review_cancel_subscription_immediately',
  SupportAccountRequestsReviewChangeSubscriptionBillingCycle = 'support_account_requests_review_change_subscription_billing_cycle',
  SupportAccountRequestsReviewCredit = 'support_account_requests_review_credit',
  SupportAccountRequestsReviewDeleteDuplicateAccount = 'support_account_requests_review_delete_duplicate_account',
  SupportAccountRequestsReviewMiscRequest = 'support_account_requests_review_misc_request',
  SupportAccountRequestsReviewOneOffAddon = 'support_account_requests_review_one_off_addon',
  SupportAccountRequestsReviewPauseSubscription = 'support_account_requests_review_pause_subscription',
  SupportAccountRequestsReviewRefund = 'support_account_requests_review_refund',
  SupportAccountRequestsReviewUncancelSubscription = 'support_account_requests_review_uncancel_subscription',
  SupportAccountRequestsReviewUnpauseSubscription = 'support_account_requests_review_unpause_subscription',
  SupportAccountRequestsReviewUpdateSubscription = 'support_account_requests_review_update_subscription',
  SupportEditTickets = 'support_edit_tickets',
  SupportResetRescheduleFreePassUsed = 'support_reset_reschedule_free_pass_used',
  SupportTickets = 'support_tickets',
  SupportedSensorManagement = 'supported_sensor_management',
  SurveysManagement = 'surveys_management',
  UsersChangeEmail = 'users_change_email',
  UsersEditAddress = 'users_edit_address',
  UsersEditCoachProfile = 'users_edit_coach_profile',
  UsersEditFulfillmentConfiguration = 'users_edit_fulfillment_configuration',
  UsersEditOrganization = 'users_edit_organization',
  UsersEditOwnCoachProfile = 'users_edit_own_coach_profile',
  UsersEditProfile = 'users_edit_profile',
  UsersEditSettings = 'users_edit_settings',
  UsersManageUiStates = 'users_manage_ui_states',
  UsersViewFulfillmentConfiguration = 'users_view_fulfillment_configuration',
  UsersViewProfile = 'users_view_profile',
  UsersViewSettings = 'users_view_settings',
  UsersViewUiStates = 'users_view_ui_states',
  ViewAppointments = 'view_appointments',
  ViewHealthTeamStructure = 'view_health_team_structure',
  ViewInsuranceStatus = 'view_insurance_status'
}

export type IFeeRule = {
  __typename?: 'FeeRule'
  fee: Scalars['Int']['output']
  paidCyclesCount: Scalars['Int']['output']
}

export type IFile = {
  __typename?: 'File'
  createdAt: Scalars['ISO8601DateTime']['output']
  downloadFileUrl: Scalars['String']['output']
  fileName: Scalars['String']['output']
  fileType: Scalars['String']['output']
  fileUrl: Scalars['String']['output']
  id: Scalars['ID']['output']
  permanentUrl: Scalars['String']['output']
  tag?: Maybe<UserFileTag>
}

export type IFileCollection = {
  __typename?: 'FileCollection'
  files: Array<IFile>
}

export type IFileDynamicFilter = {
  field: FileDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum FileDynamicFilterField {
  Tag = 'tag'
}

export type IFileDynamicFilterItem = {
  items: Array<IFileDynamicFilter>
  operator: DynamicFilterOperator
}

export type IFileMetadata = {
  byteSize: Scalars['Int']['input']
  checksum: Scalars['String']['input']
  contentType: Scalars['String']['input']
  filename: Scalars['String']['input']
}

export type IFileSort = {
  direction: SortDirection
  field: FileSortField
}

export enum FileSortField {
  CreatedAt = 'created_at'
}

export enum FilterAppointmentsKind {
  /** Fetch all appointments */
  All = 'ALL',
  /** Fetch past appointments */
  Past = 'PAST',
  /** Fetch pending schedule appointments */
  PendingSchedule = 'PENDING_SCHEDULE',
  /** Fetch upcoming appointments */
  Upcoming = 'UPCOMING'
}

export type IFollowup = {
  __typename?: 'Followup'
  kind: SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswerFollowupKind
  parentAnswer: IAnswer
  parentQuestionKey: SurveysQuestionKey
  question: IQuestion
}

export type IFormula = {
  __typename?: 'Formula'
  className: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  inputs: Array<IFormulaInput>
  operation: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type IFormulaAction = IFormulaActionFormula | IFormulaActionLink

export type IFormulaActionFormula = {
  __typename?: 'FormulaActionFormula'
  formula: Scalars['String']['output']
  inputs: Array<IFormulaKeyValuePair>
  kind: FormulaActionKind
  title: Scalars['String']['output']
}

export enum FormulaActionKind {
  Formula = 'formula',
  Link = 'link'
}

export type IFormulaActionLink = {
  __typename?: 'FormulaActionLink'
  kind: FormulaActionKind
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type IFormulaCollection = {
  __typename?: 'FormulaCollection'
  formulas: Array<IFormula>
}

export type IFormulaInput = {
  __typename?: 'FormulaInput'
  default?: Maybe<Scalars['String']['output']>
  graphqlField: Scalars['String']['output']
  graphqlType: Scalars['String']['output']
  key: Scalars['String']['output']
  options?: Maybe<Array<IFormulaInputOption>>
  required: Scalars['Boolean']['output']
}

export type IFormulaInputOption = {
  __typename?: 'FormulaInputOption'
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type IFormulaKeyValuePair = {
  __typename?: 'FormulaKeyValuePair'
  key: Scalars['String']['output']
  value?: Maybe<Scalars['String']['output']>
}

export type IFormulaResult = {
  __typename?: 'FormulaResult'
  actions: Array<IFormulaAction>
  outputs: Array<IFormulaKeyValuePair>
}

export type IFulfillmentConfiguration = {
  __typename?: 'FulfillmentConfiguration'
  sensorKind: UserSensorKind
  userId: Scalars['ID']['output']
}

export type IGlucoseDailyScore = {
  __typename?: 'GlucoseDailyScore'
  today: IDailyScore
}

export type IGlucoseStatistics = {
  __typename?: 'GlucoseStatistics'
  today: IStat
}

export type IGlucoseThresholdPreset = {
  __typename?: 'GlucoseThresholdPreset'
  description: Scalars['String']['output']
  high: Scalars['Int']['output']
  low: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export type IGoal = {
  __typename?: 'Goal'
  description?: Maybe<Scalars['String']['output']>
  kind: UserGoalKind
  title: Scalars['String']['output']
}

export type IGoalMetric = {
  __typename?: 'GoalMetric'
  highThresholdValue?: Maybe<Scalars['Float']['output']>
  kind: UserGoalMetricKind
  lowThresholdValue?: Maybe<Scalars['Float']['output']>
  primary: Scalars['Boolean']['output']
  section: Scalars['String']['output']
  statKey: Scalars['String']['output']
}

export type IGoalMetricOption = {
  __typename?: 'GoalMetricOption'
  text: Scalars['String']['output']
  value: UserGoalMetricKind
}

export type IGoalOption = {
  __typename?: 'GoalOption'
  text: Scalars['String']['output']
  value: UserGoalKind
}

export type IGoogleFit = {
  __typename?: 'GoogleFit'
  ignore: Array<Scalars['String']['output']>
}

export type IHealthDataConfig = {
  __typename?: 'HealthDataConfig'
  measurementSourceDefs: Array<IHealthDataMeasurementSourceDef>
  measurementTypeDefs: Array<IHealthDataMeasurementTypeDef>
}

export enum HealthDataMeasurementSource {
  Dexcom = 'dexcom',
  Fitbit = 'fitbit',
  Freestylelibre = 'freestylelibre',
  Garmin = 'garmin',
  GoogleHealth = 'google_health',
  Googlefit = 'googlefit',
  HealthConnect = 'health_connect',
  Healthkit = 'healthkit',
  Ketomojo = 'ketomojo',
  LibreLinkup = 'libre_linkup',
  Lingo = 'lingo',
  Nutrisense = 'nutrisense',
  Oura = 'oura',
  Whoop = 'whoop'
}

export type IHealthDataMeasurementSourceDef = {
  __typename?: 'HealthDataMeasurementSourceDef'
  iconDef?: Maybe<IIconDef>
  key: HealthDataMeasurementSource
  label: Scalars['String']['output']
  providesDailyMeasurements: Scalars['Boolean']['output']
  sourceTags: Array<Scalars['String']['output']>
}

export enum HealthDataMeasurementType {
  Appetite = 'appetite',
  BloodGlucose = 'blood_glucose',
  BloodKetones = 'blood_ketones',
  BloodPressure = 'blood_pressure',
  BodyFatPercentage = 'body_fat_percentage',
  BodyTemperature = 'body_temperature',
  BreathKetones = 'breath_ketones',
  CyclingDistance = 'cycling_distance',
  Energy = 'energy',
  ExerciseTime = 'exercise_time',
  FlightsClimbed = 'flights_climbed',
  Focus = 'focus',
  Glucose = 'glucose',
  Mood = 'mood',
  RunningDistance = 'running_distance',
  StepCount = 'step_count',
  Stress = 'stress',
  SwimmingDistance = 'swimming_distance',
  Weight = 'weight'
}

export type IHealthDataMeasurementTypeDef = {
  __typename?: 'HealthDataMeasurementTypeDef'
  icon?: Maybe<UiIcon>
  /** @deprecated Use icon instead */
  iconDef?: Maybe<IIconDef>
  isDailyMeasurement: Scalars['Boolean']['output']
  isJournalMeasurement: Scalars['Boolean']['output']
  key: HealthDataMeasurementType
  label: Scalars['String']['output']
}

export enum HealthDataMetricBiomarker {
  AlanineTransferase = 'alanine_transferase',
  Albumin = 'albumin',
  AlkalinePhosphatase = 'alkaline_phosphatase',
  Amylase = 'amylase',
  ApolipoproteinA1 = 'apolipoprotein_a1',
  ApolipoproteinB = 'apolipoprotein_b',
  ArachidonicAcid = 'arachidonic_acid',
  ArachidonicAcidEpaRatio = 'arachidonic_acid_epa_ratio',
  AspartateTransferase = 'aspartate_transferase',
  Basophils = 'basophils',
  BloodUreaNitrogen = 'blood_urea_nitrogen',
  Bmi = 'bmi',
  BunCreatinineRatio = 'bun_creatinine_ratio',
  CPeptide = 'c_peptide',
  Calcium = 'calcium',
  CarbonDioxide = 'carbon_dioxide',
  Chloride = 'chloride',
  Creatinine = 'creatinine',
  Dha = 'dha',
  DiastolicBloodPressure = 'diastolic_blood_pressure',
  Dpa = 'dpa',
  Eosinophils = 'eosinophils',
  Epa = 'epa',
  EpaDpaDha = 'epa_dpa_dha',
  EstimatedGfr = 'estimated_gfr',
  FastedGlucose = 'fasted_glucose',
  FastedInsulin = 'fasted_insulin',
  Ferritin = 'ferritin',
  FolateRbc = 'folate_rbc',
  FreeT3 = 'free_t3',
  FreeT4 = 'free_t4',
  HbA1c = 'hb_a1c',
  HdlCholesterol = 'hdl_cholesterol',
  HdlLarge = 'hdl_large',
  Height = 'height',
  Hematocrit = 'hematocrit',
  Hemoglobin = 'hemoglobin',
  Homocysteine = 'homocysteine',
  HsCrp = 'hs_crp',
  IronPercentSaturation = 'iron_percent_saturation',
  IronTotal = 'iron_total',
  LdlCholesterol = 'ldl_cholesterol',
  LdlParticleNumber = 'ldl_particle_number',
  LdlPattern = 'ldl_pattern',
  LdlSmall = 'ldl_small',
  LinoleicAcid = 'linoleic_acid',
  Lipase = 'lipase',
  LipoproteinA = 'lipoprotein_a',
  Lymphocytes = 'lymphocytes',
  MagnesiumRbc = 'magnesium_rbc',
  Mch = 'mch',
  Mchc = 'mchc',
  MeanCorpuscularVolume = 'mean_corpuscular_volume',
  MeanPlateletVolume = 'mean_platelet_volume',
  MethylmalonicAcid = 'methylmalonic_acid',
  Monocytes = 'monocytes',
  NonHdlCholesterol = 'non_hdl_cholesterol',
  Omega_3Total = 'omega_3_total',
  Omega_6Omega_3Ratio = 'omega_6_omega_3_ratio',
  Omega_6Total = 'omega_6_total',
  PlateletCount = 'platelet_count',
  Potassium = 'potassium',
  RbcBlood = 'rbc_blood',
  Rdw = 'rdw',
  ReverseT3 = 'reverse_t3',
  Selenium = 'selenium',
  Sodium = 'sodium',
  SystolicBloodPressure = 'systolic_blood_pressure',
  Tibc = 'tibc',
  TotalCholesterol = 'total_cholesterol',
  TotalCholesterolHdlRatio = 'total_cholesterol_hdl_ratio',
  TpoAntibodies = 'tpo_antibodies',
  Triglycerides = 'triglycerides',
  Tsh = 'tsh',
  UricAcid = 'uric_acid',
  VitaminB12 = 'vitamin_b12',
  VitaminD = 'vitamin_d',
  VitaminD_25Oh = 'vitamin_d_25_oh',
  WbcBlood = 'wbc_blood',
  Weight = 'weight',
  ZincRbc = 'zinc_rbc'
}

export type IHealthDataReport = {
  __typename?: 'HealthDataReport'
  createdAt: Scalars['ISO8601DateTime']['output']
  endDate: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: HealthDataReportKind
  lastState: IHealthDataReportState
  locked: Scalars['Boolean']['output']
  rawData?: Maybe<Scalars['String']['output']>
  reportData?: Maybe<Scalars['String']['output']>
  startDate: Scalars['ISO8601DateTime']['output']
  user: IUser
}

export type IHealthDataReportDynamicFilter = {
  field: HealthDataReportDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum HealthDataReportDynamicFilterField {
  LastStateKind = 'last_state_kind'
}

export type IHealthDataReportDynamicFilterItem = {
  items: Array<IHealthDataReportDynamicFilter>
  operator: DynamicFilterOperator
}

export enum HealthDataReportKind {
  AiHealth = 'ai_health',
  Custom = 'custom',
  CustomBlocks = 'custom_blocks',
  DailyReview = 'daily_review',
  MonthlySummary = 'monthly_summary',
  WeeklyNutrition = 'weekly_nutrition',
  WeeklyTrend = 'weekly_trend'
}

export type IHealthDataReportSort = {
  direction: SortDirection
  field: HealthDataReportSortField
}

export enum HealthDataReportSortField {
  CreatedAt = 'created_at'
}

export type IHealthDataReportState = {
  __typename?: 'HealthDataReportState'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: HealthDataReportStateKind
  reportId: Scalars['ID']['output']
  terminal: Scalars['Boolean']['output']
}

export enum HealthDataReportStateKind {
  BatchSubmitted = 'batch_submitted',
  Completed = 'completed',
  Created = 'created',
  DataFetched = 'data_fetched',
  Deleted = 'deleted',
  Failed = 'failed',
  PdfGenerated = 'pdf_generated'
}

export type IHealthKit = {
  __typename?: 'HealthKit'
  ignore: Array<Scalars['String']['output']>
  sourceIgnore: Array<Scalars['String']['output']>
}

export type IHealthMetric = {
  __typename?: 'HealthMetric'
  date: Scalars['ISO8601Date']['output']
  id: Scalars['ID']['output']
  kind: HealthDataMetricBiomarker
  label: Scalars['String']['output']
  unit?: Maybe<Scalars['String']['output']>
  value: Scalars['Float']['output']
}

export type IHealthMetricType = {
  __typename?: 'HealthMetricType'
  key: HealthMetricsParam
  kind: HealthMetricsKind
  label: Scalars['String']['output']
  unit?: Maybe<Scalars['String']['output']>
}

export type IHealthMetricValue = {
  __typename?: 'HealthMetricValue'
  date: Scalars['ISO8601Date']['output']
  id: Scalars['ID']['output']
  value: Scalars['Float']['output']
}

export type IHealthMetricValues = {
  __typename?: 'HealthMetricValues'
  data: Array<IHealthMetricValue>
  kind: HealthDataMetricBiomarker
  title: Scalars['String']['output']
  unit?: Maybe<Scalars['String']['output']>
}

export type IHealthMetrics = {
  __typename?: 'HealthMetrics'
  healthMetrics: Array<IHealthMetricValues>
}

export enum HealthMetricsKind {
  Biomarker = 'biomarker',
  Measurement = 'measurement'
}

export enum HealthMetricsParam {
  AlanineTransferase = 'alanine_transferase',
  Albumin = 'albumin',
  AlkalinePhosphatase = 'alkaline_phosphatase',
  Amylase = 'amylase',
  ApolipoproteinA1 = 'apolipoprotein_a1',
  ApolipoproteinB = 'apolipoprotein_b',
  ArachidonicAcid = 'arachidonic_acid',
  ArachidonicAcidEpaRatio = 'arachidonic_acid_epa_ratio',
  AspartateTransferase = 'aspartate_transferase',
  Basophils = 'basophils',
  BloodPressure = 'blood_pressure',
  BloodUreaNitrogen = 'blood_urea_nitrogen',
  Bmi = 'bmi',
  BunCreatinineRatio = 'bun_creatinine_ratio',
  CPeptide = 'c_peptide',
  Calcium = 'calcium',
  CarbonDioxide = 'carbon_dioxide',
  Chloride = 'chloride',
  Creatinine = 'creatinine',
  Dha = 'dha',
  Dpa = 'dpa',
  Eosinophils = 'eosinophils',
  Epa = 'epa',
  EpaDpaDha = 'epa_dpa_dha',
  EstimatedGfr = 'estimated_gfr',
  FastedGlucose = 'fasted_glucose',
  FastedInsulin = 'fasted_insulin',
  Ferritin = 'ferritin',
  FolateRbc = 'folate_rbc',
  FreeT3 = 'free_t3',
  FreeT4 = 'free_t4',
  HbA1c = 'hb_a1c',
  HdlCholesterol = 'hdl_cholesterol',
  HdlLarge = 'hdl_large',
  Height = 'height',
  Hematocrit = 'hematocrit',
  Hemoglobin = 'hemoglobin',
  Homocysteine = 'homocysteine',
  HsCrp = 'hs_crp',
  IronPercentSaturation = 'iron_percent_saturation',
  IronTotal = 'iron_total',
  LdlCholesterol = 'ldl_cholesterol',
  LdlParticleNumber = 'ldl_particle_number',
  LdlPattern = 'ldl_pattern',
  LdlSmall = 'ldl_small',
  LinoleicAcid = 'linoleic_acid',
  Lipase = 'lipase',
  LipoproteinA = 'lipoprotein_a',
  Lymphocytes = 'lymphocytes',
  MagnesiumRbc = 'magnesium_rbc',
  Mch = 'mch',
  Mchc = 'mchc',
  MeanCorpuscularVolume = 'mean_corpuscular_volume',
  MeanPlateletVolume = 'mean_platelet_volume',
  MethylmalonicAcid = 'methylmalonic_acid',
  Monocytes = 'monocytes',
  NonHdlCholesterol = 'non_hdl_cholesterol',
  Omega_3Total = 'omega_3_total',
  Omega_6Omega_3Ratio = 'omega_6_omega_3_ratio',
  Omega_6Total = 'omega_6_total',
  PlateletCount = 'platelet_count',
  Potassium = 'potassium',
  RbcBlood = 'rbc_blood',
  Rdw = 'rdw',
  ReverseT3 = 'reverse_t3',
  Selenium = 'selenium',
  Sodium = 'sodium',
  Tibc = 'tibc',
  TotalCholesterol = 'total_cholesterol',
  TotalCholesterolHdlRatio = 'total_cholesterol_hdl_ratio',
  TpoAntibodies = 'tpo_antibodies',
  Triglycerides = 'triglycerides',
  Tsh = 'tsh',
  UricAcid = 'uric_acid',
  VitaminB12 = 'vitamin_b12',
  VitaminD = 'vitamin_d',
  VitaminD_25Oh = 'vitamin_d_25_oh',
  WbcBlood = 'wbc_blood',
  Weight = 'weight',
  ZincRbc = 'zinc_rbc'
}

export type IHealthPortalBillingPaymentIntent = {
  __typename?: 'HealthPortalBillingPaymentIntent'
  amount: Scalars['Float']['output']
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  captureMethod: BillingPaymentIntentCaptureMethod
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  reason: BillingPaymentIntentReason
  status: BillingPaymentIntentStatus
  stripeId: Scalars['String']['output']
}

export type IHealthPortalEhrAppointment = {
  __typename?: 'HealthPortalEhrAppointment'
  actualDuration?: Maybe<Scalars['Int']['output']>
  addToGcalLink?: Maybe<Scalars['String']['output']>
  attendances: Array<IHealthPortalEhrAppointmentAttendance>
  category: EhrAppointmentCategory
  coachRating?: Maybe<Scalars['Int']['output']>
  coachingKind: CoachesCoachingKind
  createdAt: Scalars['ISO8601DateTime']['output']
  getHealthieId?: Maybe<Scalars['ID']['output']>
  getHealthieInstanceKind: EhrGetHealthieInstanceKind
  id: Scalars['ID']['output']
  joinUrl?: Maybe<Scalars['String']['output']>
  kind: EhrAppointmentKind
  lastState: IHealthPortalEhrAppointmentState
  meetingAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  providers: Array<IEhrProvider>
  recurring: Scalars['Boolean']['output']
  startUrl?: Maybe<Scalars['String']['output']>
  states: Array<IHealthPortalEhrAppointmentState>
  title?: Maybe<Scalars['String']['output']>
  unauthenticatedIcsLink?: Maybe<Scalars['String']['output']>
}

export type IHealthPortalEhrAppointmentAttendance = {
  __typename?: 'HealthPortalEhrAppointmentAttendance'
  agenda?: Maybe<Scalars['String']['output']>
  chargeKind: EhrAppointmentAttendanceChargeKind
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  insurancePolicy?: Maybe<IInsurancePolicy>
  invoice?: Maybe<IInvoice>
  paidFeeInvoice?: Maybe<IInvoice>
  paymentIntent?: Maybe<IHealthPortalBillingPaymentIntent>
  state: EhrAppointmentAttendanceState
  user: IUser
}

export type IHealthPortalEhrAppointmentState = {
  __typename?: 'HealthPortalEhrAppointmentState'
  appointmentId: Scalars['ID']['output']
  changedByGetHealthieId?: Maybe<Scalars['Int']['output']>
  changedByHealthieUser?: Maybe<IUser>
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: EhrAppointmentStateKind
  reason: EhrAppointmentReason
}

export enum HealthPortalFeature {
  ActionGoals = 'action_goals',
  ActionGoalsManagement = 'action_goals_management',
  AdminPanelManageNutritionistAssignment = 'admin_panel_manage_nutritionist_assignment',
  AdminPanelMembers = 'admin_panel_members',
  AdminPanelResetVideoChatAssignment = 'admin_panel_reset_video_chat_assignment',
  AdminPanelViewNutritionistAssignment = 'admin_panel_view_nutritionist_assignment',
  AdminPanelViewNutritionistNotifications = 'admin_panel_view_nutritionist_notifications',
  AuthorizationManagement = 'authorization_management',
  BillingDashboard = 'billing_dashboard',
  Chat = 'chat',
  ChatManagement = 'chat_management',
  ChatToggleCoachingKind = 'chat_toggle_coaching_kind',
  ChatToggleCoachingKindBypass = 'chat_toggle_coaching_kind_bypass',
  ChatbotAssistant = 'chatbot_assistant',
  ChatbotManageKnowledgeBase = 'chatbot_manage_knowledge_base',
  ChatbotMessageReports = 'chatbot_message_reports',
  ChatbotUserHistory = 'chatbot_user_history',
  ChatbotViewKnowledgeBase = 'chatbot_view_knowledge_base',
  CoachAvailability = 'coach_availability',
  CoachesBillingDashboard = 'coaches_billing_dashboard',
  CoachesBillingDetails = 'coaches_billing_details',
  CoachesBillingReviewOwnItems = 'coaches_billing_review_own_items',
  DexcomConnectionsViewAccountData = 'dexcom_connections_view_account_data',
  EditHealthTeamStructure = 'edit_health_team_structure',
  Files = 'files',
  Financials = 'financials',
  Formulas = 'formulas',
  HealthDataReport = 'health_data_report',
  HealthMetrics = 'health_metrics',
  HealthMetricsManagement = 'health_metrics_management',
  History = 'history',
  Home = 'home',
  HomeCallScheduling = 'home_call_scheduling',
  Insights = 'insights',
  MembersManagement = 'members_management',
  MembersManagementNutritionistSelection = 'members_management_nutritionist_selection',
  NutritionistHome = 'nutritionist_home',
  NutritionistHomeImpersonate = 'nutritionist_home_impersonate',
  OrganizationMembers = 'organization_members',
  Questionnaire = 'questionnaire',
  SensorsReplacementRequests = 'sensors_replacement_requests',
  ShipmentsManagement = 'shipments_management',
  ShipmentsViewUser = 'shipments_view_user',
  SupportAccountRequests = 'support_account_requests',
  SupportAccountRequestsCreate = 'support_account_requests_create',
  SupportAccountRequestsProcessCancelSubscriptionAtCommitmentEnd = 'support_account_requests_process_cancel_subscription_at_commitment_end',
  SupportAccountRequestsProcessCancelSubscriptionAtPeriodEnd = 'support_account_requests_process_cancel_subscription_at_period_end',
  SupportAccountRequestsProcessCancelSubscriptionImmediately = 'support_account_requests_process_cancel_subscription_immediately',
  SupportAccountRequestsProcessChangeSubscriptionBillingCycle = 'support_account_requests_process_change_subscription_billing_cycle',
  SupportAccountRequestsProcessCredit = 'support_account_requests_process_credit',
  SupportAccountRequestsProcessDeleteDuplicateAccount = 'support_account_requests_process_delete_duplicate_account',
  SupportAccountRequestsProcessGrantFreeVideoCall = 'support_account_requests_process_grant_free_video_call',
  SupportAccountRequestsProcessMiscRequest = 'support_account_requests_process_misc_request',
  SupportAccountRequestsProcessOneOffAddon = 'support_account_requests_process_one_off_addon',
  SupportAccountRequestsProcessPauseSubscription = 'support_account_requests_process_pause_subscription',
  SupportAccountRequestsProcessRefund = 'support_account_requests_process_refund',
  SupportAccountRequestsProcessUncancelSubscription = 'support_account_requests_process_uncancel_subscription',
  SupportAccountRequestsProcessUnpauseSubscription = 'support_account_requests_process_unpause_subscription',
  SupportAccountRequestsProcessUpdateSubscription = 'support_account_requests_process_update_subscription',
  SupportAccountRequestsReviewCancelSubscriptionAtCommitmentEnd = 'support_account_requests_review_cancel_subscription_at_commitment_end',
  SupportAccountRequestsReviewCancelSubscriptionAtPeriodEnd = 'support_account_requests_review_cancel_subscription_at_period_end',
  SupportAccountRequestsReviewCancelSubscriptionImmediately = 'support_account_requests_review_cancel_subscription_immediately',
  SupportAccountRequestsReviewChangeSubscriptionBillingCycle = 'support_account_requests_review_change_subscription_billing_cycle',
  SupportAccountRequestsReviewCredit = 'support_account_requests_review_credit',
  SupportAccountRequestsReviewDeleteDuplicateAccount = 'support_account_requests_review_delete_duplicate_account',
  SupportAccountRequestsReviewMiscRequest = 'support_account_requests_review_misc_request',
  SupportAccountRequestsReviewOneOffAddon = 'support_account_requests_review_one_off_addon',
  SupportAccountRequestsReviewPauseSubscription = 'support_account_requests_review_pause_subscription',
  SupportAccountRequestsReviewRefund = 'support_account_requests_review_refund',
  SupportAccountRequestsReviewUncancelSubscription = 'support_account_requests_review_uncancel_subscription',
  SupportAccountRequestsReviewUnpauseSubscription = 'support_account_requests_review_unpause_subscription',
  SupportAccountRequestsReviewUpdateSubscription = 'support_account_requests_review_update_subscription',
  SupportEditTickets = 'support_edit_tickets',
  SupportResetRescheduleFreePassUsed = 'support_reset_reschedule_free_pass_used',
  SupportTickets = 'support_tickets',
  SupportedSensorManagement = 'supported_sensor_management',
  SurveysManagement = 'surveys_management',
  UsersChangeEmail = 'users_change_email',
  UsersEditAddress = 'users_edit_address',
  UsersEditCoachProfile = 'users_edit_coach_profile',
  UsersEditFulfillmentConfiguration = 'users_edit_fulfillment_configuration',
  UsersEditOrganization = 'users_edit_organization',
  UsersEditOwnCoachProfile = 'users_edit_own_coach_profile',
  UsersEditProfile = 'users_edit_profile',
  UsersEditSettings = 'users_edit_settings',
  UsersManageUiStates = 'users_manage_ui_states',
  UsersViewFulfillmentConfiguration = 'users_view_fulfillment_configuration',
  UsersViewProfile = 'users_view_profile',
  UsersViewSettings = 'users_view_settings',
  UsersViewUiStates = 'users_view_ui_states',
  ViewAppointments = 'view_appointments',
  ViewHealthTeamStructure = 'view_health_team_structure',
  ViewInsuranceStatus = 'view_insurance_status'
}

export type IHealthPortalFeatureCollection = {
  __typename?: 'HealthPortalFeatureCollection'
  features: Array<FeatureGrant>
}

export type IHealthPortalNotification = {
  __typename?: 'HealthPortalNotification'
  /** @deprecated Use details field instead */
  actionDetails?: Maybe<Scalars['String']['output']>
  actionTitle?: Maybe<Scalars['String']['output']>
  admin?: Maybe<IUser>
  chatConversation?: Maybe<IChatConversation>
  coachAssignment?: Maybe<ICoachAssignment>
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  details?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  kind: HealthPortalNotificationKind
  requiresAction: Scalars['Boolean']['output']
  supportTicket?: Maybe<ITicket>
}

export type IHealthPortalNotificationCollection = {
  __typename?: 'HealthPortalNotificationCollection'
  healthPortalNotifications: Array<IHealthPortalNotification>
}

export enum HealthPortalNotificationKind {
  AnnualMembership = 'annual_membership',
  AutomaticInitialSent = 'automatic_initial_sent',
  Canceled = 'canceled',
  CoachChange = 'coach_change',
  CoachEndDateChanged = 'coach_end_date_changed',
  CoachingProgram = 'coaching_program',
  DietitianMenuAssigned = 'dietitian_menu_assigned',
  Fixed_8Weeks = 'fixed_8_weeks',
  HealthDataReportGenerated = 'health_data_report_generated',
  InsuranceConfirmed = 'insurance_confirmed',
  InsuranceConfirmedWithPatientResponsibility = 'insurance_confirmed_with_patient_responsibility',
  InsuranceRejected = 'insurance_rejected',
  MemberSwitched = 'member_switched',
  MemberSwitchedAway = 'member_switched_away',
  MidpointPulseSubmitted = 'midpoint_pulse_submitted',
  MonthlyWrapUpSent = 'monthly_wrap_up_sent',
  NewComplimentaryAddOn = 'new_complimentary_add_on',
  NewMessageInInactiveConversation = 'new_message_in_inactive_conversation',
  NewPaidAddOn = 'new_paid_add_on',
  Paused = 'paused',
  PremiumInitialSent = 'premium_initial_sent',
  Recurring_12Weeks = 'recurring_12_weeks',
  RecurringAppointmentsMissingAvailability = 'recurring_appointments_missing_availability',
  Resumed = 'resumed',
  RetentionTest = 'retention_test',
  SupportConversationAssigned = 'support_conversation_assigned',
  TicketCommentCreated = 'ticket_comment_created',
  TicketCommentSubscribed = 'ticket_comment_subscribed',
  TicketStatusChanged = 'ticket_status_changed',
  UpcomingAppointmentsCanceledPreauthorizationFailed = 'upcoming_appointments_canceled_preauthorization_failed',
  VideoCallFeedbackSubmitted = 'video_call_feedback_submitted',
  VideoCallScheduled = 'video_call_scheduled'
}

export type IHealthPortalNotificationsSort = {
  direction: SortDirection
  field: HealthPortalNotificationsSortField
}

export enum HealthPortalNotificationsSortField {
  CreatedAt = 'created_at'
}

export type IHealthSettings = {
  __typename?: 'HealthSettings'
  dashboardGraphOptions: Array<IStringSelect>
  fastingEnd: Scalars['Int']['output']
  fastingStart: Scalars['Int']['output']
  glucoseHighOptions: Array<INumericalSelect>
  glucoseLowOptions: Array<INumericalSelect>
  glucoseSourceOptions: Array<IStringSelect>
  glucoseThresholdPresets: Array<IGlucoseThresholdPreset>
  ketoneHighOptions: Array<INumericalSelect>
  ketoneLowOptions: Array<INumericalSelect>
  macroGoalSettings: IMacroGoalSettings
  trackingModeOptions: Array<IStringSelect>
  unitSystemOptions: Array<IStringSelect>
}

export type IHistory = {
  __typename?: 'History'
  filters: IHistoryFilters
}

export type IHistoryFilters = {
  __typename?: 'HistoryFilters'
  order: Array<Scalars['String']['output']>
  orderBy: Array<Scalars['String']['output']>
  types: Array<IKeyValuePairStringArray>
}

export type IHoursInterval = {
  __typename?: 'HoursInterval'
  glucoseCheckOptions: Array<INumericalSelect>
}

export type IIconDef = {
  __typename?: 'IconDef'
  name: Scalars['String']['output']
  pack: Scalars['String']['output']
}

export type IIngredient = {
  __typename?: 'Ingredient'
  calories: Scalars['Float']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  nutrition: Array<IKeyValuePairFloat>
  servingAmount: Scalars['Float']['output']
  servingUnits: Scalars['String']['output']
  thirdPartyIngredientId?: Maybe<Scalars['String']['output']>
  thirdPartyIngredientSource?: Maybe<IngredientSource>
}

export type IIngredientData = {
  calories: Scalars['Float']['input']
  description: Scalars['String']['input']
  imageUrl?: InputMaybe<Scalars['String']['input']>
  ingredientId?: InputMaybe<Scalars['ID']['input']>
  mealId?: InputMaybe<Scalars['ID']['input']>
  nutrition: Array<IKeyValueFloat>
  servingAmount: Scalars['Float']['input']
  servingUnits: Scalars['String']['input']
  thirdPartyIngredientId?: InputMaybe<Scalars['String']['input']>
  thirdPartyIngredientSource?: InputMaybe<IngredientSource>
}

export enum IngredientSource {
  BiteAi = 'biteAI',
  Myfitnesspal = 'myfitnesspal',
  Nutritionix = 'nutritionix'
}

export type IInlineAlert = {
  __typename?: 'InlineAlert'
  message: Scalars['String']['output']
  type: UiInlineAlert
}

export type IInsuranceKinds = {
  __typename?: 'InsuranceKinds'
  kindDefs: Array<IUserInsurancePolicyKindDef>
}

export type IInsurancePolicy = {
  __typename?: 'InsurancePolicy'
  declined: Scalars['Boolean']['output']
  eligible: Scalars['Boolean']['output']
  hasUnitsLeft: Scalars['Boolean']['output']
  hasUnlimitedCalls: Scalars['Boolean']['output']
  hasUnusedCalls: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  inReview: Scalars['Boolean']['output']
  initialAppointmentKind?: Maybe<IClientConfigEhrAppointmentKind>
  last: Scalars['Boolean']['output']
  lastState?: Maybe<IInsurancePolicyState>
  states?: Maybe<Array<IInsurancePolicyState>>
  unitsAuthorized?: Maybe<Scalars['Int']['output']>
  unitsLeft?: Maybe<Scalars['Int']['output']>
  unitsOccurred?: Maybe<Scalars['Int']['output']>
  unitsUsed?: Maybe<Scalars['Int']['output']>
}

export type IInsurancePolicyState = {
  __typename?: 'InsurancePolicyState'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: UserInsurancePolicyStateKind
  reason?: Maybe<Scalars['String']['output']>
}

export type IIntegrationUser = {
  __typename?: 'IntegrationUser'
  accessToken: Scalars['String']['output']
  accessTokenExpirationDate: Scalars['ISO8601DateTime']['output']
  idToken: Scalars['String']['output']
  refreshToken: Scalars['String']['output']
}

export type IIntegrationUserSetting = {
  accessToken: Scalars['String']['input']
  accessTokenExpirationDate: Scalars['ISO8601DateTime']['input']
  idToken?: InputMaybe<Scalars['String']['input']>
  refreshToken: Scalars['String']['input']
}

export type IIntegrationsSync = {
  __typename?: 'IntegrationsSync'
  dexcomUser?: Maybe<IIntegrationUser>
  ketoMojoUser?: Maybe<IIntegrationUser>
  lastSyncedDexcom?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastSyncedHealth?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastSyncedKetoMojo?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type IIntegrationsSyncSettings = {
  dexcomUser?: InputMaybe<IIntegrationUserSetting>
  ketoMojoUser?: InputMaybe<IIntegrationUserSetting>
  lastSyncedDexcom?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  lastSyncedHealth?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  lastSyncedKetoMojo?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type IInterval = {
  __typename?: 'Interval'
  description: Scalars['String']['output']
  key: BillingProductInterval
  monthsInOneBillingCycle?: Maybe<Scalars['Int']['output']>
  prefix: Scalars['String']['output']
  suffix: Scalars['String']['output']
}

export type IIntroScreen = {
  __typename?: 'IntroScreen'
  backgroundImageUrl?: Maybe<Scalars['String']['output']>
  footnote?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  icon?: Maybe<UiIcon>
  imageUrl?: Maybe<Scalars['String']['output']>
  inlineAlert?: Maybe<IInlineAlert>
  /** @deprecated use intro_markdown */
  intro?: Maybe<Scalars['String']['output']>
  introMarkdown?: Maybe<Scalars['String']['output']>
}

export type IInvoice = {
  __typename?: 'Invoice'
  created: Scalars['ISO8601DateTime']['output']
  downloadUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  latestCharge?: Maybe<ICharge>
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  periodStart: Scalars['ISO8601DateTime']['output']
  /** @deprecated not used anymore */
  primaryInvoiceLine?: Maybe<IInvoiceLine>
  primaryProduct: IProductMin
  receiptNumber?: Maybe<Scalars['String']['output']>
  status: InvoiceStatus
  stripeId: Scalars['String']['output']
  /** @deprecated use status enum field */
  stripeStatus: Scalars['String']['output']
  subscription?: Maybe<ISubscription>
  total?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  user: IUser
}

export type IInvoiceCollection = {
  __typename?: 'InvoiceCollection'
  invoices: Array<IInvoice>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IInvoiceDynamicFilter = {
  field: InvoiceDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum InvoiceDynamicFilterField {
  Created = 'created',
  DownloadUrl = 'download_url',
  PaidAt = 'paid_at',
  ReceiptNumber = 'receipt_number',
  StripeId = 'stripe_id',
  SubscriptionStripeId = 'subscription_stripe_id',
  Total = 'total',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name',
  UserId = 'user_id',
  UserStripeId = 'user_stripe_id'
}

export type IInvoiceDynamicFilterItem = {
  items: Array<IInvoiceDynamicFilter>
  operator: DynamicFilterOperator
}

export type IInvoiceLine = {
  __typename?: 'InvoiceLine'
  id: Scalars['ID']['output']
  plan?: Maybe<IPlan>
}

export type IInvoiceOrder = {
  __typename?: 'InvoiceOrder'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  invoice: IInvoice
  lastProcessingAttemptAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  orderId?: Maybe<Scalars['Int']['output']>
  processedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  product: Scalars['String']['output']
  productType: Scalars['String']['output']
  quantity: Scalars['Int']['output']
  shippingApprovalKind: UserApprovalRequestKind
  state: InvoiceOrderState
  stateReason?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  user: IUser
}

export type IInvoiceOrderDynamicFilter = {
  field: InvoiceOrderDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum InvoiceOrderDynamicFilterField {
  CreatedAt = 'created_at',
  Id = 'id',
  InvoiceId = 'invoice_id',
  InvoicePaidAt = 'invoice_paid_at',
  InvoicePeriodStart = 'invoice_period_start',
  InvoiceStripeId = 'invoice_stripe_id',
  LastProcessingAttemptAt = 'last_processing_attempt_at',
  OrderId = 'order_id',
  ProcessedAt = 'processed_at',
  State = 'state',
  StateReason = 'state_reason',
  UpdatedAt = 'updated_at',
  UserEmail = 'user_email'
}

export type IInvoiceOrderDynamicFilterItem = {
  items: Array<IInvoiceOrderDynamicFilter>
  operator: DynamicFilterOperator
}

export type IInvoiceOrderSort = {
  direction: SortDirection
  field: InvoiceOrderSortField
}

export enum InvoiceOrderSortField {
  CreatedAt = 'created_at',
  Id = 'id',
  InvoiceId = 'invoice_id',
  InvoicePaidAt = 'invoice_paid_at',
  InvoicePeriodStart = 'invoice_period_start',
  InvoiceStripeId = 'invoice_stripe_id',
  LastProcessingAttemptAt = 'last_processing_attempt_at',
  OrderId = 'order_id',
  ProcessedAt = 'processed_at',
  State = 'state',
  StateReason = 'state_reason',
  UpdatedAt = 'updated_at',
  UserEmail = 'user_email'
}

export enum InvoiceOrderState {
  Flagged = 'flagged',
  Ignored = 'ignored',
  Pending = 'pending',
  Processed = 'processed'
}

export type IInvoiceSort = {
  direction: SortDirection
  field: InvoiceSortField
}

export enum InvoiceSortField {
  Created = 'created',
  DownloadUrl = 'download_url',
  PaidAt = 'paid_at',
  ReceiptNumber = 'receipt_number',
  StripeId = 'stripe_id',
  SubscriptionStripeId = 'subscription_stripe_id',
  Total = 'total',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name',
  UserStripeId = 'user_stripe_id'
}

export enum InvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export type IJournalConfig = {
  __typename?: 'JournalConfig'
  measurementTypes: Array<IMeasurementType>
  range: IJournalRange
}

export type IJournalEntry = {
  __typename?: 'JournalEntry'
  body: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: Scalars['String']['output']
  creatorId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  kind: NoteKind
  measurements?: Maybe<Array<IMeasurement>>
  occurredAt: Scalars['ISO8601DateTime']['output']
  score?: Maybe<Scalars['Float']['output']>
  title: Scalars['String']['output']
}

export type IJournalRange = {
  __typename?: 'JournalRange'
  max: Scalars['Int']['output']
  min: Scalars['Int']['output']
}

export type IKeyValueFloat = {
  key: Scalars['String']['input']
  value: Scalars['Float']['input']
}

export type IKeyValuePairFloat = {
  __typename?: 'KeyValuePairFloat'
  key: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type IKeyValuePairString = {
  __typename?: 'KeyValuePairString'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type IKeyValuePairStringArray = {
  __typename?: 'KeyValuePairStringArray'
  key: Scalars['String']['output']
  value: Array<Scalars['String']['output']>
}

export type IKeyValueStringArray = {
  key: Scalars['String']['input']
  value: Array<Scalars['String']['input']>
}

export type IKnowledgeAnswer = {
  __typename?: 'KnowledgeAnswer'
  id: Scalars['ID']['output']
  knowledgeQuestions: Array<IKnowledgeQuestion>
  knowledgeSources: Array<IKnowledgeSource>
  title: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type IKnowledgeAnswerCollection = {
  __typename?: 'KnowledgeAnswerCollection'
  knowledgeAnswers: Array<IKnowledgeAnswer>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IKnowledgeAnswerDynamicFilter = {
  field: KnowledgeAnswerDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum KnowledgeAnswerDynamicFilterField {
  Id = 'id',
  QuestionsValue = 'questions_value',
  SourcesTitle = 'sources_title',
  SourcesUrl = 'sources_url',
  Title = 'title',
  Value = 'value'
}

export type IKnowledgeAnswerDynamicFilterItem = {
  items: Array<IKnowledgeAnswerDynamicFilter>
  operator: DynamicFilterOperator
}

export type IKnowledgeAnswerSort = {
  direction: SortDirection
  field: KnowledgeAnswerSortField
}

export enum KnowledgeAnswerSortField {
  Id = 'id',
  Title = 'title',
  Value = 'value'
}

export type IKnowledgeQuestion = {
  __typename?: 'KnowledgeQuestion'
  id: Scalars['ID']['output']
  knowledgeAnswers: Array<IKnowledgeAnswer>
  knowledgeTags: Array<IKnowledgeTag>
  value: Scalars['String']['output']
}

export type IKnowledgeQuestionCollection = {
  __typename?: 'KnowledgeQuestionCollection'
  knowledgeQuestions: Array<IKnowledgeQuestion>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IKnowledgeQuestionDynamicFilter = {
  field: KnowledgeQuestionDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum KnowledgeQuestionDynamicFilterField {
  AnswersSourcesTitle = 'answers_sources_title',
  AnswersSourcesUrl = 'answers_sources_url',
  AnswersTitle = 'answers_title',
  Id = 'id',
  TagsId = 'tags_id',
  TagsValue = 'tags_value',
  Value = 'value'
}

export type IKnowledgeQuestionDynamicFilterItem = {
  items: Array<IKnowledgeQuestionDynamicFilter>
  operator: DynamicFilterOperator
}

export type IKnowledgeQuestionSort = {
  direction: SortDirection
  field: KnowledgeQuestionSortField
}

export enum KnowledgeQuestionSortField {
  Id = 'id',
  Value = 'value'
}

export type IKnowledgeSource = {
  __typename?: 'KnowledgeSource'
  id: Scalars['ID']['output']
  knowledgeAnswers: Array<IKnowledgeAnswer>
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type IKnowledgeSourceCollection = {
  __typename?: 'KnowledgeSourceCollection'
  knowledgeSources: Array<IKnowledgeSource>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IKnowledgeSourceDynamicFilter = {
  field: KnowledgeSourceDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum KnowledgeSourceDynamicFilterField {
  AnswersQuestionsValue = 'answers_questions_value',
  AnswersTitle = 'answers_title',
  Id = 'id',
  Title = 'title',
  Url = 'url'
}

export type IKnowledgeSourceDynamicFilterItem = {
  items: Array<IKnowledgeSourceDynamicFilter>
  operator: DynamicFilterOperator
}

export type IKnowledgeSourceSort = {
  direction: SortDirection
  field: KnowledgeSourceSortField
}

export enum KnowledgeSourceSortField {
  Id = 'id',
  Url = 'url'
}

export type IKnowledgeTag = {
  __typename?: 'KnowledgeTag'
  id: Scalars['ID']['output']
  value: Scalars['String']['output']
}

export type IKnowledgeTagCollection = {
  __typename?: 'KnowledgeTagCollection'
  knowledgeTags: Array<IKnowledgeTag>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IKnowledgeTagDynamicFilter = {
  field: KnowledgeTagDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum KnowledgeTagDynamicFilterField {
  Id = 'id',
  Value = 'value'
}

export type IKnowledgeTagDynamicFilterItem = {
  items: Array<IKnowledgeTagDynamicFilter>
  operator: DynamicFilterOperator
}

export type IKnowledgeTagSort = {
  direction: SortDirection
  field: KnowledgeTagSortField
}

export enum KnowledgeTagSortField {
  Id = 'id',
  Value = 'value'
}

export type ILabResultsConfig = {
  __typename?: 'LabResultsConfig'
  fileUploadLimitMb: Scalars['Int']['output']
}

export type ILesson = {
  __typename?: 'Lesson'
  contentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  position?: Maybe<Scalars['Int']['output']>
  progress?: Maybe<IProgress>
}

export type ILink = {
  __typename?: 'Link'
  deepLink?: Maybe<Scalars['String']['output']>
  text: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type IListAmazonOrders = {
  __typename?: 'ListAmazonOrders'
  orders: Array<IAmazonOrder>
  totalCount: Scalars['Int']['output']
}

export type IListChatbotMessageReports = {
  __typename?: 'ListChatbotMessageReports'
  pageCount?: Maybe<Scalars['Int']['output']>
  reports: Array<IChatbotMessageReport>
  totalCount: Scalars['Int']['output']
}

export type IListConversations = {
  __typename?: 'ListConversations'
  conversations: Array<IConversation>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IListFiles = {
  __typename?: 'ListFiles'
  files: Array<IFile>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IListFilters = {
  __typename?: 'ListFilters'
  order: Array<Scalars['String']['output']>
  orderBy: Array<Scalars['String']['output']>
  types: Array<Scalars['String']['output']>
}

export type IListHealthDataReports = {
  __typename?: 'ListHealthDataReports'
  pageCount?: Maybe<Scalars['Int']['output']>
  reports: Array<IHealthDataReport>
  totalCount: Scalars['Int']['output']
}

export type IListInvoiceOrders = {
  __typename?: 'ListInvoiceOrders'
  invoiceOrders: Array<IInvoiceOrder>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IListNotes = {
  __typename?: 'ListNotes'
  notes: Array<INote>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type IListOrders = {
  __typename?: 'ListOrders'
  orders: Array<IOrder>
  totalRecords: Scalars['Int']['output']
}

export type IListShipments = {
  __typename?: 'ListShipments'
  shipments: Array<IShipment>
  totalRecords: Scalars['Int']['output']
}

export type IMacro = {
  __typename?: 'Macro'
  indent: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export type IMacroGoalSettings = {
  __typename?: 'MacroGoalSettings'
  caloriesMax: Scalars['Int']['output']
  carbsMax: Scalars['Int']['output']
  fatMax: Scalars['Int']['output']
  proteinMax: Scalars['Int']['output']
}

export type IMacroGoals = {
  __typename?: 'MacroGoals'
  calories: Scalars['Int']['output']
  carbs: Scalars['Int']['output']
  fat: Scalars['Int']['output']
  netCarbs?: Maybe<Scalars['Int']['output']>
  protein: Scalars['Int']['output']
}

export type IMacroGoalsDaily = {
  calories?: InputMaybe<Scalars['Int']['input']>
  carbs?: InputMaybe<Scalars['Int']['input']>
  fat?: InputMaybe<Scalars['Int']['input']>
  netCarbs?: InputMaybe<Scalars['Int']['input']>
  protein?: InputMaybe<Scalars['Int']['input']>
}

export type IMeal = {
  __typename?: 'Meal'
  avatar?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: IUser
  description: Scalars['String']['output']
  favorite: Scalars['Boolean']['output']
  generatedOccurredAt?: Maybe<Scalars['Boolean']['output']>
  glucose: IEntryGlucose
  id: Scalars['ID']['output']
  ingredients: Array<IIngredient>
  kind: MealKind
  nutrition: Array<IKeyValuePairFloat>
  occurredAt: Scalars['ISO8601DateTime']['output']
  source: MealSource
  statistics: IEntryStatistics
  /** @deprecated use kind enum field */
  time?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  /** @deprecated use kind enum field */
  type: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum MealKind {
  Breakfast = 'breakfast',
  Dessert = 'dessert',
  Dinner = 'dinner',
  Drink = 'drink',
  Lunch = 'lunch',
  Snack = 'snack',
  Supplement = 'supplement',
  Unknown = 'unknown',
  UnknownDeprecated = 'unknown_deprecated'
}

export enum MealSource {
  Dexcom = 'dexcom',
  HealthPortal = 'health_portal',
  MobileApp = 'mobile_app',
  MyFitnessPal = 'my_fitness_pal'
}

export type IMeals = {
  __typename?: 'Meals'
  filters: IListFilters
}

export type IMeasurement = {
  __typename?: 'Measurement'
  createdAt: Scalars['ISO8601DateTime']['output']
  cumulative: Scalars['Boolean']['output']
  description: Scalars['String']['output']
  displayValue?: Maybe<Scalars['String']['output']>
  externalSource?: Maybe<Scalars['String']['output']>
  healthDataType: HealthDataMeasurementType
  id: Scalars['ID']['output']
  interpolated: Scalars['Boolean']['output']
  occurredAt: Scalars['ISO8601DateTime']['output']
  scan?: Maybe<IScan>
  timestamp: Scalars['ISO8601DateTime']['output']
  title: Scalars['String']['output']
  type: Scalars['String']['output']
  units: Scalars['String']['output']
  value?: Maybe<Scalars['Float']['output']>
  values?: Maybe<IMeasurementMultiValue>
}

export type IMeasurementCollection = {
  __typename?: 'MeasurementCollection'
  measurements: Array<IMeasurement>
}

export type IMeasurementConfig = {
  __typename?: 'MeasurementConfig'
  imperial: IMeasurementConfigUnit
  metric: IMeasurementConfigUnit
  name: Scalars['String']['output']
}

export type IMeasurementConfigUnit = {
  __typename?: 'MeasurementConfigUnit'
  maxThreshold?: Maybe<Scalars['Float']['output']>
  minThreshold?: Maybe<Scalars['Float']['output']>
  precision: Scalars['Int']['output']
  units: Scalars['String']['output']
}

export type IMeasurementFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>
  endHour?: InputMaybe<Scalars['Int']['input']>
  excludeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  graph?: InputMaybe<Scalars['String']['input']>
  includeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  order?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  scope?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  startHour?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<IKeyValueStringArray>>
}

export type IMeasurementMultiValue = IBloodPressureMeasurement | ISingleValueMeasurement

export type IMeasurementType = {
  __typename?: 'MeasurementType'
  reverse?: Maybe<Scalars['Boolean']['output']>
  type: Scalars['String']['output']
}

export type IMessage = {
  __typename?: 'Message'
  attachments: Array<IMessageAttachment>
  content: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  knowledgeQuestions: Array<IKnowledgeQuestion>
  updatedAt: Scalars['ISO8601DateTime']['output']
  userId: Scalars['ID']['output']
  userMessage?: Maybe<IMessage>
}

export type IMessageAttachment = {
  __typename?: 'MessageAttachment'
  downloadFileUrl: Scalars['String']['output']
  fileName: Scalars['String']['output']
  fileType: Scalars['String']['output']
  fileUrl: Scalars['String']['output']
  id: Scalars['ID']['output']
  userFileId: Scalars['ID']['output']
}

export type IMetricOption = {
  __typename?: 'MetricOption'
  description: Scalars['String']['output']
  imperial?: Maybe<IUnitOption>
  infoText?: Maybe<Scalars['String']['output']>
  kind: ActionGoalMetricKind
  metric?: Maybe<IUnitOption>
  statKey?: Maybe<Scalars['String']['output']>
  supportsMetricValue: Scalars['Boolean']['output']
  trendSection?: Maybe<Scalars['String']['output']>
  valuePrefix?: Maybe<Scalars['String']['output']>
}

export type IMiscRequestPayload = {
  requestDetails: Scalars['String']['input']
}

export type IMiscRequestResponsePayload = {
  __typename?: 'MiscRequestResponsePayload'
  requestDetails: Scalars['String']['output']
}

export enum MobileAppFeature {
  AccountDetailsEditName = 'account_details_edit_name',
  ActivateOwnSensor = 'activate_own_sensor',
  AdminAccess = 'admin_access',
  AdminImpersonate = 'admin_impersonate',
  BiosensorAccess = 'biosensor_access',
  DailyGlucoseScore = 'daily_glucose_score',
  DexcomG6ApiIntegration = 'dexcom_g6_api_integration',
  DexcomG7ApiIntegration = 'dexcom_g7_api_integration',
  DexcomSteloApiIntegration = 'dexcom_stelo_api_integration',
  GlucoseInsights = 'glucose_insights',
  GlucoseLastReadingList = 'glucose_last_reading_list',
  GlucosePatternsNotifications = 'glucose_patterns_notifications',
  HealthCoachingVideoCalls = 'health_coaching_video_calls',
  HomeInitialScreen = 'home_initial_screen',
  InsuranceCoveredVideoCalls = 'insurance_covered_video_calls',
  ViewGlucoseCharts = 'view_glucose_charts'
}

export type IMobileUserProperty = {
  __typename?: 'MobileUserProperty'
  id: Scalars['Int']['output']
  kind: UserPropertyKind
  userId: Scalars['ID']['output']
  value: Scalars['String']['output']
}

export type IMutationType = {
  __typename?: 'MutationType'
  addKnowledgeQuestionTag: IKnowledgeQuestion
  approveCoach: ICoachProfile
  assignAuthorizationPolicy: IUserAuthorizationPolicy
  backfillChatConversation: IChatConversation
  bulkCoachAssign: IBulkAssign
  bulkCreateCoachBillingInvoices: ISuccess
  bulkCreateFiles: IFileCollection
  bulkCreatePendingCoaches: IBulkCreatePendingCoaches
  bulkCreateShipments: IListShipments
  bulkExportUsersData: ISuccess
  bulkFollowCoachAssignments: ISuccess
  bulkSendScheduledMessage: ISuccess
  bulkShipOrders: IListOrders
  bulkUnfollowCoachAssignments: ISuccess
  bulkUpdateCoachProfiles: ICoachProfileCollection
  bulkUpdateHealthPortalNotifications: IHealthPortalNotificationCollection
  bulkUpdateShipments: IListShipments
  bulkUpdateUserProperties: IUserPropertiesCollection
  changeUserEmail: IUser
  /** @deprecated use submit_account_request instead */
  createAccountRequest: IAccountRequest
  createActionGoal: IActionGoal
  createChatConversationMessageTemplate: IChatConversationMessageTemplate
  createChatConversationNote: IChatConversationNote
  createChatToken: IToken
  createChatbotDelimiter: IDelimiter
  createCoachBillingInvoice: ICoachBillingInvoice
  createCoachBillingInvoiceItem: ICoachBillingInvoiceItem
  createCoachBillingInvoiceReview: ICoachBillingInvoiceReview
  createCoachSharedAsset: ICoachSharedAsset
  createDietitianSession: IDietitianSession
  createDirectUploads: IDirectUploadCollection
  createFilesFromDirectUploads: IFileCollection
  createHealthMetric: IHealthMetric
  createKnowledgeAnswer: IKnowledgeAnswer
  createKnowledgeQuestion: IKnowledgeQuestion
  createKnowledgeSource: IKnowledgeSource
  createKnowledgeTag: IKnowledgeTag
  /** @deprecated Use :upsert_note */
  createNote: INote
  createOrder: IOrder
  createReplacementRequest: IReplacementRequest
  createReplacementRequestInvoice: IReplacementRequest
  createShipment: IShipment
  createSyncRequest: ISuccess
  createTicket: ITicket
  createTicketComment: ITicketComment
  deactivateCoachProfile: ICoachProfile
  deleteActionGoal: IActionGoal
  deleteChatConversationMessageTemplate: ISuccess
  deleteCoachBillingInvoiceItem: ICoachBillingInvoiceItem
  deleteCoachSharedAsset: ICoachSharedAsset
  deleteEhrAppointmentRecurrence: ISuccess
  deleteFile: IFile
  deleteHealthMetric: ISuccess
  deleteKnowledgeAnswer: IKnowledgeAnswer
  deleteKnowledgeQuestion: IKnowledgeQuestion
  deleteKnowledgeSource: IKnowledgeSource
  deleteKnowledgeTag: IKnowledgeTag
  deleteMeal: IMeal
  deleteNote: INote
  deleteOrder: IOrder
  deleteReplacementRequest: IReplacementRequest
  deleteScan: IMeasurement
  deleteShipment: IShipment
  deleteTicket: ITicket
  deleteUserProperty: IUserProperty
  exportAccountRequestsData: ISuccess
  generateHealthDataReport: ISuccess
  grantGlucoseFeatureOverride: ISuccess
  linkKnowledgeAnswer: IKnowledgeAnswer
  linkKnowledgeQuestion: IKnowledgeQuestion
  notifyFeatureFeedback: ISuccess
  promoteToCoachChatConversation: ISuccess
  removeKnowledgeQuestionTag: IKnowledgeQuestion
  replaceActionGoal: IReplaceActionGoal
  resendMissingPrescriptionsShipments: IListShipments
  resendShipment: IShipment
  resetVideoChatAssignment: ISuccess
  respondToHealthPortalNotification: ISuccess
  restartSurveyLink: ISurveyLink
  runDexcomConnectionStatusCheck: IDexcomConnectionStatusCheckResult
  runFormula: IRunActionPayload
  saveHealthDataReport: ISuccess
  sendChatConversationMessage: ISuccess
  sendCoachBackToPendingRegister: ICoachProfile
  sendEhrAppointmentSmsReminder: ISuccess
  sendMfaSmsCode: ISendMfaSmsCode
  setPrimaryGoalMetrics: Array<IGoalMetric>
  signInThirdPartyUser: IUserAuth
  signInUser: IUserAuth
  signOutUser: ISuccess
  /** @deprecated use sign_out_user instead */
  signoutUser: ISuccess
  submitAccountRequest: IAccountRequest
  submitCoachProfile: ISubmitCoachProfileResult
  unassignAuthorizationPolicy: IUserAuthorizationPolicy
  unlinkKnowledgeAnswer: IKnowledgeAnswer
  unlinkKnowledgeQuestion: IKnowledgeQuestion
  updateAccountRequest: IAccountRequest
  updateAddress: IAddress
  updateChatConversation: IChatConversation
  updateChatConversationMessageTemplate: IChatConversationMessageTemplate
  updateChatConversationNote: IChatConversationNote
  updateChatConversationState: IChatConversation
  updateChatbotMessageReport: IChatbotMessageReport
  updateCoachBillingInvoiceItem: ICoachBillingInvoiceItem
  updateCoachBillingRates: ICoachBillingRates
  updateCoachConversationScheduledMessage: ICoachConversationScheduledMessage
  updateCoachSharedAsset: ICoachSharedAsset
  updateEhrAppointment: ISuccess
  updateGoalMetric: IGoalMetric
  updateHealthMetric: IHealthMetric
  updateInvoiceOrder: IInvoiceOrder
  updateKnowledgeAnswer: IKnowledgeAnswer
  updateKnowledgeQuestion: IKnowledgeQuestion
  updateKnowledgeSource: IKnowledgeSource
  updateKnowledgeTag: IKnowledgeTag
  updateOrder: IOrder
  updateReplacementRequest: IReplacementRequest
  updateSensor: ISensor
  updateSettings: IUserSettings
  updateShipment: IShipment
  updateSupportedSensor: ISuccess
  updateTicket: ITicket
  updateUser: IUser
  updateUserOrganization: IUser
  updateUserProperty: IUserProperty
  uploadHealthDataReportPdf: ISuccess
  upsertCoachProfile: ICoachProfile
  upsertCoachingKindAssignment: IUser
  upsertMeal: IMeal
  upsertNote: INote
  upsertPrimaryGoal: IGoal
  upsertUiState: IPrivateUiState
  validateCoachInvites: IValidateCoachInvites
  verifyMfaSmsCode: IVerifyMfaSmsCodeActionPayload
}

export type IMutationTypeAddKnowledgeQuestionTagArgs = {
  id: Scalars['ID']['input']
  knowledgeTagId: Scalars['ID']['input']
}

export type IMutationTypeApproveCoachArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeAssignAuthorizationPolicyArgs = {
  kind: UserAuthorizationPolicyKind
  userId: Scalars['ID']['input']
}

export type IMutationTypeBackfillChatConversationArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeBulkCoachAssignArgs = {
  coachAssignments?: InputMaybe<Array<ICoachAssign>>
}

export type IMutationTypeBulkCreateCoachBillingInvoicesArgs = {
  coachIds?: InputMaybe<Array<Scalars['ID']['input']>>
  periodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>
  periodStart?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export type IMutationTypeBulkCreateFilesArgs = {
  urls?: InputMaybe<Array<Scalars['String']['input']>>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeBulkCreatePendingCoachesArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>
}

export type IMutationTypeBulkCreateShipmentsArgs = {
  provider?: InputMaybe<ShippingOrderProvider>
  shipmentsAttributes?: InputMaybe<Array<IBulkCreateShipment>>
}

export type IMutationTypeBulkExportUsersDataArgs = {
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type IMutationTypeBulkFollowCoachAssignmentsArgs = {
  coachId: Scalars['ID']['input']
}

export type IMutationTypeBulkSendScheduledMessageArgs = {
  coachAssignmentIds?: InputMaybe<Array<Scalars['ID']['input']>>
  kind?: InputMaybe<ChatConversationMessageTemplateKind>
}

export type IMutationTypeBulkShipOrdersArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>
  provider?: InputMaybe<ShippingOrderProvider>
}

export type IMutationTypeBulkUnfollowCoachAssignmentsArgs = {
  coachId: Scalars['ID']['input']
}

export type IMutationTypeBulkUpdateCoachProfilesArgs = {
  coachProfiles?: InputMaybe<Array<IUpdateCoachProfile>>
}

export type IMutationTypeBulkUpdateHealthPortalNotificationsArgs = {
  healthPortalNotifications?: InputMaybe<Array<IUpdateHealthPortalNotification>>
}

export type IMutationTypeBulkUpdateShipmentsArgs = {
  lotNumber?: InputMaybe<Scalars['String']['input']>
  shipmentsIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type IMutationTypeBulkUpdateUserPropertiesArgs = {
  kind?: InputMaybe<UserPropertyKind>
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>
  value?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeChangeUserEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeCreateAccountRequestArgs = {
  kind?: InputMaybe<OpsAccountRequestKind>
  notes?: InputMaybe<Scalars['String']['input']>
  payload?: InputMaybe<IAccountRequestPayloadUnionSubmissionType>
  priority?: InputMaybe<OpsAccountRequestPriority>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeCreateActionGoalArgs = {
  goalText?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<ActionGoalKind>
  metricKind?: InputMaybe<ActionGoalMetricKind>
  metricValue?: InputMaybe<Scalars['Float']['input']>
  numberDays?: InputMaybe<Scalars['Int']['input']>
}

export type IMutationTypeCreateChatConversationMessageTemplateArgs = {
  name?: InputMaybe<Scalars['String']['input']>
  private?: InputMaybe<Scalars['Boolean']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeCreateChatConversationNoteArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  conversationId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeCreateChatTokenArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeCreateChatbotDelimiterArgs = {
  providerConversationId: Scalars['ID']['input']
}

export type IMutationTypeCreateCoachBillingInvoiceArgs = {
  coachId?: InputMaybe<Scalars['ID']['input']>
  periodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>
  periodStart?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export type IMutationTypeCreateCoachBillingInvoiceItemArgs = {
  coachId?: InputMaybe<Scalars['ID']['input']>
  date?: InputMaybe<Scalars['ISO8601Date']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<CoachesBillingInvoiceItemKind>
  quantity?: InputMaybe<Scalars['Float']['input']>
  rate?: InputMaybe<Scalars['Float']['input']>
}

export type IMutationTypeCreateCoachBillingInvoiceReviewArgs = {
  coachId?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<CoachesBillingInvoiceReviewKind>
  periodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>
  periodStart?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export type IMutationTypeCreateCoachSharedAssetArgs = {
  category: CoachesSharedAssetCategory
  description?: InputMaybe<Scalars['String']['input']>
  signedId: Scalars['String']['input']
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  title: Scalars['String']['input']
  visibility?: InputMaybe<CoachesSharedAssetVisibility>
}

export type IMutationTypeCreateDietitianSessionArgs = {
  endedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  startedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeCreateDirectUploadsArgs = {
  files?: InputMaybe<Array<IFileMetadata>>
  reason?: InputMaybe<DirectUploadReason>
}

export type IMutationTypeCreateFilesFromDirectUploadsArgs = {
  signedIds?: InputMaybe<Array<Scalars['String']['input']>>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeCreateHealthMetricArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>
  kind?: InputMaybe<HealthDataMetricBiomarker>
  value?: InputMaybe<Scalars['Float']['input']>
}

export type IMutationTypeCreateKnowledgeAnswerArgs = {
  title: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type IMutationTypeCreateKnowledgeQuestionArgs = {
  value: Scalars['String']['input']
}

export type IMutationTypeCreateKnowledgeSourceArgs = {
  title: Scalars['String']['input']
  url: Scalars['String']['input']
}

export type IMutationTypeCreateKnowledgeTagArgs = {
  value: Scalars['String']['input']
}

export type IMutationTypeCreateNoteArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  pinned?: InputMaybe<Scalars['Boolean']['input']>
  time?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeCreateOrderArgs = {
  invoiceOrderId?: InputMaybe<Scalars['ID']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  product?: InputMaybe<Scalars['String']['input']>
  productType?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  sensorKind?: InputMaybe<UserSensorKind>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeCreateReplacementRequestArgs = {
  chargeAmount?: InputMaybe<ReplacementRequestChargeAmount>
  dateFellOff?: InputMaybe<Scalars['String']['input']>
  dateNotified?: InputMaybe<Scalars['String']['input']>
  daysWorn?: InputMaybe<Scalars['Int']['input']>
  errorType?: InputMaybe<ReplacementRequestErrorType>
  howItFellOff?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  replacementReason?: InputMaybe<ReplacementRequestReplacementReason>
  rgaRequired?: InputMaybe<ReplacementRequestRgaRequired>
  sensorId?: InputMaybe<Scalars['ID']['input']>
  sensorKind?: InputMaybe<UserSensorKind>
  serialNumber?: InputMaybe<Scalars['String']['input']>
  testedWithLibreApp?: InputMaybe<ReplacementRequestTestedWithLibreApp>
  wearingPatch?: InputMaybe<ReplacementRequestWearingPatch>
}

export type IMutationTypeCreateReplacementRequestInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeCreateShipmentArgs = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  deliveredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lotNumber?: InputMaybe<Scalars['String']['input']>
  orderId?: InputMaybe<Scalars['Int']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  providerReceivedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  providerShipmentId?: InputMaybe<Scalars['ID']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  shippedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  street2?: InputMaybe<Scalars['String']['input']>
  trackingNumber?: InputMaybe<Scalars['String']['input']>
  trackingUrl?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeCreateSyncRequestArgs = {
  userId: Scalars['ID']['input']
}

export type IMutationTypeCreateTicketArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<TicketKind>
  priority?: InputMaybe<TicketPriority>
  reason?: InputMaybe<TicketReason>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeCreateTicketCommentArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  mentionedAdminIds?: InputMaybe<Array<Scalars['ID']['input']>>
  ticketId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeDeactivateCoachProfileArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeDeleteActionGoalArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeDeleteChatConversationMessageTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeDeleteCoachBillingInvoiceItemArgs = {
  itemKey: Scalars['String']['input']
}

export type IMutationTypeDeleteCoachSharedAssetArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeDeleteEhrAppointmentRecurrenceArgs = {
  baseStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type IMutationTypeDeleteFileArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeDeleteHealthMetricArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeDeleteKnowledgeAnswerArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeDeleteKnowledgeQuestionArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeDeleteKnowledgeSourceArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeDeleteKnowledgeTagArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeDeleteMealArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeDeleteNoteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeDeleteOrderArgs = {
  deletionReason?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type IMutationTypeDeleteReplacementRequestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeDeleteScanArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeDeleteShipmentArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type IMutationTypeDeleteTicketArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeDeleteUserPropertyArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeExportAccountRequestsDataArgs = {
  status?: InputMaybe<OpsAccountRequestStatus>
}

export type IMutationTypeGenerateHealthDataReportArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  kind?: InputMaybe<HealthDataReportKind>
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeGrantGlucoseFeatureOverrideArgs = {
  userId: Scalars['ID']['input']
}

export type IMutationTypeLinkKnowledgeAnswerArgs = {
  id: Scalars['ID']['input']
  knowledgeSourceId: Scalars['ID']['input']
}

export type IMutationTypeLinkKnowledgeQuestionArgs = {
  id: Scalars['ID']['input']
  knowledgeAnswerId: Scalars['ID']['input']
}

export type IMutationTypeNotifyFeatureFeedbackArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>
  feature: HealthPortalFeature
  message: Scalars['String']['input']
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypePromoteToCoachChatConversationArgs = {
  coachingKind?: InputMaybe<CoachesCoachingKind>
  id: Scalars['ID']['input']
}

export type IMutationTypeRemoveKnowledgeQuestionTagArgs = {
  id: Scalars['ID']['input']
  knowledgeTagId: Scalars['ID']['input']
}

export type IMutationTypeReplaceActionGoalArgs = {
  actionGoal?: InputMaybe<ICreateActionGoal>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeResendShipmentArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type IMutationTypeResetVideoChatAssignmentArgs = {
  coachingKind?: InputMaybe<CoachesCoachingKind>
  userId: Scalars['ID']['input']
}

export type IMutationTypeRespondToHealthPortalNotificationArgs = {
  id: Scalars['ID']['input']
  response: Scalars['Boolean']['input']
}

export type IMutationTypeRestartSurveyLinkArgs = {
  id: Scalars['ID']['input']
  questionKeys?: InputMaybe<Array<RestartSurveyLinkQuestionKeys>>
}

export type IMutationTypeRunDexcomConnectionStatusCheckArgs = {
  userId: Scalars['ID']['input']
}

export type IMutationTypeSaveHealthDataReportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  reportData?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeSendChatConversationMessageArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  conversationId?: InputMaybe<Scalars['ID']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeSendCoachBackToPendingRegisterArgs = {
  note?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeSendEhrAppointmentSmsReminderArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeSetPrimaryGoalMetricsArgs = {
  kinds?: InputMaybe<Array<UserGoalMetricKind>>
}

export type IMutationTypeSignInThirdPartyUserArgs = {
  provider?: InputMaybe<ThirdPartySignInProvider>
  providerToken?: InputMaybe<Scalars['String']['input']>
  providerUserId?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeSignInUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeSubmitAccountRequestArgs = {
  kind?: InputMaybe<OpsAccountRequestKind>
  notes?: InputMaybe<Scalars['String']['input']>
  payload?: InputMaybe<IAccountRequestPayloadUnionSubmissionType>
  priority?: InputMaybe<OpsAccountRequestPriority>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeUnassignAuthorizationPolicyArgs = {
  id: Scalars['ID']['input']
}

export type IMutationTypeUnlinkKnowledgeAnswerArgs = {
  id: Scalars['ID']['input']
  knowledgeSourceId: Scalars['ID']['input']
}

export type IMutationTypeUnlinkKnowledgeQuestionArgs = {
  id: Scalars['ID']['input']
  knowledgeAnswerId: Scalars['ID']['input']
}

export type IMutationTypeUpdateAccountRequestArgs = {
  accountRequestId?: InputMaybe<Scalars['ID']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<OpsAccountRequestPriority>
  status?: InputMaybe<OpsAccountRequestStatus>
}

export type IMutationTypeUpdateAddressArgs = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<AddressCountry>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<AddressState>
  street?: InputMaybe<Scalars['String']['input']>
  street2?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpdateChatConversationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  read?: InputMaybe<Scalars['Boolean']['input']>
}

export type IMutationTypeUpdateChatConversationMessageTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  private?: InputMaybe<Scalars['Boolean']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpdateChatConversationNoteArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeUpdateChatConversationStateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  snoozedUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  state?: InputMaybe<ChatConversationState>
}

export type IMutationTypeUpdateChatbotMessageReportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  resolutionNote?: InputMaybe<Scalars['String']['input']>
  resolutionRef?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<ChatbotMessageReportStatus>
}

export type IMutationTypeUpdateCoachBillingInvoiceItemArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  itemKey?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<CoachesBillingInvoiceItemKind>
  quantity?: InputMaybe<Scalars['Float']['input']>
  rate?: InputMaybe<Scalars['Float']['input']>
}

export type IMutationTypeUpdateCoachBillingRatesArgs = {
  adminTimeRate?: InputMaybe<Scalars['Float']['input']>
  asyncSupportRate?: InputMaybe<Scalars['Float']['input']>
  coachId?: InputMaybe<Scalars['ID']['input']>
  completedCallRate?: InputMaybe<Scalars['Float']['input']>
  incompleteCallRate?: InputMaybe<Scalars['Float']['input']>
  mealPlanRate?: InputMaybe<Scalars['Float']['input']>
  memberReferralBonusRate?: InputMaybe<Scalars['Float']['input']>
  supplementReviewRate?: InputMaybe<Scalars['Float']['input']>
}

export type IMutationTypeUpdateCoachConversationScheduledMessageArgs = {
  scheduledMessageId?: InputMaybe<Scalars['ID']['input']>
  sendAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  state?: InputMaybe<CoachesConversationScheduledMessageState>
  value?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpdateCoachSharedAssetArgs = {
  category?: InputMaybe<CoachesSharedAssetCategory>
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
  visibility?: InputMaybe<CoachesSharedAssetVisibility>
}

export type IMutationTypeUpdateEhrAppointmentArgs = {
  actualDuration?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  state?: InputMaybe<EhrAppointmentStateKind>
}

export type IMutationTypeUpdateGoalMetricArgs = {
  highThresholdValue?: InputMaybe<Scalars['Float']['input']>
  kind?: InputMaybe<UserGoalMetricKind>
  lowThresholdValue?: InputMaybe<Scalars['Float']['input']>
}

export type IMutationTypeUpdateHealthMetricArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  value?: InputMaybe<Scalars['Float']['input']>
}

export type IMutationTypeUpdateInvoiceOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  state?: InputMaybe<InvoiceOrderState>
  stateReason?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpdateKnowledgeAnswerArgs = {
  id: Scalars['ID']['input']
  title?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpdateKnowledgeQuestionArgs = {
  id: Scalars['ID']['input']
  value: Scalars['String']['input']
}

export type IMutationTypeUpdateKnowledgeSourceArgs = {
  id: Scalars['ID']['input']
  title?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpdateKnowledgeTagArgs = {
  id: Scalars['ID']['input']
  value: Scalars['String']['input']
}

export type IMutationTypeUpdateOrderArgs = {
  email?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  product?: InputMaybe<Scalars['String']['input']>
  productType?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  sensorKind?: InputMaybe<UserSensorKind>
}

export type IMutationTypeUpdateReplacementRequestArgs = {
  chargeAmount?: InputMaybe<ReplacementRequestChargeAmount>
  dateFellOff?: InputMaybe<Scalars['String']['input']>
  dateNotified?: InputMaybe<Scalars['String']['input']>
  daysWorn?: InputMaybe<Scalars['Int']['input']>
  errorType?: InputMaybe<ReplacementRequestErrorType>
  howItFellOff?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  replacementReason?: InputMaybe<ReplacementRequestReplacementReason>
  rgaRequired?: InputMaybe<ReplacementRequestRgaRequired>
  testedWithLibreApp?: InputMaybe<ReplacementRequestTestedWithLibreApp>
  wearingPatch?: InputMaybe<ReplacementRequestWearingPatch>
}

export type IMutationTypeUpdateSensorArgs = {
  baselineAdjustment?: InputMaybe<Scalars['Int']['input']>
}

export type IMutationTypeUpdateSettingsArgs = {
  appVersionReminder?: InputMaybe<Scalars['Boolean']['input']>
  dashboardGraph?: InputMaybe<Scalars['String']['input']>
  dexcomSync?: InputMaybe<Scalars['Boolean']['input']>
  displayActivityScore?: InputMaybe<Scalars['Boolean']['input']>
  displayDailyScore?: InputMaybe<Scalars['Boolean']['input']>
  displayMealScore?: InputMaybe<Scalars['Boolean']['input']>
  fastingEnd?: InputMaybe<Scalars['Int']['input']>
  fastingStart?: InputMaybe<Scalars['Int']['input']>
  glucoseHighThreshold?: InputMaybe<Scalars['Int']['input']>
  glucoseLowThreshold?: InputMaybe<Scalars['Int']['input']>
  glucoseSource?: InputMaybe<Scalars['String']['input']>
  googleFitSync?: InputMaybe<Scalars['Boolean']['input']>
  healthKitSync?: InputMaybe<Scalars['Boolean']['input']>
  integrationsSyncSettings?: InputMaybe<IIntegrationsSyncSettings>
  ketoMojoSync?: InputMaybe<Scalars['Boolean']['input']>
  ketoneHighThreshold?: InputMaybe<Scalars['Float']['input']>
  ketoneLowThreshold?: InputMaybe<Scalars['Float']['input']>
  macroGoalsDaily?: InputMaybe<IMacroGoalsDaily>
  patternsNotifications?: InputMaybe<Scalars['Boolean']['input']>
  reminders?: InputMaybe<Scalars['Boolean']['input']>
  showNetCarbs?: InputMaybe<Scalars['Boolean']['input']>
  statsSettings?: InputMaybe<Array<IStatsSettingsOrder>>
  syncMacroGoalsDailyToActionGoals?: InputMaybe<Scalars['Boolean']['input']>
  trackingMode?: InputMaybe<TrackingMode>
  unitSystem?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpdateShipmentArgs = {
  deliveredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  lotNumber?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  providerReceivedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  providerShipmentId?: InputMaybe<Scalars['ID']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  shippedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  trackingNumber?: InputMaybe<Scalars['String']['input']>
  trackingUrl?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpdateSupportedSensorArgs = {
  model: SensorModelsSupportedModelsKind
}

export type IMutationTypeUpdateTicketArgs = {
  assignedToId?: InputMaybe<Scalars['ID']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  externalLink?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  priority?: InputMaybe<TicketPriority>
  status?: InputMaybe<TicketStatus>
}

export type IMutationTypeUpdateUserArgs = {
  berryStreetGetHealthieId?: InputMaybe<Scalars['Int']['input']>
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  sex?: InputMaybe<Scalars['String']['input']>
  truepillPatientToken?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpdateUserOrganizationArgs = {
  id: Scalars['ID']['input']
  organizationId: Scalars['Int']['input']
}

export type IMutationTypeUpdateUserPropertyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUploadHealthDataReportPdfArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  pdf?: InputMaybe<Scalars['Upload']['input']>
}

export type IMutationTypeUpsertCoachProfileArgs = {
  additionalLanguages?: InputMaybe<Scalars['String']['input']>
  bio?: InputMaybe<Scalars['String']['input']>
  cdrCnsCard?: InputMaybe<Scalars['Upload']['input']>
  cdrCnsExpirationDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  cdrCnsNumber?: InputMaybe<Scalars['String']['input']>
  credentials?: InputMaybe<Scalars['String']['input']>
  ethnicity?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<EhrCoachGender>
  lastName?: InputMaybe<Scalars['String']['input']>
  outOfOffice?: InputMaybe<Scalars['Boolean']['input']>
  photo?: InputMaybe<Scalars['Upload']['input']>
  premium?: InputMaybe<Scalars['Boolean']['input']>
  specialties?: InputMaybe<Array<EhrCoachSpecialty>>
  stateLicenceDetails?: InputMaybe<Array<IStateLicenceDetail>>
  stateLicences?: InputMaybe<Array<Scalars['String']['input']>>
  stateOfResidence?: InputMaybe<Scalars['String']['input']>
  stressBio?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IMutationTypeUpsertCoachingKindAssignmentArgs = {
  coachId: Scalars['ID']['input']
  kind: CoachesCoachingKind
  state: CoachesCoachingKindAssignmentState
}

export type IMutationTypeUpsertMealArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  favoriteId?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  ingredients?: InputMaybe<Array<IIngredientData>>
  kind?: InputMaybe<MealKind>
  photo?: InputMaybe<Scalars['Upload']['input']>
  photoSignedId?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  time?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpsertNoteArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  pinned?: InputMaybe<Scalars['Boolean']['input']>
  time?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTypeUpsertPrimaryGoalArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<UserGoalKind>
}

export type IMutationTypeUpsertUiStateArgs = {
  name?: InputMaybe<UiStateName>
  value?: InputMaybe<Scalars['Boolean']['input']>
}

export type IMutationTypeValidateCoachInvitesArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>
}

export type IMutationTypeVerifyMfaSmsCodeArgs = {
  mfaSmsCode?: InputMaybe<Scalars['String']['input']>
}

export type INote = {
  __typename?: 'Note'
  body: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: Scalars['String']['output']
  creator: IUser
  /** @deprecated Use creator instead */
  creatorId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  kind: NoteKind
  occurredAt: Scalars['ISO8601DateTime']['output']
  pinnedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  title: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type INoteDynamicFilter = {
  field: NoteDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum NoteDynamicFilterField {
  Kind = 'kind'
}

export type INoteDynamicFilterItem = {
  items: Array<INoteDynamicFilter>
  operator: DynamicFilterOperator
}

export enum NoteKind {
  DietitianNote = 'dietitian_note',
  DietitianUpNext = 'dietitian_up_next',
  GlucoseChart = 'glucose_chart',
  MemberNote = 'member_note',
  OpsAccountRequest = 'ops_account_request'
}

export type INoteSort = {
  direction: SortDirection
  field: NoteSortField
}

export enum NoteSortField {
  Id = 'id',
  Kind = 'kind',
  OccurredAt = 'occurred_at'
}

export enum NotificationEngineCampaignsKind {
  ByosVideoCallsUpsell = 'byos_video_calls_upsell',
  LabPanelsUpsell = 'lab_panels_upsell',
  StressManagement = 'stress_management',
  VideoCallSteloUpsellPersistent = 'video_call_stelo_upsell_persistent',
  VideoCallUpsell = 'video_call_upsell'
}

export enum NotificationEngineNotificationKind {
  ActivityReminder = 'activity_reminder',
  AddedToCohort = 'added_to_cohort',
  ByosVideoCallsUpsellChatlikeNotification = 'byos_video_calls_upsell_chatlike_notification',
  ByosVideoCallsUpsellFreeConsultationActionItem = 'byos_video_calls_upsell_free_consultation_action_item',
  ByosVideoCallsUpsellFreeConsultationChatlikeNotification = 'byos_video_calls_upsell_free_consultation_chatlike_notification',
  CgmReviewVideoCallUpsell = 'cgm_review_video_call_upsell',
  ChatNewMessage = 'chat_new_message',
  CoachingCallAllowanceExhausted = 'coaching_call_allowance_exhausted',
  CohortSessionAttendanceRsvp = 'cohort_session_attendance_rsvp',
  CohortSessionMakeUpMissed = 'cohort_session_make_up_missed',
  CohortSessionMissed = 'cohort_session_missed',
  CohortSessionReminder = 'cohort_session_reminder',
  CohortSessionRsvpMissing = 'cohort_session_rsvp_missing',
  CohortSessionScheduleChanged = 'cohort_session_schedule_changed',
  CohortSessionWeightLogReminder = 'cohort_session_weight_log_reminder',
  DailyActionCompleted = 'daily_action_completed',
  DailyActionReminder = 'daily_action_reminder',
  EngagedUserReferralUpsell = 'engaged_user_referral_upsell',
  FullscriptLabResultsAvailable = 'fullscript_lab_results_available',
  FullscriptLabsRenewalReminder = 'fullscript_labs_renewal_reminder',
  GlucoseCheckReminder = 'glucose_check_reminder',
  HealthDataReportPdfReady = 'health_data_report_pdf_ready',
  HealthDataReportReady = 'health_data_report_ready',
  InsuranceOptionAvailable = 'insurance_option_available',
  InsurancePolicyIneligible = 'insurance_policy_ineligible',
  InsurancePolicyPatientResponsibilityRequired = 'insurance_policy_patient_responsibility_required',
  InsurancePolicyUnitsExhausted = 'insurance_policy_units_exhausted',
  JournalReminder = 'journal_reminder',
  LabPanelDiscountAllowanceExhausted = 'lab_panel_discount_allowance_exhausted',
  LabPanelsUpsell = 'lab_panels_upsell',
  LabResultAnalysisComplete = 'lab_result_analysis_complete',
  LabResultAnalysisFailed = 'lab_result_analysis_failed',
  LastSteloSensorAboutToExpire = 'last_stelo_sensor_about_to_expire',
  LastSteloSensorAboutToExpireForDexcomUser = 'last_stelo_sensor_about_to_expire_for_dexcom_user',
  LoseWeightRecurrentVideoCallUpsell = 'lose_weight_recurrent_video_call_upsell',
  LowDailyScoreVideoCallUpsell = 'low_daily_score_video_call_upsell',
  MealReminder = 'meal_reminder',
  MealScoreSpike = 'meal_score_spike',
  MeasurementReminder = 'measurement_reminder',
  MedicalConsultReminder = 'medical_consult_reminder',
  MedicalConsultStartingSoonReminder = 'medical_consult_starting_soon_reminder',
  MfpCreditExpiringSoonReminder = 'mfp_credit_expiring_soon_reminder',
  MfpIntegrationPromotion = 'mfp_integration_promotion',
  NewCoachExperiment = 'new_coach_experiment',
  NewCoachNote = 'new_coach_note',
  NewCourseAvailable = 'new_course_available',
  NewEnrollableCohort = 'new_enrollable_cohort',
  NutritionistSwitchVideoCall = 'nutritionist_switch_video_call',
  OnboardingExperienceReminderPostCall = 'onboarding_experience_reminder_post_call',
  OnboardingExperienceReminderPreCall = 'onboarding_experience_reminder_pre_call',
  PatternsGlucoseAverage = 'patterns_glucose_average',
  PatternsGlucoseMax = 'patterns_glucose_max',
  PatternsGlucoseMin = 'patterns_glucose_min',
  PatternsGlucoseMorningAverage = 'patterns_glucose_morning_average',
  PatternsGlucoseScore = 'patterns_glucose_score',
  PatternsGlucoseSleepAverage = 'patterns_glucose_sleep_average',
  PatternsGlucoseSpikeWithExercise = 'patterns_glucose_spike_with_exercise',
  PatternsGlucoseSpikeWithMeal = 'patterns_glucose_spike_with_meal',
  PatternsGlucoseTimeInRange = 'patterns_glucose_time_in_range',
  PatternsGlucoseVariability = 'patterns_glucose_variability',
  PatternsMealScore = 'patterns_meal_score',
  PatternsUnannotatedGlucoseSpike = 'patterns_unannotated_glucose_spike',
  ProactiveExtendedGlucoseElevation = 'proactive_extended_glucose_elevation',
  ProactiveLowGlucose = 'proactive_low_glucose',
  ProactiveMealLoggingDropOff = 'proactive_meal_logging_drop_off',
  ProactivePostActivityWin = 'proactive_post_activity_win',
  ProactivePostMealSpike = 'proactive_post_meal_spike',
  ProactiveRecurringSpikePattern = 'proactive_recurring_spike_pattern',
  ProactiveSleepGlucoseCorrelation = 'proactive_sleep_glucose_correlation',
  ProactiveUpsell = 'proactive_upsell',
  ReferAFriend = 'refer_a_friend',
  ReferralAccepted = 'referral_accepted',
  ScanReminder = 'scan_reminder',
  StressManagement = 'stress_management',
  SubmitLabResultsCustomDate = 'submit_lab_results_custom_date',
  SubmitLabResultsPeriodical = 'submit_lab_results_periodical',
  SubscriptionAboutToExpire = 'subscription_about_to_expire',
  SurveyReminder = 'survey_reminder',
  TerraFitbitGoogleHealthMigration = 'terra_fitbit_google_health_migration',
  UpcomingCallPreauthorizationFailed = 'upcoming_call_preauthorization_failed',
  UpcomingCallRequiresPaymentMethod = 'upcoming_call_requires_payment_method',
  VideoCallBookNow = 'video_call_book_now',
  VideoCallCheckInReminder = 'video_call_check_in_reminder',
  VideoCallClaimFreeCall = 'video_call_claim_free_call',
  VideoCallEarlierSlotAvailable = 'video_call_earlier_slot_available',
  VideoCallNoShowFeeChargeFailed = 'video_call_no_show_fee_charge_failed',
  VideoCallNoShowFeeCharged = 'video_call_no_show_fee_charged',
  VideoCallRecurrenceAppointmentBooked = 'video_call_recurrence_appointment_booked',
  VideoCallRecurrenceBookingCompleted = 'video_call_recurrence_booking_completed',
  VideoCallReminder = 'video_call_reminder',
  VideoCallStartingSoonReminder = 'video_call_starting_soon_reminder',
  VideoCallSteloUpsell = 'video_call_stelo_upsell',
  VideoCallSteloUpsellPersistent = 'video_call_stelo_upsell_persistent',
  VideoCallUpsell = 'video_call_upsell',
  VideoCallUpsellFollowup = 'video_call_upsell_followup'
}

export enum NotificationEngineReminderFrequency {
  Bimonthly = 'bimonthly',
  Daily = 'daily',
  HoursInterval = 'hours_interval',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Weekly = 'weekly'
}

export enum NotificationEngineReminderKind {
  Breakfast = 'breakfast',
  Dinner = 'dinner',
  Exercise = 'exercise',
  Fasting = 'fasting',
  GlucoseCheck = 'glucose_check',
  Journal = 'journal',
  LogDailyAction = 'log_daily_action',
  Lunch = 'lunch',
  Meditation = 'meditation',
  OtherMeal = 'other_meal',
  Sleep = 'sleep',
  SubmitLabResults = 'submit_lab_results',
  Weight = 'weight'
}

export type INumericPair = {
  __typename?: 'NumericPair'
  x: Scalars['Float']['output']
  y?: Maybe<Scalars['Numeric']['output']>
}

export type INumericalSelect = {
  __typename?: 'NumericalSelect'
  text: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type INutritionCard = {
  __typename?: 'NutritionCard'
  nutrition: INutritionStatistics
  score: IGlucoseDailyScore
  statistics: IGlucoseStatistics
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type INutritionStatistics = {
  __typename?: 'NutritionStatistics'
  today: Array<IKeyValuePairFloat>
}

export type IOnboarding = {
  __typename?: 'Onboarding'
  tutorials: Array<ITutorials>
}

export type IOnboardingExperience = {
  __typename?: 'OnboardingExperience'
  baselineWeight?: Maybe<Scalars['Int']['output']>
  dateToReachDesiredWeight?: Maybe<Scalars['String']['output']>
  desiredWeight?: Maybe<Scalars['Int']['output']>
  desiredWeightLossAmount?: Maybe<Scalars['Int']['output']>
  fourWeekWeight?: Maybe<Scalars['Int']['output']>
  kind: UserPropertyOnboardingExperienceKind
  participating: Scalars['Boolean']['output']
  realisticWeightLoss?: Maybe<Scalars['Boolean']['output']>
  weightLossPace?: Maybe<Scalars['Int']['output']>
}

export type IOneOffAddonRequestPayload = {
  discountCentsAmount?: InputMaybe<Scalars['Int']['input']>
  paid: Scalars['Boolean']['input']
  product: BillingProduct
}

export type IOneOffAddonResponsePayload = {
  __typename?: 'OneOffAddonResponsePayload'
  discountCentsAmount?: Maybe<Scalars['Int']['output']>
  paid: Scalars['Boolean']['output']
  product: BillingProduct
}

export enum OpsAccountRequestKind {
  CancelSubscription = 'cancel_subscription',
  ChangeSubscriptionBillingCycle = 'change_subscription_billing_cycle',
  Credit = 'credit',
  DeleteDuplicateAccount = 'delete_duplicate_account',
  GrantFreeVideoCall = 'grant_free_video_call',
  MiscRequest = 'misc_request',
  OneOffAddon = 'one_off_addon',
  PauseSubscription = 'pause_subscription',
  Refund = 'refund',
  UncancelSubscription = 'uncancel_subscription',
  UnpauseSubscription = 'unpause_subscription',
  UpdateSubscription = 'update_subscription',
  UpdateSubscriptionChurnRecovery = 'update_subscription_churn_recovery',
  UpsertLimitedSupport = 'upsert_limited_support'
}

export enum OpsAccountRequestKindsCancelSubscriptionReason {
  AppAnalytics = 'app_analytics',
  AppComplexity = 'app_complexity',
  AppDietitianCommunication = 'app_dietitian_communication',
  CgmAccuracy = 'cgm_accuracy',
  CgmCgmUncomfortable = 'cgm_cgm_uncomfortable',
  CgmScanningFrequency = 'cgm_scanning_frequency',
  CgmSkinSensitivity = 'cgm_skin_sensitivity',
  CgmTroubleshooting = 'cgm_troubleshooting',
  CompetitorStelo = 'competitor_stelo',
  HealthDoctorSuggestionToCancel = 'health_doctor_suggestion_to_cancel',
  HealthEmergency = 'health_emergency',
  HealthInsulin = 'health_insulin',
  HealthMetHealthGoals = 'health_met_health_goals',
  HealthPregnancy = 'health_pregnancy',
  HealthSurgery = 'health_surgery',
  Libre_3ToLibreLinkMigration = 'libre_3_to_libre_link_migration',
  LibreLinkRemoval = 'libre_link_removal',
  PriceDispute = 'price_dispute',
  PriceGotInsuranceToCover = 'price_got_insurance_to_cover',
  PricePersonalFinances = 'price_personal_finances',
  PriceTooExpensive = 'price_too_expensive',
  RejectedRejected = 'rejected_rejected',
  ShippingDelay = 'shipping_delay',
  ShippingGapBetweenSensors = 'shipping_gap_between_sensors',
  SubscriptionChangedMind = 'subscription_changed_mind',
  SubscriptionEndOfSubscription = 'subscription_end_of_subscription',
  SubscriptionTooManySensors = 'subscription_too_many_sensors',
  SubscriptionTooMuchOfACommitment = 'subscription_too_much_of_a_commitment'
}

export enum OpsAccountRequestKindsPauseSubscriptionReason {
  MedicalProcedure = 'medical_procedure',
  NeedBreak = 'need_break',
  ProactiveSnooze = 'proactive_snooze',
  TooManySensors = 'too_many_sensors',
  Vacation = 'vacation'
}

export type IOpsAccountRequestKindsPauseSubscriptionReasonDef = {
  __typename?: 'OpsAccountRequestKindsPauseSubscriptionReasonDef'
  copy: Scalars['String']['output']
  key: OpsAccountRequestKindsPauseSubscriptionReason
}

export enum OpsAccountRequestKindsRefundReason {
  BnplAppFunctionality = 'bnpl_app_functionality',
  BnplCgmFunctionality = 'bnpl_cgm_functionality',
  BnplFinancialFinancialChallenges = 'bnpl_financial_financial_challenges',
  BnplNoHqBuyersRemorse = 'bnpl_no_hq_buyers_remorse',
  BnplNoHqChallengedByProcess = 'bnpl_no_hq_challenged_by_process',
  BnplRejectedRejected = 'bnpl_rejected_rejected',
  ConclusionCancellingAutoRenewalDefinitionOfNoCommitment = 'conclusion_cancelling_auto_renewal_definition_of_no_commitment',
  ConclusionCancellingAutoRenewalFinishedCommitment = 'conclusion_cancelling_auto_renewal_finished_commitment',
  ConclusionEarlyCancellationPolicyCancellationFee = 'conclusion_early_cancellation_policy_cancellation_fee',
  ConclusionEarlyCancellationPolicyDiscountClawback = 'conclusion_early_cancellation_policy_discount_clawback',
  MembershipAppFunctionality = 'membership_app_functionality',
  MembershipCgmFunctionality = 'membership_cgm_functionality',
  MembershipCgmMismatchOnMakeOrModel = 'membership_cgm_mismatch_on_make_or_model',
  MembershipCgmUnmetExpectations = 'membership_cgm_unmet_expectations',
  MembershipDiscountMissedAddingCoupon = 'membership_discount_missed_adding_coupon',
  MembershipFinancialFinancialChallenges = 'membership_financial_financial_challenges',
  MembershipForgettingUnpauseForgettingUnpause = 'membership_forgetting_unpause_forgetting_unpause',
  MembershipHealthHealthChallenges = 'membership_health_health_challenges',
  MembershipLogisticsCgm = 'membership_logistics_cgm',
  MembershipLogisticsPatches = 'membership_logistics_patches',
  MembershipNnSupportLateCancellationFee = 'membership_nn_support_late_cancellation_fee',
  MembershipNnSupportLateRescheduleFee = 'membership_nn_support_late_reschedule_fee',
  MembershipNnSupportNoShowFee = 'membership_nn_support_no_show_fee',
  MembershipNnSupportNutritionistMatching = 'membership_nn_support_nutritionist_matching',
  MembershipNnSupportServiceLevel = 'membership_nn_support_service_level',
  MembershipUnhappyWithCgmFunctional = 'membership_unhappy_with_cgm_functional',
  MembershipUnhappyWithCgmMismatchOnMakeOrModel = 'membership_unhappy_with_cgm_mismatch_on_make_or_model',
  MembershipUnhappyWithCgmMismatchedExpectationOnMonitoring = 'membership_unhappy_with_cgm_mismatched_expectation_on_monitoring',
  MembershipUnsatisfactoryNnSupportMisinformation = 'membership_unsatisfactory_nn_support_misinformation',
  MembershipUnsatisfactoryNnSupportNutritionistMatching = 'membership_unsatisfactory_nn_support_nutritionist_matching',
  MembershipUnsatisfactoryNnSupportServiceLevel = 'membership_unsatisfactory_nn_support_service_level',
  NsErrorAgent = 'ns_error_agent',
  NsErrorBug = 'ns_error_bug',
  NsErrorMarketing = 'ns_error_marketing',
  NsGiftCardRemorse = 'ns_gift_card_remorse',
  NsNnVideoChangedMind = 'ns_nn_video_changed_mind',
  NsOutOfStockOutOfStock = 'ns_out_of_stock_out_of_stock',
  NsTestTest = 'ns_test_test',
  SignUpChangedMindBuyersRemorse = 'sign_up_changed_mind_buyers_remorse',
  SignUpChangedMindDidNotKnowWasMonthly = 'sign_up_changed_mind_did_not_know_was_monthly',
  SignUpConfusionMistakeChild = 'sign_up_confusion_mistake_child',
  SignUpConfusionProgramDetails = 'sign_up_confusion_program_details',
  SignUpDiscountMissedAddingCoupon = 'sign_up_discount_missed_adding_coupon',
  SignUpDuplicateAccountsDuplicateAccounts = 'sign_up_duplicate_accounts_duplicate_accounts',
  SignUpFinancialChallengesFinancialChallenges = 'sign_up_financial_challenges_financial_challenges',
  SignUpGovernmentIdGovernmentId = 'sign_up_government_id_government_id',
  SignUpHealthChallengesHealthChallenges = 'sign_up_health_challenges_health_challenges',
  SignUpMispurchaseChild = 'sign_up_mispurchase_child',
  SignUpMispurchaseConfusion = 'sign_up_mispurchase_confusion',
  SignUpMispurchaseLackOfInformation = 'sign_up_mispurchase_lack_of_information',
  SignUpNoHqBuyersRemorse = 'sign_up_no_hq_buyers_remorse',
  SignUpNoHqChallengedByProcess = 'sign_up_no_hq_challenged_by_process',
  SignUpNoHqDontKnowNeedToFillItOut = 'sign_up_no_hq_dont_know_need_to_fill_it_out',
  SignUpNoHqFinancialChallenges = 'sign_up_no_hq_financial_challenges',
  SignUpNoHqForgets = 'sign_up_no_hq_forgets',
  SignUpNoHqLinkDoesNotWork = 'sign_up_no_hq_link_does_not_work',
  SignUpNoHqRefusedToFillOut = 'sign_up_no_hq_refused_to_fill_out',
  SignUpRejectedRejected = 'sign_up_rejected_rejected',
  SignUpTechIssuesTechIssues = 'sign_up_tech_issues_tech_issues',
  SignUpUserExperienceUserExperience = 'sign_up_user_experience_user_experience'
}

export type IOpsAccountRequestKindsRefundReasonDef = {
  __typename?: 'OpsAccountRequestKindsRefundReasonDef'
  description: Scalars['String']['output']
  journey: Scalars['String']['output']
  key: OpsAccountRequestKindsRefundReason
  reasonOne: Scalars['String']['output']
  reasonTwo: Scalars['String']['output']
}

export enum OpsAccountRequestPriority {
  High = 'high',
  Regular = 'regular'
}

export enum OpsAccountRequestStatus {
  Escalated = 'escalated',
  Failed = 'failed',
  Processed = 'processed',
  Processing = 'processing',
  Rejected = 'rejected',
  Reviewed = 'reviewed'
}

export type IOrder = {
  __typename?: 'Order'
  address?: Maybe<IAddress>
  addressId: Scalars['Int']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  email: Scalars['String']['output']
  id: Scalars['Int']['output']
  includable: ShippingOrderIncludable
  invoice?: Maybe<IInvoice>
  notes?: Maybe<Scalars['String']['output']>
  product: Scalars['String']['output']
  productType: ShippingOrderProductType
  provider?: Maybe<ShippingOrderProvider>
  quantity: Scalars['Int']['output']
  replacementRequest?: Maybe<IReplacementRequest>
  sensorKind?: Maybe<UserSensorKind>
  updatedAt: Scalars['ISO8601DateTime']['output']
  user?: Maybe<IUser>
  userId?: Maybe<Scalars['Int']['output']>
}

export type IOrderDynamicFilter = {
  field: OrderDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum OrderDynamicFilterField {
  AddressCity = 'address_city',
  AddressCountry = 'address_country',
  AddressName = 'address_name',
  AddressState = 'address_state',
  AddressStreet = 'address_street',
  AddressStreet_2 = 'address_street_2',
  AddressZipCode = 'address_zip_code',
  CreatedAt = 'created_at',
  Email = 'email',
  Id = 'id',
  Includable = 'includable',
  InvoiceStripeId = 'invoice_stripe_id',
  Notes = 'notes',
  Product = 'product',
  ProductType = 'product_type',
  Provider = 'provider',
  Quantity = 'quantity',
  ReplacementRequestReplacementReason = 'replacement_request_replacement_reason',
  SensorKind = 'sensor_kind',
  UpdatedAt = 'updated_at',
  UserDateOfBirth = 'user_date_of_birth',
  UserEmail = 'user_email',
  UserFirstName = 'user_first_name',
  UserFullName = 'user_full_name',
  UserId = 'user_id',
  UserLastName = 'user_last_name',
  UserPhoneNumber = 'user_phone_number',
  UserSex = 'user_sex'
}

export type IOrderDynamicFilterItem = {
  items: Array<IOrderDynamicFilter>
  operator: DynamicFilterOperator
}

export type IOrderSort = {
  direction: SortDirection
  field: OrderSortField
}

export enum OrderSortField {
  AddressCity = 'address_city',
  AddressCountry = 'address_country',
  AddressName = 'address_name',
  AddressState = 'address_state',
  AddressStreet = 'address_street',
  AddressStreet_2 = 'address_street_2',
  AddressZipCode = 'address_zip_code',
  CreatedAt = 'created_at',
  Email = 'email',
  Id = 'id',
  Includable = 'includable',
  InvoiceStripeId = 'invoice_stripe_id',
  Notes = 'notes',
  Product = 'product',
  ProductType = 'product_type',
  Provider = 'provider',
  Quantity = 'quantity',
  ReplacementRequestReplacementReason = 'replacement_request_replacement_reason',
  SensorKind = 'sensor_kind',
  UpdatedAt = 'updated_at',
  UserDateOfBirth = 'user_date_of_birth',
  UserEmail = 'user_email',
  UserFirstName = 'user_first_name',
  UserFullName = 'user_full_name',
  UserId = 'user_id',
  UserLastName = 'user_last_name',
  UserPhoneNumber = 'user_phone_number',
  UserSex = 'user_sex'
}

export type IOrganization = {
  __typename?: 'Organization'
  id: Scalars['Int']['output']
  isNutrisense: Scalars['Boolean']['output']
  name: Scalars['String']['output']
}

export type IOrganizationsCollection = {
  __typename?: 'OrganizationsCollection'
  organizations: Array<IOrganization>
}

export type IOutcome = {
  __typename?: 'Outcome'
  id: Scalars['ID']['output']
  key: Scalars['String']['output']
  reason: IReason
}

export type IPagination = {
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type IPauseSubscriptionRequestPayload = {
  cycleCount: Scalars['Int']['input']
  reason: OpsAccountRequestKindsPauseSubscriptionReason
  subscriptionId: Scalars['ID']['input']
}

export type IPauseSubscriptionResponsePayload = {
  __typename?: 'PauseSubscriptionResponsePayload'
  cycleCount: Scalars['Int']['output']
  reason: OpsAccountRequestKindsPauseSubscriptionReason
  subscriptionId: Scalars['ID']['output']
}

export type IPaymentMethod = {
  __typename?: 'PaymentMethod'
  cardType: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  expirationDate: Scalars['ISO8601Date']['output']
  last4: Scalars['String']['output']
  stripeId: Scalars['String']['output']
}

export type IPill = {
  __typename?: 'Pill'
  fill?: Maybe<UiPillFill>
  size?: Maybe<UiPillSize>
  text: Scalars['String']['output']
  type?: Maybe<UiPillType>
}

export type IPlan = {
  __typename?: 'Plan'
  amount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  nickname: Scalars['String']['output']
  product: IProductMin
  stripeId: Scalars['String']['output']
}

export type IPrivateSurveyLinkCollection = {
  __typename?: 'PrivateSurveyLinkCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  surveyLinks: Array<ISurveyLink>
  totalCount: Scalars['Int']['output']
}

export type IPrivateUiState = {
  __typename?: 'PrivateUIState'
  name: UiStateName
  value: Scalars['Boolean']['output']
}

export type IPrivateUserCollection = {
  __typename?: 'PrivateUserCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
  users: Array<IUser>
}

export type IProduct = {
  __typename?: 'Product'
  addon: Scalars['Boolean']['output']
  appliedPromo?: Maybe<IPromotionCode>
  billingDateChangeable: Scalars['Boolean']['output']
  bundledPaidCalls: Scalars['Boolean']['output']
  callout?: Maybe<Scalars['String']['output']>
  cgm: Scalars['Boolean']['output']
  commitmentMonths?: Maybe<Scalars['Int']['output']>
  core: Scalars['Boolean']['output']
  description?: Maybe<Scalars['String']['output']>
  details?: Maybe<Array<Scalars['String']['output']>>
  dietitian: Scalars['Boolean']['output']
  dietitianMenu: Scalars['Boolean']['output']
  /** @deprecated Field removed from product */
  dietitianTrialDays?: Maybe<Scalars['Int']['output']>
  ehrSchedulingRule: IEhrAppointmentSchedulingRuleDef
  eligibilityListItems: Array<Scalars['String']['output']>
  eligibleUpgradeProducts: Array<IProductMin>
  free: Scalars['Boolean']['output']
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  includedGoods: Array<IProductMin>
  includedOptions?: Maybe<Array<Scalars['String']['output']>>
  includesCgm: Scalars['Boolean']['output']
  incompatibleAddons: Array<IProductMin>
  insuranceCoverage: Scalars['Boolean']['output']
  interval: IInterval
  key: Scalars['String']['output']
  metadata: Scalars['JSON']['output']
  order: Scalars['Int']['output']
  ownSensor: Scalars['Boolean']['output']
  patch: Scalars['Boolean']['output']
  pill?: Maybe<IPill>
  /** @deprecated Use price instead */
  plan: IProductPlan
  preselected: Scalars['Boolean']['output']
  price: Scalars['Float']['output']
  productGroup?: Maybe<IProductGroup>
  programsName?: Maybe<Scalars['String']['output']>
  recurring: Scalars['Boolean']['output']
  requiresShipping: Scalars['Boolean']['output']
  shippingRule: IShippingRule
  shortDescription?: Maybe<Scalars['String']['output']>
  showUnitPrice: Scalars['Boolean']['output']
  softwareOnly: Scalars['Boolean']['output']
  title: Scalars['String']['output']
  trialDays?: Maybe<Scalars['Int']['output']>
  uhc: Scalars['Boolean']['output']
  uncancelable: Scalars['Boolean']['output']
  units?: Maybe<Scalars['Int']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type IProductCollection = {
  __typename?: 'ProductCollection'
  products: Array<IProduct>
}

export type IProductGroup = {
  __typename?: 'ProductGroup'
  description: Scalars['String']['output']
  details: Array<Scalars['String']['output']>
  id: Scalars['ID']['output']
  interval: IInterval
  key: Scalars['String']['output']
  kind?: Maybe<BillingProductGroupKind>
  order: Scalars['Int']['output']
  shortDescription: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type IProductMin = {
  __typename?: 'ProductMin'
  billingDateChangeable: Scalars['Boolean']['output']
  bundledPaidCalls: Scalars['Boolean']['output']
  cgm: Scalars['Boolean']['output']
  core: Scalars['Boolean']['output']
  details?: Maybe<Array<Scalars['String']['output']>>
  ehrSchedulingRule: IEhrAppointmentSchedulingRuleDef
  eligibleUpgradeProducts: Array<IProductMin>
  free: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  includedGoods: Array<IProductMin>
  includesCgm: Scalars['Boolean']['output']
  incompatibleAddons: Array<IProductMin>
  interval: IInterval
  key: Scalars['String']['output']
  ownSensor: Scalars['Boolean']['output']
  patch: Scalars['Boolean']['output']
  recurring: Scalars['Boolean']['output']
  requiresShipping: Scalars['Boolean']['output']
  softwareOnly: Scalars['Boolean']['output']
  title: Scalars['String']['output']
  uhc: Scalars['Boolean']['output']
  uncancelable: Scalars['Boolean']['output']
}

export type IProductPlan = {
  __typename?: 'ProductPlan'
  amount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  stripeId: Scalars['String']['output']
}

export type IProgramCollection = {
  __typename?: 'ProgramCollection'
  programs: Array<IExpandableProgram>
}

export type IProgress = {
  __typename?: 'Progress'
  complete: Scalars['Boolean']['output']
}

export type IPromotionCode = {
  __typename?: 'PromotionCode'
  amountOff?: Maybe<Scalars['Float']['output']>
  applicable: Scalars['Boolean']['output']
  code: Scalars['String']['output']
  durationInMonths?: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  percentOff?: Maybe<Scalars['Float']['output']>
  providerId: Scalars['String']['output']
}

export type IQueryType = {
  __typename?: 'QueryType'
  actionGoalSummaries: IActionGoalSummaryCollection
  allAccountRequests: IAccountRequestCollection
  allAmazonOrders: IListAmazonOrders
  allAssignableAuthorizationPolicies: Array<IAssignableAuthorizationPolicy>
  allCharges: IChargeCollection
  allCharts: ICharts
  allChatConversationEvents: IChatConversationEventsCollection
  allChatConversationMessageTemplateVariables: IChatConversationMessageTemplateVariableCollection
  allChatConversationMessageTemplates: IConversationMessageTemplateCollection
  allChatConversations: IChatConversationsCollection
  allChatbotConversations: IListConversations
  allChatbotMessageReports: IListChatbotMessageReports
  allCoachAssignments: ICoachAssignmentsCollection
  allCoachBillingInvoiceUsers: ICoachBillingInvoiceUserCollection
  allCoachConversationScheduledMessages: ICoachConversationScheduledMessageCollection
  allCourses: IProgramCollection
  allEvents: IEventsData
  allFiles: IListFiles
  allFormulas: IFormulaCollection
  allHealthDataReports: IListHealthDataReports
  allHealthPortalNotifications: IHealthPortalNotificationCollection
  allInvoiceOrders: IListInvoiceOrders
  allInvoices: IInvoiceCollection
  allKnowledgeAnswers: IKnowledgeAnswerCollection
  allKnowledgeQuestions: IKnowledgeQuestionCollection
  allKnowledgeSources: IKnowledgeSourceCollection
  allKnowledgeTags: IKnowledgeTagCollection
  allMeasurements: IMeasurementCollection
  allNotes: IListNotes
  allNutrition: INutritionCard
  allOrders: IListOrders
  allOrganizations: IOrganizationsCollection
  allReplacementReasonsConfig: IReplacementReasonsConfig
  allReplacementRequests: IReplacementRequestCollection
  allSensors: ISensorCollection
  allShipments: IListShipments
  allStats: IStats
  allSubscriptionSchedules: IScheduleCollection
  allSubscriptions: ISubscriptionCollection
  allSurveyLinks: IPrivateSurveyLinkCollection
  allTicketComments: ITicketCommentCollection
  allTickets: ITicketCollection
  allUserProperties: IUserPropertiesCollection
  allUsers: IPrivateUserCollection
  allUsersAutocomplete: IUserCollection
  authorizationPolicies: IAuthorizationPolicyCollection
  authorizedFeatures: IHealthPortalFeatureCollection
  billingAllowances: IBillingAllowanceCollection
  calculateDuplicateAccountCredit: ICalculateDuplicateAccountCredit
  calendar: IUserCalendar
  chatConversation: IChatConversation
  chatbotMessage: IMessage
  clientConfig: IClientConfig
  coachAvailabilitySnapshot: ISnapshot
  coachBillingInvoiceItemKinds: ICoachBillingInvoiceItemKindCollection
  coachBillingInvoiceItemTotals: ICoachBillingInvoiceItemTotals
  coachBillingInvoiceItems: ICoachBillingInvoiceItemCollection
  coachBillingInvoiceReviews: ICoachBillingInvoiceReviewCollection
  coachBillingInvoices: ICoachBillingInvoiceCollection
  coachBillingRates: ICoachBillingRates
  coachSharedAssets: ICoachSharedAssetCollection
  currentAdmin?: Maybe<IUser>
  currentUser?: Maybe<IUser>
  dexcomConnectionStatus?: Maybe<IDexcomConnection>
  distinctUserPropertyValues: Array<Scalars['String']['output']>
  ehrAppointment: IHealthPortalEhrAppointment
  ehrAppointmentCredits: IEhrAppointmentCredits
  ehrAppointmentRecurrence?: Maybe<IEhrAppointmentRecurrence>
  ehrAppointmentRecurrences: Array<IEhrAppointmentRecurrence>
  ehrAppointments: IEhrAppointmentCollection
  eligibleProducts: IProductCollection
  eligibleUpdateProducts: IEligibleUpdateProducts
  formula: IFormula
  healthMetrics: IHealthMetrics
  listCoachAvailabilitySnapshots: ISnapshotCollection
  nextCoachAppointment?: Maybe<IHealthPortalEhrAppointment>
  nextUserEhrAppointment?: Maybe<IHealthPortalEhrAppointment>
  order: IOrder
  previewCoachConversationMessage: ICoachConversationMessagePreview
  resetPasswordRequest: ISuccess
  showAccountRequestsConfig: IAccountRequestsConfig
  uiStates: Array<IUiState>
  user: IUser
  userInsurancePolicy?: Maybe<IInsurancePolicy>
  userSurveyLinks: ISurveyLinkCollection
}

export type IQueryTypeActionGoalSummariesArgs = {
  startDate: Scalars['ISO8601Date']['input']
}

export type IQueryTypeAllAccountRequestsArgs = {
  dynamicFilters?: InputMaybe<Array<IAccountRequestDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IAccountRequestSort>>
  status?: InputMaybe<OpsAccountRequestStatus>
}

export type IQueryTypeAllAmazonOrdersArgs = {
  dynamicFilters?: InputMaybe<Array<IAmazonOrderDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IAmazonOrderSort>>
}

export type IQueryTypeAllChargesArgs = {
  dynamicFilters?: InputMaybe<Array<IChargeDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IChargeSort>>
}

export type IQueryTypeAllChartsArgs = {
  filter?: InputMaybe<IDateFilter>
}

export type IQueryTypeAllChatConversationEventsArgs = {
  conversationId?: InputMaybe<Scalars['ID']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IChatConversationEventSort>>
}

export type IQueryTypeAllChatConversationMessageTemplatesArgs = {
  excludeAutomatic?: InputMaybe<Scalars['Boolean']['input']>
  kinds?: InputMaybe<Array<ChatConversationMessageTemplateKind>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}

export type IQueryTypeAllChatConversationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  forCoach?: InputMaybe<Scalars['Boolean']['input']>
  kinds?: InputMaybe<Array<ChatConversationKind>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IChatConversationSort>>
  states?: InputMaybe<Array<ChatConversationState>>
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type IQueryTypeAllChatbotMessageReportsArgs = {
  dynamicFilters?: InputMaybe<Array<IChatbotMessageReportDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IChatbotMessageReportSort>>
}

export type IQueryTypeAllCoachAssignmentsArgs = {
  dynamicFilters?: InputMaybe<Array<ICoachAssignmentDynamicFilterItem>>
  last?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<ICoachAssignmentSort>>
}

export type IQueryTypeAllCoachBillingInvoiceUsersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  dynamicFilters?: InputMaybe<Array<ICoachBillingInvoiceUserDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  periodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>
  periodStart?: InputMaybe<Scalars['ISO8601Date']['input']>
  sorts?: InputMaybe<Array<ICoachBillingInvoiceUserSort>>
}

export type IQueryTypeAllCoachConversationScheduledMessagesArgs = {
  kinds?: InputMaybe<Array<ChatConversationMessageTemplateKind>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<ICoachConversationScheduledMessageSort>>
  states?: InputMaybe<Array<CoachesConversationScheduledMessageState>>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IQueryTypeAllEventsArgs = {
  filter?: InputMaybe<IDateFilter>
  pagination?: InputMaybe<IPagination>
}

export type IQueryTypeAllFilesArgs = {
  dynamicFilters?: InputMaybe<Array<IFileDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IFileSort>>
}

export type IQueryTypeAllHealthDataReportsArgs = {
  dynamicFilters?: InputMaybe<Array<IHealthDataReportDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IHealthDataReportSort>>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IQueryTypeAllHealthPortalNotificationsArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>
  completedLastMonth?: InputMaybe<Scalars['Boolean']['input']>
  forReview?: InputMaybe<Scalars['Boolean']['input']>
  kinds?: InputMaybe<Array<HealthPortalNotificationKind>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IHealthPortalNotificationsSort>>
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type IQueryTypeAllInvoiceOrdersArgs = {
  dynamicFilters?: InputMaybe<Array<IInvoiceOrderDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IInvoiceOrderSort>>
}

export type IQueryTypeAllInvoicesArgs = {
  dynamicFilters?: InputMaybe<Array<IInvoiceDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IInvoiceSort>>
}

export type IQueryTypeAllKnowledgeAnswersArgs = {
  dynamicFilters?: InputMaybe<Array<IKnowledgeAnswerDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IKnowledgeAnswerSort>>
}

export type IQueryTypeAllKnowledgeQuestionsArgs = {
  dynamicFilters?: InputMaybe<Array<IKnowledgeQuestionDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IKnowledgeQuestionSort>>
}

export type IQueryTypeAllKnowledgeSourcesArgs = {
  dynamicFilters?: InputMaybe<Array<IKnowledgeSourceDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IKnowledgeSourceSort>>
}

export type IQueryTypeAllKnowledgeTagsArgs = {
  dynamicFilters?: InputMaybe<Array<IKnowledgeTagDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IKnowledgeTagSort>>
}

export type IQueryTypeAllMeasurementsArgs = {
  filter?: InputMaybe<IMeasurementFilter>
  pagination?: InputMaybe<IPagination>
}

export type IQueryTypeAllNotesArgs = {
  dynamicFilters?: InputMaybe<Array<INoteDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<INoteSort>>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IQueryTypeAllNutritionArgs = {
  filter?: InputMaybe<IDateFilter>
}

export type IQueryTypeAllOrdersArgs = {
  dynamicFilters?: InputMaybe<Array<IOrderDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IOrderSort>>
}

export type IQueryTypeAllOrganizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type IQueryTypeAllReplacementRequestsArgs = {
  dynamicFilters?: InputMaybe<Array<IReplacementRequestDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IReplacementRequestSort>>
}

export type IQueryTypeAllShipmentsArgs = {
  dynamicFilters?: InputMaybe<Array<IShipmentDynamicFilterItem>>
  orderId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IShipmentSort>>
}

export type IQueryTypeAllStatsArgs = {
  filter?: InputMaybe<IDateFilter>
}

export type IQueryTypeAllSubscriptionSchedulesArgs = {
  dynamicFilters?: InputMaybe<Array<ISubscriptionScheduleDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}

export type IQueryTypeAllSubscriptionsArgs = {
  dynamicFilters?: InputMaybe<Array<ISubscriptionDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<ISubscriptionSort>>
}

export type IQueryTypeAllSurveyLinksArgs = {
  dynamicFilters?: InputMaybe<Array<ISurveyLinkDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<ISurveyLinkSort>>
}

export type IQueryTypeAllTicketCommentsArgs = {
  dynamicFilters?: InputMaybe<Array<ITicketCommentDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<ITicketCommentSort>>
  ticketId?: InputMaybe<Scalars['ID']['input']>
}

export type IQueryTypeAllTicketsArgs = {
  dynamicFilters?: InputMaybe<Array<ITicketDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<ITicketSort>>
}

export type IQueryTypeAllUsersArgs = {
  dynamicFilters?: InputMaybe<Array<IUserDynamicFilterItem>>
  forHqApproval?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IUserSort>>
}

export type IQueryTypeAllUsersAutocompleteArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['String']['input']
}

export type IQueryTypeAuthorizationPoliciesArgs = {
  userId: Scalars['ID']['input']
}

export type IQueryTypeBillingAllowancesArgs = {
  userId: Scalars['ID']['input']
}

export type IQueryTypeCalculateDuplicateAccountCreditArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IQueryTypeCalendarArgs = {
  filter?: InputMaybe<IDateFilter>
}

export type IQueryTypeChatConversationArgs = {
  id: Scalars['ID']['input']
}

export type IQueryTypeChatbotMessageArgs = {
  id: Scalars['ID']['input']
}

export type IQueryTypeCoachAvailabilitySnapshotArgs = {
  snapshotKey: Scalars['String']['input']
}

export type IQueryTypeCoachBillingInvoiceItemTotalsArgs = {
  coachId?: InputMaybe<Scalars['ID']['input']>
  periodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>
  periodStart?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export type IQueryTypeCoachBillingInvoiceItemsArgs = {
  coachId?: InputMaybe<Scalars['ID']['input']>
  dynamicFilters?: InputMaybe<Array<ICoachBillingInvoiceItemDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  periodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>
  periodStart?: InputMaybe<Scalars['ISO8601Date']['input']>
  sorts?: InputMaybe<Array<ICoachBillingInvoiceItemSort>>
}

export type IQueryTypeCoachBillingInvoiceReviewsArgs = {
  coachId?: InputMaybe<Scalars['ID']['input']>
  dynamicFilters?: InputMaybe<Array<ICoachBillingInvoiceReviewDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  periodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>
  periodStart?: InputMaybe<Scalars['ISO8601Date']['input']>
  sorts?: InputMaybe<Array<ICoachBillingInvoiceReviewSort>>
}

export type IQueryTypeCoachBillingInvoicesArgs = {
  coachId?: InputMaybe<Scalars['ID']['input']>
  dynamicFilters?: InputMaybe<Array<ICoachBillingInvoiceDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  periodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>
  periodStart?: InputMaybe<Scalars['ISO8601Date']['input']>
  sorts?: InputMaybe<Array<ICoachBillingInvoiceSort>>
}

export type IQueryTypeCoachBillingRatesArgs = {
  coachId: Scalars['ID']['input']
}

export type IQueryTypeCoachSharedAssetsArgs = {
  dynamicFilters?: InputMaybe<Array<ICoachSharedAssetDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<ICoachSharedAssetSort>>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
}

export type IQueryTypeDexcomConnectionStatusArgs = {
  userId: Scalars['ID']['input']
}

export type IQueryTypeDistinctUserPropertyValuesArgs = {
  kind: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  value: Scalars['String']['input']
}

export type IQueryTypeEhrAppointmentArgs = {
  id: Scalars['ID']['input']
}

export type IQueryTypeEhrAppointmentsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  category?: InputMaybe<EhrAppointmentCategory>
  coachUserId?: InputMaybe<Scalars['ID']['input']>
  dynamicFilters?: InputMaybe<Array<IEhrAppointmentDynamicFilterItem>>
  filterKind?: InputMaybe<FilterAppointmentsKind>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<IEhrAppointmentSort>>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IQueryTypeEligibleProductsArgs = {
  products?: InputMaybe<Array<BillingProduct>>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IQueryTypeEligibleUpdateProductsArgs = {
  userId: Scalars['ID']['input']
}

export type IQueryTypeFormulaArgs = {
  operation: Scalars['String']['input']
}

export type IQueryTypeNextUserEhrAppointmentArgs = {
  userId: Scalars['ID']['input']
}

export type IQueryTypeOrderArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type IQueryTypePreviewCoachConversationMessageArgs = {
  messageTemplateId?: InputMaybe<Scalars['ID']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type IQueryTypeResetPasswordRequestArgs = {
  email?: InputMaybe<Scalars['String']['input']>
}

export type IQueryTypeUserArgs = {
  id: Scalars['ID']['input']
}

export type IQueryTypeUserInsurancePolicyArgs = {
  userId: Scalars['ID']['input']
}

export type IQuestion = {
  __typename?: 'Question'
  actionButtonText?: Maybe<Scalars['String']['output']>
  coachBubbleLabel?: Maybe<Scalars['String']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  key: SurveysQuestionKey
  label?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  required: Scalars['Boolean']['output']
  response: IResponse
}

export type IQuestionsGroup = {
  __typename?: 'QuestionsGroup'
  banner?: Maybe<Scalars['String']['output']>
  introScreen?: Maybe<IIntroScreen>
  questions: Array<IQuestion>
}

export type IRange = {
  __typename?: 'Range'
  max: Scalars['Float']['output']
  min: Scalars['Float']['output']
}

export type IRangePair = {
  __typename?: 'RangePair'
  x: IRange
  y: Scalars['Numeric']['output']
}

export type IRangeUnit = {
  __typename?: 'RangeUnit'
  from?: Maybe<Scalars['Float']['output']>
  rating: Scalars['String']['output']
  to?: Maybe<Scalars['Float']['output']>
  type: Scalars['String']['output']
}

export type IReason = {
  __typename?: 'Reason'
  headline: Scalars['String']['output']
  inlineAlert?: Maybe<IInlineAlert>
  message: IReasonMessage
  notes: Array<Scalars['String']['output']>
}

export type IReasonMessage = {
  __typename?: 'ReasonMessage'
  content: Scalars['String']['output']
  links?: Maybe<Array<IReasonMessageLink>>
}

export type IReasonMessageLink = {
  __typename?: 'ReasonMessageLink'
  placeholder: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type IReferral = {
  __typename?: 'Referral'
  credits: Scalars['Int']['output']
  description: Scalars['String']['output']
  discount: Scalars['Int']['output']
  discountPercentage?: Maybe<Scalars['Float']['output']>
  kind: ReferralCouponKind
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}

export enum ReferralCouponKind {
  AmazonGiftCard = 'amazon_gift_card',
  Credits = 'credits'
}

export type IRefundRequestPayload = {
  amountInCents: Scalars['Int']['input']
  chargeId: Scalars['String']['input']
  refundReason: OpsAccountRequestKindsRefundReason
  subscriptionCancellationReason?: InputMaybe<OpsAccountRequestKindsCancelSubscriptionReason>
  subscriptionCancellationRequired: Scalars['Boolean']['input']
}

export type IRefundResponsePayload = {
  __typename?: 'RefundResponsePayload'
  amountInCents: Scalars['Int']['output']
  chargeId: Scalars['ID']['output']
  refundReason?: Maybe<IOpsAccountRequestKindsRefundReasonDef>
  subscriptionCancellationReason?: Maybe<OpsAccountRequestKindsCancelSubscriptionReason>
  subscriptionCancellationRequired: Scalars['Boolean']['output']
}

export type IReminderFrequency = {
  __typename?: 'ReminderFrequency'
  key: NotificationEngineReminderFrequency
}

export type IReminderKind = {
  __typename?: 'ReminderKind'
  allowedFrequencies: Array<IReminderFrequency>
  icon: Scalars['String']['output']
  key: NotificationEngineReminderKind
  title: Scalars['String']['output']
}

export type IRemindersSettings = {
  __typename?: 'RemindersSettings'
  hoursInterval: IHoursInterval
}

export type IReplaceActionGoal = {
  __typename?: 'ReplaceActionGoal'
  deletedActionGoal: IActionGoal
  newActionGoal: IActionGoal
}

export type IReplacementReasonsConfig = {
  __typename?: 'ReplacementReasonsConfig'
  replacementReasons: Array<IReplacementRequestReplacementReasonDef>
}

export type IReplacementRequest = {
  __typename?: 'ReplacementRequest'
  chargeAmount: ReplacementRequestChargeAmount
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy?: Maybe<IUser>
  createdById?: Maybe<Scalars['ID']['output']>
  dateFellOff?: Maybe<Scalars['String']['output']>
  dateNotified?: Maybe<Scalars['String']['output']>
  daysWorn?: Maybe<Scalars['String']['output']>
  errorType?: Maybe<ReplacementRequestErrorType>
  howItFellOff: Scalars['String']['output']
  id: Scalars['ID']['output']
  invoice?: Maybe<IInvoice>
  notes: Scalars['String']['output']
  providerCompensation: ReplacementRequestProviderCompensation
  replacementReason: ReplacementRequestReplacementReason
  rgaRequired?: Maybe<ReplacementRequestRgaRequired>
  sensor?: Maybe<ISensor>
  sensorKind?: Maybe<UserSensorKind>
  /** @deprecated Use sensor field instead */
  serialNumber?: Maybe<Scalars['String']['output']>
  state: ReplacementRequestState
  testedWithLibreApp?: Maybe<ReplacementRequestTestedWithLibreApp>
  user: IUser
  userId: Scalars['ID']['output']
  wearingPatch: ReplacementRequestWearingPatch
}

export enum ReplacementRequestChargeAmount {
  FreeReplacement_1Cgm = 'free_replacement_1_cgm',
  FreeReplacement_2Cgm = 'free_replacement_2_cgm',
  PaidReship_1Cgm = 'paid_reship_1_cgm',
  PaidReship_2Cgm = 'paid_reship_2_cgm',
  PaidReship_3Cgm = 'paid_reship_3_cgm',
  ReplacementFee_1Cgm = 'replacement_fee_1_cgm',
  ReplacementFee_2Cgm = 'replacement_fee_2_cgm',
  Reship_1Cgm = 'reship_1_cgm',
  Reship_2Cgm = 'reship_2_cgm',
  Reship_3Cgm = 'reship_3_cgm'
}

export type IReplacementRequestCollection = {
  __typename?: 'ReplacementRequestCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  replacementRequests: Array<IReplacementRequest>
  totalCount: Scalars['Int']['output']
}

export type IReplacementRequestDynamicFilter = {
  field: ReplacementRequestDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum ReplacementRequestDynamicFilterField {
  ChargeAmount = 'charge_amount',
  CreatedAt = 'created_at',
  CreatedByEmail = 'created_by_email',
  CreatedById = 'created_by_id',
  DateFellOff = 'date_fell_off',
  DateNotified = 'date_notified',
  DaysWorn = 'days_worn',
  ErrorType = 'error_type',
  HowItFellOff = 'how_it_fell_off',
  Id = 'id',
  InvoiceStripeId = 'invoice_stripe_id',
  Notes = 'notes',
  ReplacementReason = 'replacement_reason',
  RgaRequired = 'rga_required',
  SensorKind = 'sensor_kind',
  SensorModel = 'sensor_model',
  SensorSerialNumber = 'sensor_serial_number',
  State = 'state',
  TestedWithLibreApp = 'tested_with_libre_app',
  UpdatedAt = 'updated_at',
  UserEmail = 'user_email',
  UserId = 'user_id',
  WearingPatch = 'wearing_patch'
}

export type IReplacementRequestDynamicFilterItem = {
  items: Array<IReplacementRequestDynamicFilter>
  operator: DynamicFilterOperator
}

export enum ReplacementRequestErrorType {
  Malfunction = 'malfunction',
  ReturnToSender = 'return_to_sender',
  Unknown = 'unknown',
  UserError = 'user_error'
}

export enum ReplacementRequestProviderCompensation {
  TruepillFull = 'truepill_full',
  Unknown = 'unknown'
}

export enum ReplacementRequestReplacementReason {
  ActivationError_0Reading = 'activation_error_0_reading',
  ActivationErrorActivationLoop = 'activation_error_activation_loop',
  ActivationErrorNoScans = 'activation_error_no_scans',
  Adhesion = 'adhesion',
  AppCrash = 'app_crash',
  ApplicationErrorDeploymentEarlyDeployment = 'application_error_deployment_early_deployment',
  ApplicationErrorDeploymentSensorStuck = 'application_error_deployment_sensor_stuck',
  ApplicationErrorNeedleBent = 'application_error_needle_bent',
  ApplicationErrorNeedleFellOut = 'application_error_needle_fell_out',
  ApplicationErrorNeedleStuck = 'application_error_needle_stuck',
  ApplicationErrorSensorPlacement = 'application_error_sensor_placement',
  ApplicationErrorUnknown = 'application_error_unknown',
  ApplicatorDeploymentError = 'applicator_deployment_error',
  BleedingOrBruising = 'bleeding_or_bruising',
  BriefSensorIssue = 'brief_sensor_issue',
  CalibrationErrorAbnormalData = 'calibration_error_abnormal_data',
  CalibrationErrorHighValues = 'calibration_error_high_values',
  CalibrationErrorLowValues = 'calibration_error_low_values',
  CgmAccuracyHighValues = 'cgm_accuracy_high_values',
  CgmAccuracyLowValues = 'cgm_accuracy_low_values',
  DamageSportsActivity = 'damage_sports_activity',
  DamageWaterSwimmingSauna = 'damage_water_swimming_sauna',
  DamagedInTransit = 'damaged_in_transit',
  DexcomApiBug = 'dexcom_api_bug',
  DexcomApplicatorStuck = 'dexcom_applicator_stuck',
  DexcomCodeIssue = 'dexcom_code_issue',
  DexcomNoCode = 'dexcom_no_code',
  DexcomNoNeedle = 'dexcom_no_needle',
  DexcomNoResponseSupport = 'dexcom_no_response_support',
  DexcomSensorFailure = 'dexcom_sensor_failure',
  DiscomfortDrewBlood = 'discomfort_drew_blood',
  DiscomfortGeneralPain = 'discomfort_general_pain',
  DiscomfortSkinIrritation = 'discomfort_skin_irritation',
  FellOffAdhesiveMalfunction = 'fell_off_adhesive_malfunction',
  FellOffBumped = 'fell_off_bumped',
  FellOffChanging = 'fell_off_changing',
  FellOffDueToPatch = 'fell_off_due_to_patch',
  FellOffShowering = 'fell_off_showering',
  FellOffSleeping = 'fell_off_sleeping',
  FellOffUnknown = 'fell_off_unknown',
  FellOffWorkingOut = 'fell_off_working_out',
  HealthMriXRayImaging = 'health_mri_x_ray_imaging',
  HealthSurgery = 'health_surgery',
  Libre_3ActivationError_0Reading = 'libre_3_activation_error_0_reading',
  Libre_3ActivationErrorActivationLoop = 'libre_3_activation_error_activation_loop',
  Libre_3CalibrationHighValues = 'libre_3_calibration_high_values',
  Libre_3CalibrationLowValues = 'libre_3_calibration_low_values',
  Libre_3InsertionFailed = 'libre_3_insertion_failed',
  Libre_3NoData = 'libre_3_no_data',
  Libre_3SensorFailed = 'libre_3_sensor_failed',
  LibreLinkIntegrationEscalation = 'libre_link_integration_escalation',
  LibreLinkIntegrationIssue = 'libre_link_integration_issue',
  MissingLost = 'missing_lost',
  Other = 'other',
  OtherGeneral = 'other_general',
  OtherRemovedWoTroubleshooting = 'other_removed_wo_troubleshooting',
  OtherRequiredRemoved = 'other_required_removed',
  PairingActivationFailure = 'pairing_activation_failure',
  PhysicalDamageGeneral = 'physical_damage_general',
  ProductEarlyDecline = 'product_early_decline',
  ProductSensorMissing = 'product_sensor_missing',
  Refused = 'refused',
  RemovedWOTroubleshooting = 'removed_w_o_troubleshooting',
  Retention = 'retention',
  ScanningError_0Reading = 'scanning_error_0_reading',
  ScanningErrorNfc = 'scanning_error_nfc',
  SentExpiredSensor = 'sent_expired_sensor',
  ShippingNotReceived = 'shipping_not_received',
  ShippingRefused = 'shipping_refused',
  ShippingSensorMissing = 'shipping_sensor_missing',
  SignalLoss = 'signal_loss',
  SkinReactionPatch = 'skin_reaction_patch',
  SkinReactionSensor = 'skin_reaction_sensor',
  Stolen = 'stolen',
  Unclaimed = 'unclaimed',
  WearableFailureSessionEndedEarly = 'wearable_failure_session_ended_early',
  WireBrokenOrDetached = 'wire_broken_or_detached',
  WrongAddress = 'wrong_address'
}

export type IReplacementRequestReplacementReasonDef = {
  __typename?: 'ReplacementRequestReplacementReasonDef'
  description: Scalars['String']['output']
  key: Scalars['String']['output']
  label: Scalars['String']['output']
}

export enum ReplacementRequestRgaRequired {
  No = 'no',
  Yes = 'yes'
}

export type IReplacementRequestSort = {
  direction: SortDirection
  field: ReplacementRequestSortField
}

export enum ReplacementRequestSortField {
  ChargeAmount = 'charge_amount',
  CreatedAt = 'created_at',
  CreatedByEmail = 'created_by_email',
  CreatedById = 'created_by_id',
  DateFellOff = 'date_fell_off',
  DateNotified = 'date_notified',
  DaysWorn = 'days_worn',
  ErrorType = 'error_type',
  HowItFellOff = 'how_it_fell_off',
  Id = 'id',
  InvoiceStripeId = 'invoice_stripe_id',
  Notes = 'notes',
  ReplacementReason = 'replacement_reason',
  SensorKind = 'sensor_kind',
  SensorModel = 'sensor_model',
  SensorSerialNumber = 'sensor_serial_number',
  State = 'state',
  TestedWithLibreApp = 'tested_with_libre_app',
  UpdatedAt = 'updated_at',
  UserEmail = 'user_email',
  UserId = 'user_id',
  WearingPatch = 'wearing_patch'
}

export enum ReplacementRequestState {
  Completed = 'completed',
  Init = 'init',
  Processing = 'processing'
}

export enum ReplacementRequestTestedWithLibreApp {
  No = 'no',
  Yes = 'yes'
}

export enum ReplacementRequestWearingPatch {
  No = 'no',
  NotApplicable = 'not_applicable',
  Unknown = 'unknown',
  Yes = 'yes'
}

export type IResearchFaqs = {
  __typename?: 'ResearchFaqs'
  dataProtectionUrl: Scalars['String']['output']
  eligibilityUrl: Scalars['String']['output']
  gettingStartedUrl: Scalars['String']['output']
  rootUrl: Scalars['String']['output']
}

export type IResponse = {
  __typename?: 'Response'
  answersGroups?: Maybe<Array<IAnswersGroup>>
  kind: SurveysConfigObjectQuestionsGroupQuestionResponseKind
  kindMetadata?: Maybe<Scalars['JSON']['output']>
}

export enum RestartSurveyLinkQuestionKeys {
  GovernmentIdCard = 'government_id_card'
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayload = {
  __typename?: 'RunActionPayload'
  campaignsAdvanceSequenceStep: IFormulaResult
  campaignsOrchestrate: IFormulaResult
  createSensor: IFormulaResult
  ehrAppointmentsSchedule: IFormulaResult
  ehrCoachesCreateFromStaging: IFormulaResult
  notificationsCreate: IFormulaResult
  uhcStoreCheckout: IFormulaResult
  uhcStoreSamlSignIn: IFormulaResult
  usersInsurancePoliciesUpdateAuthorization: IFormulaResult
  usersInsurancePoliciesUpdateState: IFormulaResult
  usersSignUpMobile: IFormulaResult
  usersSignUpWebsiteCheckout: IFormulaResult
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadCampaignsAdvanceSequenceStepArgs = {
  campaignKind: NotificationEngineCampaignsKind
  userId: Scalars['String']['input']
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadCampaignsOrchestrateArgs = {
  campaignKind: NotificationEngineCampaignsKind
  userId: Scalars['String']['input']
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadCreateSensorArgs = {
  addMeasurementsToExistingSensor?: InputMaybe<Scalars['Boolean']['input']>
  calibration?: InputMaybe<Scalars['Int']['input']>
  measurementsCount?: InputMaybe<Scalars['Int']['input']>
  model: SensorModel
  sensorMode?: InputMaybe<UserExperienceSensorModeKind>
  startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['String']['input']
  withGlucoseData?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadEhrAppointmentsScheduleArgs = {
  appointmentKind: EhrAppointmentKind
  chargeKind: EhrAppointmentAttendanceChargeKind
  coachId: Scalars['String']['input']
  date: Scalars['ISO8601DateTime']['input']
  userId: Scalars['String']['input']
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadEhrCoachesCreateFromStagingArgs = {
  getHealthieId: Scalars['String']['input']
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadNotificationsCreateArgs = {
  content: Scalars['String']['input']
  kind: NotificationEngineNotificationKind
  payloadJson: Scalars['String']['input']
  userId: Scalars['String']['input']
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadUhcStoreCheckoutArgs = {
  orderItemId: Scalars['String']['input']
  product: UhcStoreProduct
  serviceValidUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  uhcId: Scalars['String']['input']
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadUhcStoreSamlSignInArgs = {
  dateOfBirth: Scalars['ISO8601Date']['input']
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  uhcId: Scalars['String']['input']
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadUsersInsurancePoliciesUpdateAuthorizationArgs = {
  userId: Scalars['String']['input']
  visitsAuthorized: Scalars['String']['input']
  visitsLeft: Scalars['String']['input']
  visitsUsed: Scalars['String']['input']
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadUsersInsurancePoliciesUpdateStateArgs = {
  insuranceState: UserInsurancePolicyStateKind
  userId: Scalars['String']['input']
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadUsersSignUpMobileArgs = {
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  password: Scalars['String']['input']
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  phoneNumberConsent?: InputMaybe<Scalars['Boolean']['input']>
  source?: InputMaybe<UserSignUpSource>
}

/** Autogenerated return type of RunAction. */
export type IRunActionPayloadUsersSignUpWebsiteCheckoutArgs = {
  eligibilityConsent?: InputMaybe<Scalars['Boolean']['input']>
  email: Scalars['String']['input']
  fullName: Scalars['String']['input']
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  phoneNumberConsent?: InputMaybe<Scalars['Boolean']['input']>
  product: BillingProduct
  referralPartner: UserReferralPartner
}

export type IScan = {
  __typename?: 'Scan'
  /** @deprecated deprecated in 4.6.1 */
  createdAt: Scalars['ISO8601DateTime']['output']
  /** @deprecated deprecated in 4.6.1 */
  id: Scalars['ID']['output']
  measurements: Array<IMeasurement>
  sensor?: Maybe<ISensor>
}

export type ISchedule = {
  __typename?: 'Schedule'
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentPhaseEndAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  currentPhaseStartAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  phases: Array<ISchedulePhase>
  releasedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  status: SubscriptionScheduleStatus
  stripeId: Scalars['String']['output']
  subscription?: Maybe<ISubscription>
  updatedAt: Scalars['ISO8601DateTime']['output']
  user: IUser
}

export type IScheduleCollection = {
  __typename?: 'ScheduleCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  schedules: Array<ISchedule>
  totalCount: Scalars['Int']['output']
}

export type ISchedulePhase = {
  __typename?: 'SchedulePhase'
  billingCycleAnchorChange?: Maybe<SubscriptionSchedulePhaseBillingCycleAnchorChange>
  createdAt: Scalars['ISO8601DateTime']['output']
  description?: Maybe<Scalars['String']['output']>
  endAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  price: Scalars['Float']['output']
  primaryProduct?: Maybe<IProductMin>
  startAt: Scalars['ISO8601DateTime']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type IScore = {
  __typename?: 'Score'
  danger: Scalars['Int']['output']
  max: Scalars['Int']['output']
  warning: Scalars['Int']['output']
}

export type ISendMfaSmsCode = {
  __typename?: 'SendMfaSmsCode'
  success: Scalars['Boolean']['output']
  userEmail: Scalars['String']['output']
  userMaskedPhoneNumber?: Maybe<Scalars['String']['output']>
}

export type ISensor = {
  __typename?: 'Sensor'
  activationDate: Scalars['ISO8601Date']['output']
  activationTime: Scalars['ISO8601DateTime']['output']
  baselineAdjustment: Scalars['Int']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  daysRemaining: Scalars['Int']['output']
  description: Scalars['String']['output']
  expirationDate: Scalars['ISO8601Date']['output']
  expirationTime: Scalars['ISO8601DateTime']['output']
  expired: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  lastStatusChange?: Maybe<ISensorStatusChange>
  /** @deprecated removed in v5.48.0 */
  model: Scalars['String']['output']
  modelEnum?: Maybe<SensorModel>
  serialNumber: Scalars['String']['output']
  status?: Maybe<Scalars['String']['output']>
}

export type ISensorCollection = {
  __typename?: 'SensorCollection'
  sensors: Array<ISensor>
}

export type ISensorMode = {
  __typename?: 'SensorMode'
  kind: UserExperienceSensorModeKind
  syncDescription: Scalars['String']['output']
}

export enum SensorModel {
  DexcomG6 = 'dexcom_g6',
  DexcomG7 = 'dexcom_g7',
  DexcomG7_15Day = 'dexcom_g7_15_day',
  DexcomOnePlus = 'dexcom_one_plus',
  DexcomStelo = 'dexcom_stelo',
  Libre1 = 'libre1',
  Libre2 = 'libre2',
  Libre2Eu = 'libre2_eu',
  Libre3 = 'libre3',
  LibrePro = 'libre_pro',
  LibreUs = 'libre_us',
  Lingo = 'lingo',
  Unknown = 'unknown'
}

export enum SensorModelsSupportedModelsKind {
  DexcomG7 = 'dexcom_g7',
  DexcomStelo = 'dexcom_stelo',
  Libre3 = 'libre3'
}

export type ISensorSettings = {
  __typename?: 'SensorSettings'
  baselineAdjustmentOptions: Array<INumericalSelect>
}

export enum SensorStatus {
  Active = 'active',
  Error = 'error',
  Expired = 'expired',
  Failure = 'failure',
  InsertionDetection = 'insertion_detection',
  InsertionFailed = 'insertion_failed',
  Paired = 'paired',
  Ready = 'ready',
  Shutdown = 'shutdown',
  Starting = 'starting',
  Unknown = 'unknown'
}

export type ISensorStatusChange = {
  __typename?: 'SensorStatusChange'
  createdAt: Scalars['ISO8601Date']['output']
  failure: Scalars['Boolean']['output']
  status: SensorStatus
}

export type ISettings = {
  __typename?: 'Settings'
  cancellationPolicy: Scalars['String']['output']
  consumerHealthDataPrivacyPolicy: Scalars['String']['output']
  courtesyReminder: Scalars['String']['output']
  hipaaAuthorization: Scalars['String']['output']
  medicalDisclaimer: Scalars['String']['output']
  privacyPolicy: Scalars['String']['output']
  supportForm: Scalars['String']['output']
  telehealth: Scalars['String']['output']
  termsOfUse: Scalars['String']['output']
}

export type IShipment = {
  __typename?: 'Shipment'
  address: IAddress
  addressId: Scalars['Int']['output']
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  eta?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['Int']['output']
  location?: Maybe<Scalars['String']['output']>
  lotNumber?: Maybe<Scalars['String']['output']>
  order: IOrder
  orderId: Scalars['Int']['output']
  provider?: Maybe<ShippingOrderProvider>
  providerError?: Maybe<Scalars['String']['output']>
  providerReceivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  providerShipmentId?: Maybe<Scalars['ID']['output']>
  quantity: Scalars['Int']['output']
  shippedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  status?: Maybe<ShippingShipmentStatus>
  trackingNumber?: Maybe<Scalars['String']['output']>
  trackingUrl?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  user?: Maybe<IUser>
}

export type IShipmentDynamicFilter = {
  field: ShipmentDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum ShipmentDynamicFilterField {
  AddressCity = 'address_city',
  AddressCountry = 'address_country',
  AddressId = 'address_id',
  AddressName = 'address_name',
  AddressState = 'address_state',
  AddressStreet = 'address_street',
  AddressStreet_2 = 'address_street_2',
  AddressZipCode = 'address_zip_code',
  CanceledAt = 'canceled_at',
  CreatedAt = 'created_at',
  DeliveredAt = 'delivered_at',
  Eta = 'eta',
  Id = 'id',
  Location = 'location',
  LotNumber = 'lot_number',
  OrderCreatedAt = 'order_created_at',
  OrderId = 'order_id',
  OrderInvoiceStripeId = 'order_invoice_stripe_id',
  OrderNotes = 'order_notes',
  OrderProduct = 'order_product',
  OrderProductType = 'order_product_type',
  OrderQuantity = 'order_quantity',
  OrderReplacementRequestProviderCompensation = 'order_replacement_request_provider_compensation',
  OrderReplacementRequestRgaRequired = 'order_replacement_request_rga_required',
  OrderSensorKind = 'order_sensor_kind',
  OrderUpdatedAt = 'order_updated_at',
  Provider = 'provider',
  ProviderError = 'provider_error',
  ProviderReceivedAt = 'provider_received_at',
  ProviderShipmentId = 'provider_shipment_id',
  Quantity = 'quantity',
  ShippedAt = 'shipped_at',
  Status = 'status',
  TrackingNumber = 'tracking_number',
  TrackingUrl = 'tracking_url',
  UpdatedAt = 'updated_at',
  UserDateOfBirth = 'user_date_of_birth',
  UserEmail = 'user_email',
  UserFirstName = 'user_first_name',
  UserFullName = 'user_full_name',
  UserId = 'user_id',
  UserLastName = 'user_last_name',
  UserPhoneNumber = 'user_phone_number',
  UserSex = 'user_sex',
  UserTruepillPatientToken = 'user_truepill_patient_token'
}

export type IShipmentDynamicFilterItem = {
  items: Array<IShipmentDynamicFilter>
  operator: DynamicFilterOperator
}

export type IShipmentSort = {
  direction: SortDirection
  field: ShipmentSortField
}

export enum ShipmentSortField {
  AddressCity = 'address_city',
  AddressCountry = 'address_country',
  AddressId = 'address_id',
  AddressName = 'address_name',
  AddressState = 'address_state',
  AddressStreet = 'address_street',
  AddressStreet_2 = 'address_street_2',
  AddressZipCode = 'address_zip_code',
  CanceledAt = 'canceled_at',
  CreatedAt = 'created_at',
  DeliveredAt = 'delivered_at',
  Eta = 'eta',
  Id = 'id',
  Location = 'location',
  OrderCreatedAt = 'order_created_at',
  OrderId = 'order_id',
  OrderInvoiceStripeId = 'order_invoice_stripe_id',
  OrderNotes = 'order_notes',
  OrderProduct = 'order_product',
  OrderProductType = 'order_product_type',
  OrderQuantity = 'order_quantity',
  OrderSensorKind = 'order_sensor_kind',
  OrderUpdatedAt = 'order_updated_at',
  Provider = 'provider',
  ProviderError = 'provider_error',
  ProviderReceivedAt = 'provider_received_at',
  ProviderShipmentId = 'provider_shipment_id',
  Quantity = 'quantity',
  ShippedAt = 'shipped_at',
  Status = 'status',
  TrackingNumber = 'tracking_number',
  TrackingUrl = 'tracking_url',
  UpdatedAt = 'updated_at',
  UserDateOfBirth = 'user_date_of_birth',
  UserEmail = 'user_email',
  UserFirstName = 'user_first_name',
  UserFullName = 'user_full_name',
  UserId = 'user_id',
  UserLastName = 'user_last_name',
  UserPhoneNumber = 'user_phone_number',
  UserSex = 'user_sex',
  UserTruepillPatientToken = 'user_truepill_patient_token'
}

export enum ShippingAmazonOrderStatus {
  Canceled = 'canceled',
  InvoiceUnconfirmed = 'invoice_unconfirmed',
  PartiallyShipped = 'partially_shipped',
  Pending = 'pending',
  PendingAvailability = 'pending_availability',
  Shipped = 'shipped',
  Unfulfillable = 'unfulfillable',
  Unshipped = 'unshipped'
}

export enum ShippingOrderIncludable {
  Regular = 'regular',
  WelcomeKit = 'welcome_kit'
}

export enum ShippingOrderProductType {
  Cgm = 'cgm',
  FreeReplacement = 'free_replacement',
  NoShipping = 'no_shipping',
  PaidReplacement = 'paid_replacement',
  Patch = 'patch',
  Semaglutide = 'semaglutide',
  WelcomeKit = 'welcome_kit'
}

export enum ShippingOrderProvider {
  AmazonEasyship = 'amazon_easyship',
  Avery = 'avery',
  Easyship = 'easyship',
  GiftHealth = 'gift_health',
  GiftHealthManual = 'gift_health_manual',
  Nutrisense = 'nutrisense',
  Precision = 'precision',
  Truepill = 'truepill'
}

export type IShippingRule = {
  __typename?: 'ShippingRule'
  recurring: Scalars['Boolean']['output']
  recurringInvoiceInterval: Scalars['Int']['output']
  shippingType: ShippingOrderProductType
}

export enum ShippingShipmentStatus {
  Canceled = 'canceled',
  Delivered = 'delivered',
  Failure = 'failure',
  Returned = 'returned',
  Shipped = 'shipped'
}

export type IShowAlertOnCloseBehavior = {
  __typename?: 'ShowAlertOnCloseBehavior'
  body: Scalars['String']['output']
  cancelTitle: Scalars['String']['output']
  confirmTitle: Scalars['String']['output']
  icon?: Maybe<UiIcon>
  title: Scalars['String']['output']
}

export type ISignup = {
  __typename?: 'Signup'
  learnMore: Scalars['String']['output']
}

export type ISingleValueMeasurement = {
  __typename?: 'SingleValueMeasurement'
  value: Scalars['Float']['output']
}

export type ISnapshot = {
  __typename?: 'Snapshot'
  data: Scalars['JSON']['output']
  snapshotKey: Scalars['String']['output']
}

export type ISnapshotCollection = {
  __typename?: 'SnapshotCollection'
  snapshotKeys: Array<Scalars['String']['output']>
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type IStat = {
  __typename?: 'Stat'
  mean: Scalars['Float']['output']
}

export type IStatMeta = {
  __typename?: 'StatMeta'
  key: Scalars['String']['output']
  section: Scalars['String']['output']
}

export type IStatRange = {
  __typename?: 'StatRange'
  danger?: Maybe<Scalars['Float']['output']>
  max?: Maybe<Scalars['Float']['output']>
  min?: Maybe<Scalars['Float']['output']>
  reverse?: Maybe<Scalars['Boolean']['output']>
  warning?: Maybe<Scalars['Float']['output']>
}

export type IState = {
  __typename?: 'State'
  abbreviation: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type IStateLicence = {
  __typename?: 'StateLicence'
  document?: Maybe<Scalars['String']['output']>
  expirationDate: Scalars['ISO8601Date']['output']
  expirationReminderEnabled: Scalars['Boolean']['output']
  state: AddressState
}

export type IStateLicenceDetail = {
  document?: InputMaybe<Scalars['Upload']['input']>
  expirationDate: Scalars['ISO8601Date']['input']
  expirationReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>
  state: AddressState
}

export type IStatistic = {
  __typename?: 'Statistic'
  change: Scalars['Int']['output']
  description: Scalars['String']['output']
  displayValue?: Maybe<Scalars['String']['output']>
  meta: IStatMeta
  range: IStatRange
  title: Scalars['String']['output']
  type: Scalars['String']['output']
  units: Scalars['String']['output']
  value: Scalars['Float']['output']
  valuePrev: Scalars['Float']['output']
}

export type IStatistics = {
  __typename?: 'Statistics'
  imperial: IConfigUnit
  metric: IConfigUnit
  name: Scalars['String']['output']
}

export type IStats = {
  __typename?: 'Stats'
  statistics: Array<IStatistic>
}

export type IStatsConfig = {
  __typename?: 'StatsConfig'
  filters: IStatsFilters
}

export type IStatsFilters = {
  __typename?: 'StatsFilters'
  types: Array<IKeyValuePairStringArray>
}

export type IStatsSettings = {
  __typename?: 'StatsSettings'
  key: Scalars['String']['output']
  order: Scalars['Int']['output']
  section: Scalars['String']['output']
  visible: Scalars['Boolean']['output']
}

export type IStatsSettingsOrder = {
  key: Scalars['String']['input']
  order: Scalars['Int']['input']
  section: Scalars['String']['input']
  visible: Scalars['Boolean']['input']
}

export type IStringPair = {
  __typename?: 'StringPair'
  displayValue?: Maybe<Scalars['String']['output']>
  /** @deprecated Removed in v3.9.1 */
  name?: Maybe<Scalars['String']['output']>
  x: Scalars['String']['output']
  y?: Maybe<Scalars['Numeric']['output']>
}

export type IStringSelect = {
  __typename?: 'StringSelect'
  text: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ISubmitCoachProfileResult = {
  __typename?: 'SubmitCoachProfileResult'
  missingFields: Array<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type ISubscription = {
  __typename?: 'Subscription'
  allowedPauseCycles: Scalars['Int']['output']
  attachedSchedule?: Maybe<ISchedule>
  cancelAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  checkoutOptions: Array<ICheckoutOption>
  commitmentEndAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentPeriodEndAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  currentPeriodStartAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  dietitianAddOn: Scalars['Boolean']['output']
  discountedPrice: Scalars['Float']['output']
  effectivelyActive: Scalars['Boolean']['output']
  endAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  latestInvoice?: Maybe<IInvoice>
  paidMonthsCount: Scalars['Int']['output']
  paused: Scalars['Boolean']['output']
  pausedMonthsCount: Scalars['Int']['output']
  /** @deprecated Removed usage in v2.7.0 */
  plans: Array<IPlan>
  price: Scalars['Float']['output']
  /** @deprecated Use price and primary_product */
  primaryPlan: IPlan
  primaryProduct: IProductMin
  resetBillingCycleAnchorAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  resumesAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  startAt: Scalars['ISO8601DateTime']['output']
  status: SubscriptionStatus
  stripeId: Scalars['String']['output']
  /** @deprecated Use status enum field */
  stripeStatus: Scalars['String']['output']
  subscribedAt: Scalars['ISO8601DateTime']['output']
  trialEndAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  uhcStoreSubscription?: Maybe<IUhcStoreSubscription>
  updatedAt: Scalars['ISO8601DateTime']['output']
  user: IUser
}

export enum SubscriptionCheckoutOptionKind {
  Prescription = 'prescription',
  Research = 'research',
  Stelo = 'stelo'
}

export type ISubscriptionCollection = {
  __typename?: 'SubscriptionCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  subscriptions: Array<ISubscription>
  totalCount: Scalars['Int']['output']
}

export type ISubscriptionDynamicFilter = {
  field: SubscriptionDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum SubscriptionDynamicFilterField {
  CancelAt = 'cancel_at',
  CanceledAt = 'canceled_at',
  CreatedAt = 'created_at',
  CurrentPeriodEndAt = 'current_period_end_at',
  EndAt = 'end_at',
  PaidMonthsCount = 'paid_months_count',
  Paused = 'paused',
  PausedMonthsCount = 'paused_months_count',
  Plans = 'plans',
  ResumesAt = 'resumes_at',
  StartAt = 'start_at',
  Status = 'status',
  StripeId = 'stripe_id',
  /** @deprecated use status */
  StripeStatus = 'stripe_status',
  SubscribedAt = 'subscribed_at',
  TrialEndAt = 'trial_end_at',
  UpdatedAt = 'updated_at',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name',
  UserId = 'user_id'
}

export type ISubscriptionDynamicFilterItem = {
  items: Array<ISubscriptionDynamicFilter>
  operator: DynamicFilterOperator
}

export type ISubscriptionScheduleDynamicFilter = {
  field: SubscriptionScheduleDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum SubscriptionScheduleDynamicFilterField {
  CanceledAt = 'canceled_at',
  CompletedAt = 'completed_at',
  CreatedAt = 'created_at',
  CurrentPhaseEndAt = 'current_phase_end_at',
  CurrentPhaseStartAt = 'current_phase_start_at',
  Id = 'id',
  ReleasedAt = 'released_at',
  Status = 'status',
  StripeId = 'stripe_id',
  SubscriptionId = 'subscription_id',
  UpdatedAt = 'updated_at',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name',
  UserId = 'user_id'
}

export type ISubscriptionScheduleDynamicFilterItem = {
  items: Array<ISubscriptionScheduleDynamicFilter>
  operator: DynamicFilterOperator
}

export enum SubscriptionSchedulePhaseBillingCycleAnchorChange {
  Automatic = 'automatic',
  PhaseStart = 'phase_start'
}

export enum SubscriptionScheduleStatus {
  Active = 'active',
  Canceled = 'canceled',
  Completed = 'completed',
  NotStarted = 'not_started',
  Released = 'released'
}

export type ISubscriptionSort = {
  direction: SortDirection
  field: SubscriptionSortField
}

export enum SubscriptionSortField {
  CancelAt = 'cancel_at',
  CanceledAt = 'canceled_at',
  CreatedAt = 'created_at',
  CurrentPeriodEndAt = 'current_period_end_at',
  EndAt = 'end_at',
  PaidMonthsCount = 'paid_months_count',
  Paused = 'paused',
  PausedMonthsCount = 'paused_months_count',
  Plans = 'plans',
  ResumesAt = 'resumes_at',
  StartAt = 'start_at',
  Status = 'status',
  StripeId = 'stripe_id',
  /** @deprecated use status */
  StripeStatus = 'stripe_status',
  SubscribedAt = 'subscribed_at',
  TrialEndAt = 'trial_end_at',
  UpdatedAt = 'updated_at',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name'
}

export enum SubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type ISuccess = {
  __typename?: 'Success'
  success: Scalars['Boolean']['output']
}

export type ISurvey = {
  __typename?: 'Survey'
  /** @deprecated use survey_link.early_exit_deep_link instead */
  allowEarlyExitBehavior?: Maybe<IAllowEarlyExitBehavior>
  behavior: IBehavior
  completedScreen?: Maybe<ICompletedScreen>
  completionFlashMessage?: Maybe<Scalars['String']['output']>
  followups: Array<IFollowup>
  header?: Maybe<Scalars['String']['output']>
  kind: SurveysConfigKind
  questionsGroups: Array<IQuestionsGroup>
  /** @deprecated Removed in v5.23.0 */
  research: Scalars['Boolean']['output']
  showAlertOnCloseBehavior?: Maybe<IShowAlertOnCloseBehavior>
  version: Scalars['String']['output']
}

export enum SurveyConfigItem {
  CompletedScreen = 'completed_screen',
  IntroScreen = 'intro_screen',
  Question = 'question'
}

export type ISurveyLink = {
  __typename?: 'SurveyLink'
  completionDeepLink?: Maybe<Scalars['String']['output']>
  config: ISurveyLinkConfig
  earlyExitDeepLink?: Maybe<Scalars['String']['output']>
  finished: Scalars['Boolean']['output']
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  inProgress: Scalars['Boolean']['output']
  outcome?: Maybe<IOutcome>
  responses: Array<ISurveyResponse>
  startedAt: Scalars['ISO8601DateTime']['output']
  state: SurveysUserLinkState
  survey: ISurvey
  user?: Maybe<IUser>
}

export type ISurveyLinkCollection = {
  __typename?: 'SurveyLinkCollection'
  surveyLinks: Array<ISurveyLink>
}

export type ISurveyLinkConfig = {
  __typename?: 'SurveyLinkConfig'
  currentItemIndex: Scalars['Int']['output']
  items: Array<ISurveyLinkConfigItem>
  questionsCount: Scalars['Int']['output']
  sectionsCount: Scalars['Int']['output']
}

export type ISurveyLinkConfigCompletedItem = {
  __typename?: 'SurveyLinkConfigCompletedItem'
  footnote?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  icon?: Maybe<UiIcon>
  iconColor?: Maybe<UiColor>
  introMarkdown?: Maybe<Scalars['String']['output']>
  primaryActionText?: Maybe<Scalars['String']['output']>
  secondaryActionLink?: Maybe<ILink>
  showCoachPhoto: Scalars['Boolean']['output']
  title?: Maybe<Scalars['String']['output']>
  type: SurveyConfigItem
}

export type ISurveyLinkConfigIntroItem = {
  __typename?: 'SurveyLinkConfigIntroItem'
  footnote?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  icon?: Maybe<UiIcon>
  imageUrl?: Maybe<Scalars['String']['output']>
  inlineAlert?: Maybe<IInlineAlert>
  introMarkdown?: Maybe<Scalars['String']['output']>
  type: SurveyConfigItem
}

export type ISurveyLinkConfigItem =
  | ISurveyLinkConfigCompletedItem
  | ISurveyLinkConfigIntroItem
  | ISurveyLinkConfigQuestionItem

export type ISurveyLinkConfigQuestionItem = {
  __typename?: 'SurveyLinkConfigQuestionItem'
  actionButtonText?: Maybe<Scalars['String']['output']>
  coachBubbleLabel?: Maybe<Scalars['String']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  key: SurveysQuestionKey
  label?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  primaryActionLink?: Maybe<ILink>
  required: Scalars['Boolean']['output']
  response: IResponse
  secondaryActionLink?: Maybe<ILink>
  type: SurveyConfigItem
}

export type ISurveyLinkDynamicFilter = {
  field: SurveyLinkDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum SurveyLinkDynamicFilterField {
  FinishedAt = 'finished_at',
  StartedAt = 'started_at',
  State = 'state',
  SurveyKind = 'survey_kind',
  SurveyVersion = 'survey_version',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name'
}

export type ISurveyLinkDynamicFilterItem = {
  items: Array<ISurveyLinkDynamicFilter>
  operator: DynamicFilterOperator
}

export type ISurveyLinkSort = {
  direction: SortDirection
  field: SurveyLinkSortField
}

export enum SurveyLinkSortField {
  FinishedAt = 'finished_at',
  StartedAt = 'started_at',
  State = 'state',
  SurveyKind = 'survey_kind',
  SurveyVersion = 'survey_version',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name'
}

export type ISurveyResponse = {
  __typename?: 'SurveyResponse'
  answer: Scalars['JSON']['output']
  id: Scalars['ID']['output']
  questionKey: SurveysQuestionKey
  surveyLink: ISurveyLink
}

export enum SurveysConfigKind {
  AccountInterest = 'account_interest',
  BiosensorRequirements = 'biosensor_requirements',
  Cancellation = 'cancellation',
  CareEligibility = 'care_eligibility',
  CareIntake = 'care_intake',
  CareLabWorkResults = 'care_lab_work_results',
  CareRenewal = 'care_renewal',
  CgmMedicalDisclaimer = 'cgm_medical_disclaimer',
  CgmPrerequisite = 'cgm_prerequisite',
  ChurnFeedback = 'churn_feedback',
  CoachingGoalsAndPreferences = 'coaching_goals_and_preferences',
  ConstructiveFeedback = 'constructive_feedback',
  Demographics = 'demographics',
  DexcomResearchConsent = 'dexcom_research_consent',
  DietaryHabits = 'dietary_habits',
  DppEligibility = 'dpp_eligibility',
  DppEnrollment = 'dpp_enrollment',
  DppEvidence = 'dpp_evidence',
  DppScheduling = 'dpp_scheduling',
  ExerciseHabits = 'exercise_habits',
  Goals = 'goals',
  GovernmentId = 'government_id',
  GroupVideoCallsEligibility = 'group_video_calls_eligibility',
  GroupVideoCallsInsuranceIneligible = 'group_video_calls_insurance_ineligible',
  Health = 'health',
  HealthCoachingPostCallFeedback = 'health_coaching_post_call_feedback',
  HealthCoachingPostCallFeedbackLowRating = 'health_coaching_post_call_feedback_low_rating',
  HealthUpdate = 'health_update',
  Insurance = 'insurance',
  InsuranceCallHesitation = 'insurance_call_hesitation',
  InsuranceEarlyExit = 'insurance_early_exit',
  InsuranceFallback = 'insurance_fallback',
  MedicalDisclaimer = 'medical_disclaimer',
  MedicalHistory = 'medical_history',
  MentalHealthServicesInterest = 'mental_health_services_interest',
  MidpointPulse = 'midpoint_pulse',
  NetPromoterScore = 'net_promoter_score',
  NutritionistReferral = 'nutritionist_referral',
  OnboardingExperienceBasicInformation = 'onboarding_experience_basic_information',
  OnboardingExperienceGoals = 'onboarding_experience_goals',
  OnboardingExperiencePace = 'onboarding_experience_pace',
  OneMonthActiveFeedback = 'one_month_active_feedback',
  OwnSensor = 'own_sensor',
  OwnSensorGoal = 'own_sensor_goal',
  PostCallFeedback = 'post_call_feedback',
  PostCallFeedbackLowRating = 'post_call_feedback_low_rating',
  PostCoachSwitch = 'post_coach_switch',
  ProductMarketFit = 'product_market_fit',
  RecurringSubscriptionConsent = 'recurring_subscription_consent',
  SatisfactionRating = 'satisfaction_rating',
  SleepHabits = 'sleep_habits',
  SteloEligibility = 'stelo_eligibility',
  VideoCallFeedback = 'video_call_feedback',
  VideoCallsSteloUpsellReferral = 'video_calls_stelo_upsell_referral',
  WeightLossExperienceDesiredWeight = 'weight_loss_experience_desired_weight',
  WeightLossExperienceGoalsAndHabits = 'weight_loss_experience_goals_and_habits',
  WeightLossExperiencePace = 'weight_loss_experience_pace'
}

export enum SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswerFollowupKind {
  Inline = 'inline',
  Standalone = 'standalone'
}

export enum SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswersOrder {
  Random = 'random',
  Serial = 'serial'
}

export enum SurveysConfigObjectQuestionsGroupQuestionResponseKind {
  Address = 'address',
  CheckboxMulti = 'checkbox_multi',
  Consent = 'consent',
  DateInput = 'date_input',
  FileUpload = 'file_upload',
  HeightImperial = 'height_imperial',
  LikertScale = 'likert_scale',
  PhoneNumber = 'phone_number',
  Radio = 'radio',
  Ruler = 'ruler',
  SelectSingle = 'select_single',
  Slider = 'slider',
  SliderWithSkip = 'slider_with_skip',
  TabsTextInput = 'tabs_text_input',
  TextArea = 'text_area',
  TextAreaWithSkip = 'text_area_with_skip',
  TextInput = 'text_input'
}

export enum SurveysQuestionKey {
  Address = 'address',
  AdhesiveAllergy = 'adhesive_allergy',
  AetnaInsurancePlanType = 'aetna_insurance_plan_type',
  AgeRange = 'age_range',
  AlcoholicBeveragesFrequency = 'alcoholic_beverages_frequency',
  AnnualIncomeRange = 'annual_income_range',
  AnthemInsurancePlanType = 'anthem_insurance_plan_type',
  AnythingElse = 'anything_else',
  AppetiteChange = 'appetite_change',
  AppetiteLevel = 'appetite_level',
  AvoidingDiabetesPriority = 'avoiding_diabetes_priority',
  BedtimeRoutine = 'bedtime_routine',
  BedtimeRoutineOther = 'bedtime_routine_other',
  BetterStatementAboutOwnHealth = 'better_statement_about_own_health',
  BiologicalSex = 'biological_sex',
  BirthDate = 'birth_date',
  BloodPressureRisk = 'blood_pressure_risk',
  BloodTestRisk = 'blood_test_risk',
  BlueCrossBlueShieldInsurancePlanType = 'blue_cross_blue_shield_insurance_plan_type',
  Bmi = 'bmi',
  BmiRange = 'bmi_range',
  BodyFat = 'body_fat',
  BodyPhoto = 'body_photo',
  BreakfastFrequency = 'breakfast_frequency',
  CancellationReason = 'cancellation_reason',
  CancellationReasonOther = 'cancellation_reason_other',
  CancerTreatment = 'cancer_treatment',
  CgmDevice = 'cgm_device',
  CgmDeviceOther = 'cgm_device_other',
  ChurnFeedbackCustomerSupportReason = 'churn_feedback_customer_support_reason',
  ChurnFeedbackCustomerSupportReasonOther = 'churn_feedback_customer_support_reason_other',
  ChurnFeedbackInsuranceManagementReason = 'churn_feedback_insurance_management_reason',
  ChurnFeedbackInsuranceManagementReasonOther = 'churn_feedback_insurance_management_reason_other',
  ChurnFeedbackMainAreaNotMetExpectations = 'churn_feedback_main_area_not_met_expectations',
  ChurnFeedbackMainAreaNotMetExpectationsOther = 'churn_feedback_main_area_not_met_expectations_other',
  ChurnFeedbackNutritionistServiceReason = 'churn_feedback_nutritionist_service_reason',
  ChurnFeedbackNutritionistServiceReasonOther = 'churn_feedback_nutritionist_service_reason_other',
  ChurnFeedbackTimingConstraintsReason = 'churn_feedback_timing_constraints_reason',
  ChurnFeedbackTimingConstraintsReasonOther = 'churn_feedback_timing_constraints_reason_other',
  CignaInsurancePlanType = 'cigna_insurance_plan_type',
  CoachBetterSupport = 'coach_better_support',
  CoachFocus = 'coach_focus',
  CoachGoalsOpenToPhysicalActivityChanges = 'coach_goals_open_to_physical_activity_changes',
  CoachSwitchReason = 'coach_switch_reason',
  CoachSwitchReasonOther = 'coach_switch_reason_other',
  CoachValueSoFar = 'coach_value_so_far',
  CoachingExperienceIssuesDetails = 'coaching_experience_issues_details',
  CoachingExperienceIssuesDetailsOther = 'coaching_experience_issues_details_other',
  CoachingGoalsAdditionalGoals = 'coaching_goals_additional_goals',
  CoachingGoalsAdditionalGoalsOther = 'coaching_goals_additional_goals_other',
  CoachingGoalsBiggestChallenges = 'coaching_goals_biggest_challenges',
  CoachingGoalsBiggestChallengesOther = 'coaching_goals_biggest_challenges_other',
  CoachingGoalsCurrentDiet = 'coaching_goals_current_diet',
  CoachingGoalsMotivationToChangeEatingHabits = 'coaching_goals_motivation_to_change_eating_habits',
  CoachingGoalsPhysicalActivity = 'coaching_goals_physical_activity',
  CoachingGoalsStyle = 'coaching_goals_style',
  CoachingStyle = 'coaching_style',
  CommunicationFrequency = 'communication_frequency',
  ComplimentarySupportDecision = 'complimentary_support_decision',
  CompoundedSemaglutideConsent = 'compounded_semaglutide_consent',
  ConfidentInterpretGlucoseData = 'confident_interpret_glucose_data',
  ConfirmReject = 'confirm_reject',
  CurrentHba1cLevel = 'current_hba1c_level',
  DairyProductsFrequency = 'dairy_products_frequency',
  DefineProgress = 'define_progress',
  DescribesYou = 'describes_you',
  DescribesYouOther = 'describes_you_other',
  DexcomAppCompatibility = 'dexcom_app_compatibility',
  DexcomResearchConsent = 'dexcom_research_consent',
  Diabetes = 'diabetes',
  DiabetesDiagnosis = 'diabetes_diagnosis',
  DiabetesMedication = 'diabetes_medication',
  DiagnosedConditions = 'diagnosed_conditions',
  DiagnosedConditions2 = 'diagnosed_conditions2',
  DiagnosedConditionsOther = 'diagnosed_conditions_other',
  Diet = 'diet',
  DietOther = 'diet_other',
  DietaryGuidelinesRestrictions = 'dietary_guidelines_restrictions',
  DietaryGuidelinesRestrictionsOther = 'dietary_guidelines_restrictions_other',
  DietaryHabitsChanges = 'dietary_habits_changes',
  DietaryHabitsChangesDetails = 'dietary_habits_changes_details',
  DietaryHabitsChangesDetailsOther = 'dietary_habits_changes_details_other',
  DinnerFrequency = 'dinner_frequency',
  Disabilities = 'disabilities',
  DiscoverNs = 'discover_ns',
  DiscoverNsBlog = 'discover_ns_blog',
  DiscoverNsDoctor = 'discover_ns_doctor',
  DiscoverNsFacebook = 'discover_ns_facebook',
  DiscoverNsFamily = 'discover_ns_family',
  DiscoverNsFriend = 'discover_ns_friend',
  DiscoverNsInfluencer = 'discover_ns_influencer',
  DiscoverNsInstagram = 'discover_ns_instagram',
  DiscoverNsLinkedin = 'discover_ns_linkedin',
  DiscoverNsMagazine = 'discover_ns_magazine',
  DiscoverNsMedia = 'discover_ns_media',
  DiscoverNsNewsletter = 'discover_ns_newsletter',
  DiscoverNsOther = 'discover_ns_other',
  DiscoverNsPinterest = 'discover_ns_pinterest',
  DiscoverNsPodcast = 'discover_ns_podcast',
  DiscoverNsRadio = 'discover_ns_radio',
  DiscoverNsReddit = 'discover_ns_reddit',
  DiscoverNsSearchEngine = 'discover_ns_search_engine',
  DiscoverNsTikTok = 'discover_ns_tik_tok',
  DiscoverNsTwitter = 'discover_ns_twitter',
  DiscoverNsYoutube = 'discover_ns_youtube',
  DppCommercialInsurancePlan = 'dpp_commercial_insurance_plan',
  DppCommercialInsurancePlanOther = 'dpp_commercial_insurance_plan_other',
  DppHbA1cEvidence = 'dpp_hb_a1c_evidence',
  DppHealthcareProfessionalRecommendation = 'dpp_healthcare_professional_recommendation',
  DppInsurancePlan = 'dpp_insurance_plan',
  DppPreferredCallDays = 'dpp_preferred_call_days',
  DppPreferredCallTimes = 'dpp_preferred_call_times',
  DppProgramMotivation = 'dpp_program_motivation',
  EarliestWakeUpTime = 'earliest_wake_up_time',
  EatOutFrequency = 'eat_out_frequency',
  EatingDisorder = 'eating_disorder',
  EatingDisorderType = 'eating_disorder_type',
  EducationLevel = 'education_level',
  EducationLevelOther = 'education_level_other',
  ElectronicDevicesBeforeBedtime = 'electronic_devices_before_bedtime',
  EmploymentStatus = 'employment_status',
  EmploymentStatusOther = 'employment_status_other',
  EnergyLevelsChanges = 'energy_levels_changes',
  Ethnicity = 'ethnicity',
  EthnicityOther = 'ethnicity_other',
  ExerciseDuration = 'exercise_duration',
  ExerciseHabitsChanges = 'exercise_habits_changes',
  ExerciseHabitsChangesDetails = 'exercise_habits_changes_details',
  ExerciseHabitsChangesDetailsOther = 'exercise_habits_changes_details_other',
  ExerciseLocation = 'exercise_location',
  ExerciseLocationOther = 'exercise_location_other',
  ExerciseMotivation = 'exercise_motivation',
  ExerciseMotivationOther = 'exercise_motivation_other',
  ExerciseTypes = 'exercise_types',
  ExerciseTypesOther = 'exercise_types_other',
  FallAsleepTime = 'fall_asleep_time',
  FamiliarPrediabeticsConfirmation = 'familiar_prediabetics_confirmation',
  FamilyDiabetes = 'family_diabetes',
  FamilyMedicalConditions = 'family_medical_conditions',
  FastingGlucoseToleranceBloodTest = 'fasting_glucose_tolerance_blood_test',
  FishSeafoodFrequency = 'fish_seafood_frequency',
  FoodAllergies = 'food_allergies',
  FoodAllergiesIntolerances = 'food_allergies_intolerances',
  FoodAllergiesIntolerancesOther = 'food_allergies_intolerances_other',
  FoodAllergiesOther = 'food_allergies_other',
  FoodCravings = 'food_cravings',
  FoodCravingsChange = 'food_cravings_change',
  FoodCravingsDescription = 'food_cravings_description',
  FoodSymptoms = 'food_symptoms',
  FoodSymptomsOther = 'food_symptoms_other',
  FruitsVegetablesFrequency = 'fruits_vegetables_frequency',
  Gender = 'gender',
  GestationalDiabetesDiagnosis = 'gestational_diabetes_diagnosis',
  GlpActivePrescription = 'glp_active_prescription',
  GlpAdditionalHealthConditions = 'glp_additional_health_conditions',
  GlpCommonSideEffects = 'glp_common_side_effects',
  GlpConditions = 'glp_conditions',
  GlpConsiderPregnant = 'glp_consider_pregnant',
  GlpCurrentDose = 'glp_current_dose',
  GlpDosePreference = 'glp_dose_preference',
  GlpDoseScheduleAdherence = 'glp_dose_schedule_adherence',
  GlpDoseScheduleAdherenceDescription = 'glp_dose_schedule_adherence_description',
  GlpElevatedTriglycerides = 'glp_elevated_triglycerides',
  GlpElevatedTriglyceridesValue = 'glp_elevated_triglycerides_value',
  GlpFutureMonthsMedication = 'glp_future_months_medication',
  GlpGallbladderDisease = 'glp_gallbladder_disease',
  GlpGallbladderRemoved = 'glp_gallbladder_removed',
  GlpGastricBypassSurgery = 'glp_gastric_bypass_surgery',
  GlpGastricBypassSurgeryDate = 'glp_gastric_bypass_surgery_date',
  GlpGastricBypassSurgeryType = 'glp_gastric_bypass_surgery_type',
  GlpGoal = 'glp_goal',
  GlpGoalOther = 'glp_goal_other',
  GlpHeaviestWeightInPounds = 'glp_heaviest_weight_in_pounds',
  GlpHistoryBipolarDepression = 'glp_history_bipolar_depression',
  GlpIncreasePhysicalActivity = 'glp_increase_physical_activity',
  GlpIndianAsianDescent = 'glp_indian_asian_descent',
  GlpKidneyDisease = 'glp_kidney_disease',
  GlpKidneyDiseaseGfr = 'glp_kidney_disease_gfr',
  GlpLabWorkResults = 'glp_lab_work_results',
  GlpLastInPersonMedicalEvaluationDate = 'glp_last_in_person_medical_evaluation_date',
  GlpMedicationChallenges = 'glp_medication_challenges',
  GlpMedicationChallengesDescription = 'glp_medication_challenges_description',
  GlpMedicationQualityOfLife = 'glp_medication_quality_of_life',
  GlpOtherDose = 'glp_other_dose',
  GlpOtherSideEffects = 'glp_other_side_effects',
  GlpPhysicianQuestions = 'glp_physician_questions',
  GlpPrescriptionMedications = 'glp_prescription_medications',
  GlpPrescriptionMedicationsList = 'glp_prescription_medications_list',
  GlpProgressRate = 'glp_progress_rate',
  GlpProviderQuestions = 'glp_provider_questions',
  GlpPsychiatricFacility = 'glp_psychiatric_facility',
  GlpReduceCaloricIntake = 'glp_reduce_caloric_intake',
  GlpRestrictedConditions = 'glp_restricted_conditions',
  GlpSevereSideEffects = 'glp_severe_side_effects',
  GlpTakingWeightMedication = 'glp_taking_weight_medication',
  GlpTriedWeightManagement = 'glp_tried_weight_management',
  GlpTriedWeightManagementOther = 'glp_tried_weight_management_other',
  GlpWeightGoalInPounds = 'glp_weight_goal_in_pounds',
  GlucoseManagementKnowledge = 'glucose_management_knowledge',
  GoalsPrevention = 'goals_prevention',
  GoalsPreventionOther = 'goals_prevention_other',
  GotWhatNeededDetails = 'got_what_needed_details',
  GotWhatNeededMostHelpful = 'got_what_needed_most_helpful',
  GovernmentIdCard = 'government_id_card',
  GroupCoachingParticipation = 'group_coaching_participation',
  HadIssuesWithExperienceDetails = 'had_issues_with_experience_details',
  HavingOwnHealthUpsAndDownsConfirmation = 'having_own_health_ups_and_downs_confirmation',
  Hba1cBloodTest = 'hba1c_blood_test',
  Hba1cBloodTestRange = 'hba1c_blood_test_range',
  Hba1cBloodTestResult = 'hba1c_blood_test_result',
  Hba1cMeasurementTime = 'hba1c_measurement_time',
  HealthConditions = 'health_conditions',
  HealthConditionsImpactExercise = 'health_conditions_impact_exercise',
  HealthConditionsOther = 'health_conditions_other',
  HealthGoal = 'health_goal',
  HealthInsuranceCard = 'health_insurance_card',
  Height = 'height',
  HeightInInches = 'height_in_inches',
  HighmarkInsurancePlanType = 'highmark_insurance_plan_type',
  HipCircumferenceInInches = 'hip_circumference_in_inches',
  HorizonInsurancePlanType = 'horizon_insurance_plan_type',
  HowCanWeImprove = 'how_can_we_improve',
  InjuriesImpactExercise = 'injuries_impact_exercise',
  Insulin = 'insulin',
  InsulinOrCancerTreatment = 'insulin_or_cancer_treatment',
  InsuranceCallHesitationReason = 'insurance_call_hesitation_reason',
  InsuranceCallHesitationReasonOther = 'insurance_call_hesitation_reason_other',
  InsuranceEarlyExitReason = 'insurance_early_exit_reason',
  InsuranceEarlyExitReasonOther = 'insurance_early_exit_reason_other',
  InsuranceEarlyExitSecondReason = 'insurance_early_exit_second_reason',
  InsuranceEarlyExitSecondReasonOther = 'insurance_early_exit_second_reason_other',
  InsuranceEarlyExitWantToSpeakToOurMd = 'insurance_early_exit_want_to_speak_to_our_md',
  InsuranceGroupNumber = 'insurance_group_number',
  InsuranceMemberId = 'insurance_member_id',
  InsurancePlan = 'insurance_plan',
  InsurancePlanOther = 'insurance_plan_other',
  InsurancePolicyHolder = 'insurance_policy_holder',
  InsurancePolicyHolderDateOfBirth = 'insurance_policy_holder_date_of_birth',
  InsurancePolicyHolderFirstName = 'insurance_policy_holder_first_name',
  InsurancePolicyHolderLastName = 'insurance_policy_holder_last_name',
  InsurancePolicyHolderOther = 'insurance_policy_holder_other',
  InsuranceReimbursementPossibility = 'insurance_reimbursement_possibility',
  InsuranceVideoCallGoal = 'insurance_video_call_goal',
  InsuranceVideoCallGoalOther = 'insurance_video_call_goal_other',
  LabWork = 'lab_work',
  LabWorkResults = 'lab_work_results',
  LearnSpecificFoodsAffectDiabetes = 'learn_specific_foods_affect_diabetes',
  LifestyleChanges = 'lifestyle_changes',
  LifestyleConfidence = 'lifestyle_confidence',
  LikelihoodFollowWorkoutPlan = 'likelihood_follow_workout_plan',
  LikelihoodToChangeSleepHabits = 'likelihood_to_change_sleep_habits',
  LongTermWeightGoalEffort = 'long_term_weight_goal_effort',
  LunchFrequency = 'lunch_frequency',
  MedicalDisclaimerConsent = 'medical_disclaimer_consent',
  MedicalHistoryChanges = 'medical_history_changes',
  MedicalHistoryChangesDescription = 'medical_history_changes_description',
  MedicationChanges = 'medication_changes',
  Medications = 'medications',
  MentalHealthTherapistInterest = 'mental_health_therapist_interest',
  MetabolismDisorder = 'metabolism_disorder',
  MobileAppMedicalDisclaimer = 'mobile_app_medical_disclaimer',
  MorningRestfulness = 'morning_restfulness',
  NetPromoterScoreChangeSuggestion = 'net_promoter_score_change_suggestion',
  NetPromoterScoreLoveMost = 'net_promoter_score_love_most',
  NetPromoterScoreMissingOrFrustrating = 'net_promoter_score_missing_or_frustrating',
  NetPromoterScoreRecommendationLevel = 'net_promoter_score_recommendation_level',
  NfcSupported = 'nfc_supported',
  NotUnderstandingOwnHealthConfirmation = 'not_understanding_own_health_confirmation',
  NsValueInPastTwoWeeks = 'ns_value_in_past_two_weeks',
  NutritionKnowledge = 'nutrition_knowledge',
  NutritionistContinueReachGoals = 'nutritionist_continue_reach_goals',
  NutritionistReferral = 'nutritionist_referral',
  NutritionistReferralCoachId = 'nutritionist_referral_coach_id',
  NutritionistReferralProductKey = 'nutritionist_referral_product_key',
  NutritionistStartStopReachGoals = 'nutritionist_start_stop_reach_goals',
  Occupation = 'occupation',
  OnboardingExperienceBiggestChallenges = 'onboarding_experience_biggest_challenges',
  OnboardingExperienceBiggestChallengesOther = 'onboarding_experience_biggest_challenges_other',
  OnboardingExperienceChallenges = 'onboarding_experience_challenges',
  OnboardingExperienceComfortablePace = 'onboarding_experience_comfortable_pace',
  OnboardingExperienceCurrentDiet = 'onboarding_experience_current_diet',
  OnboardingExperienceDesiredWeight = 'onboarding_experience_desired_weight',
  OnboardingExperienceMainGoals = 'onboarding_experience_main_goals',
  OnboardingExperienceMotivationToChangeEatingHabits = 'onboarding_experience_motivation_to_change_eating_habits',
  OnboardingExperienceOpenToPhysicalActivityChanges = 'onboarding_experience_open_to_physical_activity_changes',
  OnboardingExperiencePhysicalActivity = 'onboarding_experience_physical_activity',
  OnboardingExperiencePrimaryMotivation = 'onboarding_experience_primary_motivation',
  OnboardingExperiencePrimaryMotivationOther = 'onboarding_experience_primary_motivation_other',
  OnboardingExperienceProgress = 'onboarding_experience_progress',
  OnboardingExperienceTriedChanges = 'onboarding_experience_tried_changes',
  OnboardingExperienceTriedLoseWeight = 'onboarding_experience_tried_lose_weight',
  OneMonthActiveFeedbackDietitian = 'one_month_active_feedback_dietitian',
  OtherAllergies = 'other_allergies',
  OtherAllergiesList = 'other_allergies_list',
  OtherInsurancePlanType = 'other_insurance_plan_type',
  OwnGlucometer = 'own_glucometer',
  OwnSensorGoal = 'own_sensor_goal',
  OwnSensorGoalOther = 'own_sensor_goal_other',
  PainOrDiscomfortDuringSleep = 'pain_or_discomfort_during_sleep',
  PastHealthConditions = 'past_health_conditions',
  PharmacyServicesConsent = 'pharmacy_services_consent',
  PhoneNumber = 'phone_number',
  PhysicalActivity = 'physical_activity',
  PhysicalActivityFrequency = 'physical_activity_frequency',
  PostCallFeedbackContinuation = 'post_call_feedback_continuation',
  PostCallFeedbackDoneBetter = 'post_call_feedback_done_better',
  PostCallFeedbackMostValuable = 'post_call_feedback_most_valuable',
  PostCallFeedbackMostValuableOther = 'post_call_feedback_most_valuable_other',
  PoultryFrequency = 'poultry_frequency',
  PreExistingMedicalConditions = 'pre_existing_medical_conditions',
  PreExistingMedicalConditionsList = 'pre_existing_medical_conditions_list',
  Pregnancy = 'pregnancy',
  PregnancyTerms = 'pregnancy_terms',
  PrescriptionMedications = 'prescription_medications',
  PrescriptionMedicationsList = 'prescription_medications_list',
  PrimaryJoiningGoal = 'primary_joining_goal',
  PrimaryJoiningGoalOther = 'primary_joining_goal_other',
  ProcessedFoodFrequency = 'processed_food_frequency',
  ProductMarketFitBenefit = 'product_market_fit_benefit',
  ProductMarketFitFeeling = 'product_market_fit_feeling',
  ProductMarketFitImprovement = 'product_market_fit_improvement',
  ProductMarketFitTypeOfPerson = 'product_market_fit_type_of_person',
  RecurringSubscriptionConsent = 'recurring_subscription_consent',
  RedMeatFrequency = 'red_meat_frequency',
  ReversedConditions = 'reversed_conditions',
  ReversedConditionsOther = 'reversed_conditions_other',
  SanaBenefitsInsurancePlanType = 'sana_benefits_insurance_plan_type',
  SatisfactionRating = 'satisfaction_rating',
  SatisfactionRatingDescription = 'satisfaction_rating_description',
  SensorIssuesDetails = 'sensor_issues_details',
  SensorIssuesDetailsOther = 'sensor_issues_details_other',
  ServiceNotValuableDetails = 'service_not_valuable_details',
  Sex = 'sex',
  ShareWithCoach = 'share_with_coach',
  SittingHours = 'sitting_hours',
  SleepChanges = 'sleep_changes',
  SleepChangesDetails = 'sleep_changes_details',
  SleepChangesDetailsOther = 'sleep_changes_details_other',
  SleepDisorderDiagnosis = 'sleep_disorder_diagnosis',
  SleepHours = 'sleep_hours',
  SnackFrequency = 'snack_frequency',
  SteloDeviceEligibility = 'stelo_device_eligibility',
  SteloMedicalEligibility = 'stelo_medical_eligibility',
  StepsPerDay = 'steps_per_day',
  Stress = 'stress',
  SubstancesBeforeBedtime = 'substances_before_bedtime',
  SuccessLookLike = 'success_look_like',
  SugaryDrinksFrequency = 'sugary_drinks_frequency',
  Supplements = 'supplements',
  SurgeriesHospitalizations = 'surgeries_hospitalizations',
  TechAppIssuesDetails = 'tech_app_issues_details',
  TechAppIssuesDetailsOther = 'tech_app_issues_details_other',
  TelehealthConsent = 'telehealth_consent',
  TooExpensiveDetails = 'too_expensive_details',
  TooExpensiveDetailsOther = 'too_expensive_details_other',
  Type_2DiabetesComplications = 'type_2_diabetes_complications',
  Type_2DiabetesDate = 'type_2_diabetes_date',
  Type_2DiabetesManagement = 'type_2_diabetes_management',
  UnfamiliarPrediabeticsConfirmation = 'unfamiliar_prediabetics_confirmation',
  UnitedHealthcareInsurancePlanType = 'united_healthcare_insurance_plan_type',
  VideoCallFeedbackConfidence = 'video_call_feedback_confidence',
  VideoCallFeedbackContinuation = 'video_call_feedback_continuation',
  VideoCallFeedbackImprovements = 'video_call_feedback_improvements',
  VideoCallFeedbackMostValuable = 'video_call_feedback_most_valuable',
  VideoCallFeedbackUsefulness = 'video_call_feedback_usefulness',
  VideoCallFeedbackWhy = 'video_call_feedback_why',
  VideoCallsSteloUpsellReferral = 'video_calls_stelo_upsell_referral',
  VideoCallsSteloUpsellReferralCoachId = 'video_calls_stelo_upsell_referral_coach_id',
  WaistCircumferenceInInches = 'waist_circumference_in_inches',
  WakeUpFrequency = 'wake_up_frequency',
  Weight = 'weight',
  WeightChange = 'weight_change',
  WeightGainedInPounds = 'weight_gained_in_pounds',
  WeightGoalEffortWorksForYou = 'weight_goal_effort_works_for_you',
  WeightInPounds = 'weight_in_pounds',
  WeightLossExperienceBiggestChallenges = 'weight_loss_experience_biggest_challenges',
  WeightLossExperienceBiggestChallengesOther = 'weight_loss_experience_biggest_challenges_other',
  WeightLossExperienceComfortablePace = 'weight_loss_experience_comfortable_pace',
  WeightLossExperienceCurrentDiet = 'weight_loss_experience_current_diet',
  WeightLossExperienceDesiredWeight = 'weight_loss_experience_desired_weight',
  WeightLossExperienceMotivationToChangeEatingHabits = 'weight_loss_experience_motivation_to_change_eating_habits',
  WeightLossExperienceOpenToPhysicalActivityChanges = 'weight_loss_experience_open_to_physical_activity_changes',
  WeightLossExperiencePhysicalActivity = 'weight_loss_experience_physical_activity',
  WeightLossExperiencePrimaryMotivation = 'weight_loss_experience_primary_motivation',
  WeightLossExperiencePrimaryMotivationOther = 'weight_loss_experience_primary_motivation_other',
  WeightLossExperienceTriedLoseWeight = 'weight_loss_experience_tried_lose_weight',
  WeightLostInPounds = 'weight_lost_in_pounds',
  WillingToPay = 'willing_to_pay',
  WillingToPayComments = 'willing_to_pay_comments',
  WillingToPayMaximum = 'willing_to_pay_maximum',
  WillingToPayMaximumOther = 'willing_to_pay_maximum_other',
  WorkedWithTrainer = 'worked_with_trainer'
}

export enum SurveysUserLinkState {
  Completed = 'completed',
  Processed = 'processed',
  Restarted = 'restarted',
  Started = 'started',
  Stopped = 'stopped'
}

export enum ThirdPartySignInProvider {
  Apple = 'apple',
  Google = 'google'
}

export type ITicket = {
  __typename?: 'Ticket'
  assignedTo?: Maybe<IUser>
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: IUser
  description: Scalars['String']['output']
  externalLink?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  kind: TicketKind
  priority: TicketPriority
  reason?: Maybe<TicketReason>
  status: TicketStatus
  user: IUser
}

export type ITicketCollection = {
  __typename?: 'TicketCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  tickets: Array<ITicket>
  totalCount: Scalars['Int']['output']
}

export type ITicketComment = {
  __typename?: 'TicketComment'
  body: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: IUserMin
  id: Scalars['ID']['output']
  ticketId: Scalars['ID']['output']
}

export type ITicketCommentCollection = {
  __typename?: 'TicketCommentCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  ticketComments: Array<ITicketComment>
  totalCount: Scalars['Int']['output']
}

export type ITicketCommentDynamicFilter = {
  field: TicketCommentDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum TicketCommentDynamicFilterField {
  Id = 'id'
}

export type ITicketCommentDynamicFilterItem = {
  items: Array<ITicketCommentDynamicFilter>
  operator: DynamicFilterOperator
}

export type ITicketCommentSort = {
  direction: SortDirection
  field: TicketCommentSortField
}

export enum TicketCommentSortField {
  CreatedAt = 'created_at'
}

export type ITicketDynamicFilter = {
  field: TicketDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum TicketDynamicFilterField {
  AssignedToEmail = 'assigned_to_email',
  AssignedToFullName = 'assigned_to_full_name',
  CreatedAt = 'created_at',
  CreatedByEmail = 'created_by_email',
  Id = 'id',
  Kind = 'kind',
  Priority = 'priority',
  Reason = 'reason',
  Status = 'status',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name',
  UserId = 'user_id'
}

export type ITicketDynamicFilterItem = {
  items: Array<ITicketDynamicFilter>
  operator: DynamicFilterOperator
}

export enum TicketKind {
  Subscription = 'subscription',
  Troubleshooting = 'troubleshooting'
}

export enum TicketPriority {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum TicketReason {
  Accounts = 'accounts',
  Addons = 'addons',
  AppLogin = 'app_login',
  AppMealLogging = 'app_meal_logging',
  AppQuestionnaires = 'app_questionnaires',
  Billing = 'billing',
  Cancellation = 'cancellation',
  GeneralInquiries = 'general_inquiries',
  GeneralNutritionSupport = 'general_nutrition_support',
  HealthPortal = 'health_portal',
  InformationUpdate = 'information_update',
  Insurance = 'insurance',
  InsuranceInquiries = 'insurance_inquiries',
  IntegrationHealth = 'integration_health',
  IntegrationsDexcom = 'integrations_dexcom',
  IntegrationsOther = 'integrations_other',
  Other = 'other',
  Patches = 'patches',
  Pauses = 'pauses',
  Payments = 'payments',
  SensorActivation = 'sensor_activation',
  SensorCalibration = 'sensor_calibration',
  SensorFellOff = 'sensor_fell_off',
  SensorOther = 'sensor_other',
  SensorPainSkinIrritation = 'sensor_pain_skin_irritation',
  SensorScanning = 'sensor_scanning',
  Shipments = 'shipments',
  SubscriptionPurchase = 'subscription_purchase',
  SubscriptionUpdate = 'subscription_update',
  VideoCalls = 'video_calls'
}

export type ITicketReasonDef = {
  __typename?: 'TicketReasonDef'
  key: TicketReason
  kind: TicketKind
  title: Scalars['String']['output']
}

export type ITicketSort = {
  direction: SortDirection
  field: TicketSortField
}

export enum TicketSortField {
  AssignedToEmail = 'assigned_to_email',
  AssignedToFullName = 'assigned_to_full_name',
  CreatedAt = 'created_at',
  CreatedByEmail = 'created_by_email',
  Id = 'id',
  Kind = 'kind',
  Priority = 'priority',
  Reason = 'reason',
  Status = 'status',
  UserEmail = 'user_email',
  UserFullName = 'user_full_name'
}

export enum TicketStatus {
  CompleteNoMemberResponse = 'complete_no_member_response',
  Completed = 'completed',
  FirstOutreachSent = 'first_outreach_sent',
  InProgress = 'in_progress',
  Pending = 'pending',
  PendingBugFix = 'pending_bug_fix',
  PendingLeadership = 'pending_leadership',
  PendingMemberResponse = 'pending_member_response'
}

export type ITickets = {
  __typename?: 'Tickets'
  reasonDefs: Array<ITicketReasonDef>
}

export type ITimePair = {
  __typename?: 'TimePair'
  displayValue?: Maybe<Scalars['String']['output']>
  interpolated: Scalars['Boolean']['output']
  x: Scalars['ISO8601DateTime']['output']
  y: Scalars['Numeric']['output']
}

export type IToken = {
  __typename?: 'Token'
  value: Scalars['String']['output']
}

export enum TrackingMode {
  Cgm = 'cgm',
  Logging = 'logging'
}

export type ITutorialStep = {
  __typename?: 'TutorialStep'
  description?: Maybe<Scalars['String']['output']>
  moreUrl?: Maybe<Scalars['String']['output']>
  photoUrlDark?: Maybe<Scalars['String']['output']>
  photoUrlLight?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  videoUrl?: Maybe<Scalars['String']['output']>
}

export type ITutorials = {
  __typename?: 'Tutorials'
  key: Scalars['String']['output']
  value: Array<ITutorialStep>
}

export enum UiColor {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}

export enum UiIcon {
  Avocado = 'avocado',
  Barbell = 'barbell',
  Bed = 'bed',
  BellRinging = 'bell_ringing',
  Bluetooth = 'bluetooth',
  BookOpenText = 'book_open_text',
  BookmarkSimple = 'bookmark_simple',
  CalendarBlank = 'calendar_blank',
  Carrot = 'carrot',
  ChartLine = 'chart_line',
  Coaching = 'coaching',
  Confetti = 'confetti',
  Cookie = 'cookie',
  Done = 'done',
  Drop = 'drop',
  Fish = 'fish',
  Flag = 'flag',
  FlowerLotus = 'flower_lotus',
  Food = 'food',
  Footprints = 'footprints',
  ForkKnife = 'fork_knife',
  Gift = 'gift',
  Glucose = 'glucose',
  Goals = 'goals',
  GoogleHealth = 'google_health',
  Hamburger = 'hamburger',
  HandHeart = 'hand_heart',
  Health = 'health',
  Lifebuoy = 'lifebuoy',
  Lifecycle = 'lifecycle',
  MoonStars = 'moon_stars',
  Percent = 'percent',
  PersonSimpleBike = 'person_simple_bike',
  PersonSimpleRun = 'person_simple_run',
  PersonSimpleSwim = 'person_simple_swim',
  PersonSimpleWalk = 'person_simple_walk',
  Plant = 'plant',
  Scales = 'scales',
  SealCheck = 'seal_check',
  Sleep = 'sleep',
  Smiley = 'smiley',
  Sparkle = 'sparkle',
  Steps = 'steps',
  Tag = 'tag',
  Thermometer = 'thermometer',
  Timer = 'timer',
  Users = 'users',
  Warning = 'warning',
  Waves = 'waves'
}

export enum UiInlineAlert {
  Danger = 'danger',
  Info = 'info',
  Neutral = 'neutral',
  Success = 'success',
  Warning = 'warning'
}

export enum UiPillFill {
  Brick = 'brick',
  Citron = 'citron',
  Moonstone = 'moonstone',
  Tea = 'tea',
  White = 'white'
}

export enum UiPillSize {
  M = 'm',
  S = 's'
}

export enum UiPillType {
  Alert = 'alert',
  Info = 'info',
  Neutral = 'neutral',
  Success = 'success',
  Warning = 'warning'
}

export type IUiState = {
  __typename?: 'UIState'
  createdAt: Scalars['ISO8601DateTime']['output']
  name: UiStateNames
  value: Scalars['Boolean']['output']
}

export enum UiStateName {
  CheckoutCompleted = 'checkout_completed',
  ChurnFeedbackModal = 'churn_feedback_modal',
  CoachRatingModalDismissed = 'coach_rating_modal_dismissed',
  DailyActionCompleted = 'daily_action_completed',
  DailyActionStreakCompleted = 'daily_action_streak_completed',
  DexcomSensorPrompt = 'dexcom_sensor_prompt',
  DownloadAppBannerInteracted = 'download_app_banner_interacted',
  EligibleForNetPromoterScoreSurvey = 'eligible_for_net_promoter_score_survey',
  EligibleForProductMarketFitSurvey = 'eligible_for_product_market_fit_survey',
  FirstCallReadinessBannerClicked = 'first_call_readiness_banner_clicked',
  FreeCallTrialUpsellBannerDismissed = 'free_call_trial_upsell_banner_dismissed',
  FreeCallTrialUpsellPopupShown = 'free_call_trial_upsell_popup_shown',
  FreestyleLibreTerraGlucoseDetected = 'freestyle_libre_terra_glucose_detected',
  FullscriptLabsBannerClicked = 'fullscript_labs_banner_clicked',
  FullscriptLabsUpsellModalShown = 'fullscript_labs_upsell_modal_shown',
  GlucoseFeatureOverride = 'glucose_feature_override',
  InsuranceInformationSubmitted = 'insurance_information_submitted',
  NetPromoterScoreSurveyReminderSent = 'net_promoter_score_survey_reminder_sent',
  NetPromoterScoreSurveyVisited = 'net_promoter_score_survey_visited',
  NoraHomeTutorialSeen = 'nora_home_tutorial_seen',
  NutritionistSwitchModal = 'nutritionist_switch_modal',
  OnboardingChecklistReminderVisited = 'onboarding_checklist_reminder_visited',
  OpenedMobileApp = 'opened_mobile_app',
  OwnSensorGlucoseDetected = 'own_sensor_glucose_detected',
  OwnSensorOnboardingCompleted = 'own_sensor_onboarding_completed',
  OwnSensorTutorialCompleted = 'own_sensor_tutorial_completed',
  PostCoachSwitchSurvey = 'post_coach_switch_survey',
  PrescriptionDexcomG7Allowed = 'prescription_dexcom_g7_allowed',
  ProductMarketFitSurveyReminderSent = 'product_market_fit_survey_reminder_sent',
  ProductMarketFitSurveyVisited = 'product_market_fit_survey_visited',
  ReferralBannerDismissed = 'referral_banner_dismissed',
  ReferralPopupDismissed = 'referral_popup_dismissed',
  ReferredToPurchaseByNutritionistModal = 'referred_to_purchase_by_nutritionist_modal',
  ShowLabResultAnalysisCompleteBanner = 'show_lab_result_analysis_complete_banner',
  ShowLabResultAnalysisFailedBanner = 'show_lab_result_analysis_failed_banner',
  ShowLibre3ToLinkupScreen = 'show_libre3_to_linkup_screen',
  ShowLibreIndirectSyncPopup = 'show_libre_indirect_sync_popup',
  ShowLibreIndirectSyncScreen = 'show_libre_indirect_sync_screen',
  SteloRealtimeApiUpgradeBanner = 'stelo_realtime_api_upgrade_banner',
  SteloShowMigrationBanner = 'stelo_show_migration_banner',
  SteloShowUpgradedBanner = 'stelo_show_upgraded_banner',
  StressManagementBannerDismissed = 'stress_management_banner_dismissed',
  SyncedFreestyleLibreTerra = 'synced_freestyle_libre_terra',
  SyncedLinkup = 'synced_linkup',
  SyncedSteloRealtime = 'synced_stelo_realtime',
  UnifiedOnboardingCompleted = 'unified_onboarding_completed',
  UnifiedOnboardingStarted = 'unified_onboarding_started',
  UnifiedOnboardingUpsellOffersCompleted = 'unified_onboarding_upsell_offers_completed',
  VideoCallSteloUpsellReferralModal = 'video_call_stelo_upsell_referral_modal',
  ViewedTrends = 'viewed_trends',
  WeightLossRecurringBannerClicked = 'weight_loss_recurring_banner_clicked'
}

export enum UiStateNames {
  CheckoutCompleted = 'checkout_completed',
  ChurnFeedbackModal = 'churn_feedback_modal',
  CoachRatingModalDismissed = 'coach_rating_modal_dismissed',
  DailyActionCompleted = 'daily_action_completed',
  DailyActionStreakCompleted = 'daily_action_streak_completed',
  DexcomSensorPrompt = 'dexcom_sensor_prompt',
  DownloadAppBannerInteracted = 'download_app_banner_interacted',
  EligibleForNetPromoterScoreSurvey = 'eligible_for_net_promoter_score_survey',
  EligibleForProductMarketFitSurvey = 'eligible_for_product_market_fit_survey',
  FirstCallReadinessBannerClicked = 'first_call_readiness_banner_clicked',
  FreeCallTrialUpsellBannerDismissed = 'free_call_trial_upsell_banner_dismissed',
  FreeCallTrialUpsellPopupShown = 'free_call_trial_upsell_popup_shown',
  FreestyleLibreTerraGlucoseDetected = 'freestyle_libre_terra_glucose_detected',
  FullscriptLabsBannerClicked = 'fullscript_labs_banner_clicked',
  FullscriptLabsUpsellModalShown = 'fullscript_labs_upsell_modal_shown',
  GlucoseFeatureOverride = 'glucose_feature_override',
  InsuranceInformationSubmitted = 'insurance_information_submitted',
  NetPromoterScoreSurveyReminderSent = 'net_promoter_score_survey_reminder_sent',
  NetPromoterScoreSurveyVisited = 'net_promoter_score_survey_visited',
  NoraHomeTutorialSeen = 'nora_home_tutorial_seen',
  NutritionistSwitchModal = 'nutritionist_switch_modal',
  OnboardingChecklistReminderVisited = 'onboarding_checklist_reminder_visited',
  OpenedMobileApp = 'opened_mobile_app',
  OwnSensorGlucoseDetected = 'own_sensor_glucose_detected',
  OwnSensorOnboardingCompleted = 'own_sensor_onboarding_completed',
  OwnSensorTutorialCompleted = 'own_sensor_tutorial_completed',
  PostCoachSwitchSurvey = 'post_coach_switch_survey',
  PrescriptionDexcomG7Allowed = 'prescription_dexcom_g7_allowed',
  ProductMarketFitSurveyReminderSent = 'product_market_fit_survey_reminder_sent',
  ProductMarketFitSurveyVisited = 'product_market_fit_survey_visited',
  ReferralBannerDismissed = 'referral_banner_dismissed',
  ReferralPopupDismissed = 'referral_popup_dismissed',
  ReferredToPurchaseByNutritionistModal = 'referred_to_purchase_by_nutritionist_modal',
  ShowLabResultAnalysisCompleteBanner = 'show_lab_result_analysis_complete_banner',
  ShowLabResultAnalysisFailedBanner = 'show_lab_result_analysis_failed_banner',
  ShowLibre3ToLinkupScreen = 'show_libre3_to_linkup_screen',
  ShowLibreIndirectSyncPopup = 'show_libre_indirect_sync_popup',
  ShowLibreIndirectSyncScreen = 'show_libre_indirect_sync_screen',
  SteloRealtimeApiUpgradeBanner = 'stelo_realtime_api_upgrade_banner',
  SteloShowMigrationBanner = 'stelo_show_migration_banner',
  SteloShowUpgradedBanner = 'stelo_show_upgraded_banner',
  StressManagementBannerDismissed = 'stress_management_banner_dismissed',
  SyncedFreestyleLibreTerra = 'synced_freestyle_libre_terra',
  SyncedLinkup = 'synced_linkup',
  SyncedSteloRealtime = 'synced_stelo_realtime',
  UnifiedOnboardingCompleted = 'unified_onboarding_completed',
  UnifiedOnboardingStarted = 'unified_onboarding_started',
  UnifiedOnboardingUpsellOffersCompleted = 'unified_onboarding_upsell_offers_completed',
  VideoCallSteloUpsellReferralModal = 'video_call_stelo_upsell_referral_modal',
  ViewedTrends = 'viewed_trends',
  WeightLossRecurringBannerClicked = 'weight_loss_recurring_banner_clicked'
}

export type IUhcDeepLinks = {
  __typename?: 'UhcDeepLinks'
  storeUrl: Scalars['String']['output']
}

export type IUhcMember = {
  __typename?: 'UhcMember'
  appAccessBlocked: Scalars['Boolean']['output']
  dateOfBirth?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  uhcId: Scalars['String']['output']
}

export enum UhcStoreProduct {
  FitnessMonthly = 'fitness_monthly',
  FitnessOneTime = 'fitness_one_time',
  HealthCoachingMonthly = 'health_coaching_monthly',
  HealthCoachingOneTime = 'health_coaching_one_time'
}

export type IUhcStoreSubscription = {
  __typename?: 'UhcStoreSubscription'
  id: Scalars['ID']['output']
  lastState: IUhcStoreSubscriptionState
  product: UhcStoreProduct
  uhcId: Scalars['String']['output']
}

export type IUhcStoreSubscriptionState = {
  __typename?: 'UhcStoreSubscriptionState'
  id: Scalars['ID']['output']
  kind: UhcStoreSubscriptionStateKind
  occurredAt: Scalars['ISO8601DateTime']['output']
  serviceValidUntil?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export enum UhcStoreSubscriptionStateKind {
  Active = 'active',
  Cancelled = 'cancelled'
}

export type IUncancelSubscriptionRequestPayload = {
  subscriptionId: Scalars['ID']['input']
}

export type IUncancelSubscriptionResponsePayload = {
  __typename?: 'UncancelSubscriptionResponsePayload'
  subscriptionId: Scalars['ID']['output']
}

export type IUnitOption = {
  __typename?: 'UnitOption'
  increment: Scalars['Float']['output']
  max: Scalars['Float']['output']
  min: Scalars['Float']['output']
  units?: Maybe<Scalars['String']['output']>
}

export type IUnpauseSubscriptionRequestPayload = {
  resumeDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  subscriptionId: Scalars['ID']['input']
}

export type IUnpauseSubscriptionResponsePayload = {
  __typename?: 'UnpauseSubscriptionResponsePayload'
  resumeDate?: Maybe<Scalars['ISO8601Date']['output']>
  subscriptionId: Scalars['ID']['output']
}

export type IUpdateCoachProfile = {
  /** @deprecated Use `state` instead */
  active?: InputMaybe<Scalars['Boolean']['input']>
  bio?: InputMaybe<Scalars['String']['input']>
  credentials?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  getHealthieId?: InputMaybe<Scalars['String']['input']>
  licenceMode?: InputMaybe<EhrCoachLicenceMode>
  managerId?: InputMaybe<Scalars['ID']['input']>
  outOfOffice?: InputMaybe<Scalars['Boolean']['input']>
  premium?: InputMaybe<Scalars['Boolean']['input']>
  schedulingPriority?: InputMaybe<Scalars['Int']['input']>
  specialties?: InputMaybe<Array<EhrCoachSpecialty>>
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  state?: InputMaybe<EhrCoachState>
  stateLicences?: InputMaybe<Array<Scalars['String']['input']>>
  stressBio?: InputMaybe<Scalars['String']['input']>
  stressLicenceMode?: InputMaybe<EhrCoachLicenceMode>
  unlimitedChatSupport?: InputMaybe<Scalars['Boolean']['input']>
  userId: Scalars['ID']['input']
}

export type IUpdateHealthPortalNotification = {
  completed: Scalars['Boolean']['input']
  notificationId: Scalars['ID']['input']
}

export type IUpdateSubscriptionChurnRecoveryRequestPayload = {
  nextProduct: BillingProduct
}

export type IUpdateSubscriptionResponsePayload = {
  __typename?: 'UpdateSubscriptionResponsePayload'
  nextProduct: BillingProduct
  oldProduct?: Maybe<BillingProduct>
  waiveFee?: Maybe<Scalars['Boolean']['output']>
}

export type IUpgradeSubscriptionRequestPayload = {
  nextProduct: BillingProduct
  oldProduct?: InputMaybe<BillingProduct>
  waiveFee?: InputMaybe<Scalars['Boolean']['input']>
}

export type IUpsellOffer = {
  __typename?: 'UpsellOffer'
  badge: Scalars['String']['output']
  benefits: Array<IUpsellOfferBenefit>
  benefitsDescription: Scalars['String']['output']
  benefitsTitle?: Maybe<Scalars['String']['output']>
  billingProduct: BillingProduct
  billingProductName: Scalars['String']['output']
  billingProductPrice: Scalars['String']['output']
  cheaperSensors: Scalars['Boolean']['output']
  cheaperSensorsDescriptionMarkdown?: Maybe<Scalars['String']['output']>
  descriptionMarkdown: Scalars['String']['output']
  subscriptionId: Scalars['ID']['output']
  title: Scalars['String']['output']
  upgradeCallToAction: Scalars['String']['output']
  upgradeDescription: Scalars['String']['output']
}

export type IUpsellOfferBenefit = {
  __typename?: 'UpsellOfferBenefit'
  description: Scalars['String']['output']
  icon: UiIcon
  title: Scalars['String']['output']
}

export type IUpsertLimitedSupportResponsePayload = {
  __typename?: 'UpsertLimitedSupportResponsePayload'
  limitedSupportCancelAt: Scalars['ISO8601Date']['output']
  limitedSupportSubscriptionId?: Maybe<Scalars['ID']['output']>
}

export type IUser = {
  __typename?: 'User'
  activeCoachingKinds: Array<ICoachesCoachingKindDef>
  addonLimits: Array<IAddonLimit>
  address?: Maybe<IAddress>
  age?: Maybe<Scalars['String']['output']>
  avatar?: Maybe<Scalars['String']['output']>
  berryStreetGetHealthieId?: Maybe<Scalars['Int']['output']>
  canViewGlucoseGraph: Scalars['Boolean']['output']
  coachAssignmentInfo: ICoachAssignmentInfo
  coachAssignments?: Maybe<Array<ICoachAssignment>>
  /** @deprecated use mntChatConversation or stressChatConversation */
  coachChatConversation?: Maybe<IChatConversation>
  coachProfile?: Maybe<ICoachProfile>
  compoundedSemaglutideConsent: Scalars['Boolean']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  dateOfBirth?: Maybe<Scalars['String']['output']>
  dexcomConnection?: Maybe<IDexcomConnectionType>
  /** @deprecated dexcom research is deprecated */
  dexcomSensorPromptUiState?: Maybe<Scalars['Boolean']['output']>
  dexcomSteloConnection?: Maybe<IDexcomConnectionType>
  eligibleForInsuranceCoverage: Scalars['Boolean']['output']
  email: Scalars['String']['output']
  features: Array<MobileAppFeature>
  firstName: Scalars['String']['output']
  floridaDigitalBillOfRightsConsent: Scalars['Boolean']['output']
  /** @deprecated use ehrAppointmentSchedulingInfo instead */
  followupSchedulingAvailable: Scalars['Boolean']['output']
  fulfillmentConfiguration: IFulfillmentConfiguration
  fullName: Scalars['String']['output']
  futurePaymentsConsent: Scalars['Boolean']['output']
  goalMetrics: Array<IGoalMetric>
  governmentIdCard?: Maybe<Scalars['String']['output']>
  /** @deprecated not used anymore */
  healthReject?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  intercomDigest?: Maybe<Scalars['String']['output']>
  kind: UserKind
  klaviyoId?: Maybe<Scalars['String']['output']>
  kustomerId?: Maybe<Scalars['String']['output']>
  /** @deprecated not used anymore */
  lastAnsweredHealthSurveyQuestionKey?: Maybe<SurveysQuestionKey>
  lastAnsweredMedicalHistorySurveyQuestionKey?: Maybe<SurveysQuestionKey>
  lastAppPlatform?: Maybe<Scalars['String']['output']>
  lastAppVersion?: Maybe<Scalars['String']['output']>
  lastAppointmentDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastAsyncChatAssignment?: Maybe<ICoachAssignment>
  lastCoreSubscription?: Maybe<ISubscription>
  lastDietitianSubscription?: Maybe<ISubscription>
  lastDoctorAssignment?: Maybe<IDoctorAssignment>
  lastDppApprovalRequest?: Maybe<IApprovalRequest>
  lastGlpApprovalRequest?: Maybe<IApprovalRequest>
  lastGlpRenewalApprovalRequest?: Maybe<IApprovalRequest>
  lastGovernmentIdApprovalRequest?: Maybe<IApprovalRequest>
  lastMedicalAppointment?: Maybe<IEhrAppointment>
  lastName: Scalars['String']['output']
  lastOccurredCoachingAppointment?: Maybe<IEhrAppointment>
  /** @deprecated prescriptions are not used anymore */
  lastPrescriptionApprovalRequest?: Maybe<IApprovalRequest>
  /** @deprecated dexcom research is deprecated */
  lastResearchApprovalRequest?: Maybe<IApprovalRequest>
  lastVideoChatAssignment?: Maybe<ICoachAssignment>
  latestCgmOrderDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  mfaEnabled: Scalars['Boolean']['output']
  mntChatConversation?: Maybe<IChatConversation>
  nextAppointmentDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  /** @deprecated Use feature checks instead */
  nutrisenseAdmin: Scalars['Boolean']['output']
  nutrisenseGetHealthieId?: Maybe<Scalars['Int']['output']>
  onboardingExperience?: Maybe<IOnboardingExperience>
  ongoingCareNonRefundableConsent: Scalars['Boolean']['output']
  ongoingCoreSubscription?: Maybe<ISubscription>
  ongoingDietitianSubscription?: Maybe<ISubscription>
  ongoingSubscriptions: Array<ISubscription>
  organization: IOrganization
  paymentMethod?: Maybe<IPaymentMethod>
  phoneNumber?: Maybe<Scalars['String']['output']>
  phoneNumberConsent?: Maybe<Scalars['Boolean']['output']>
  primaryCoachingKind: ICoachesCoachingKindDef
  primaryGoal?: Maybe<IGoal>
  purchasedSteloBiosensor: Scalars['Boolean']['output']
  referralPartner: IUserReferralPartnerDef
  referralUrl: Scalars['String']['output']
  role: UserRole
  sensor?: Maybe<ISensor>
  sensorInfo?: Maybe<IUserSensorInfo>
  settings: IUserSettings
  sex?: Maybe<Scalars['String']['output']>
  /** @deprecated use uiFlags instead */
  showChurnFeedbackModal: Scalars['Boolean']['output']
  /** @deprecated use uiFlags instead */
  showReferredToPurchaseModal: Scalars['Boolean']['output']
  signUpSource?: Maybe<UserSignUpSource>
  stressChatConversation?: Maybe<IChatConversation>
  stripeCreditBalance: Scalars['Float']['output']
  stripeId?: Maybe<Scalars['String']['output']>
  subscriptions: Array<ISubscription>
  surveyLinks: Array<ISurveyLink>
  telehealthConsent: Scalars['Boolean']['output']
  timeZone: Scalars['String']['output']
  truepillPatientToken?: Maybe<Scalars['String']['output']>
  uhcMember?: Maybe<IUhcMember>
  uiStates: Array<IUiState>
  upsellOffer?: Maybe<IUpsellOffer>
  userProperties?: Maybe<IUserProperties>
  uxSensorMode: ISensorMode
  videoCallSignupPaymentMethodRequired: Scalars['Boolean']['output']
}

export enum UserApprovalRequestKind {
  Dpp = 'dpp',
  Glp = 'glp',
  GlpRenewal = 'glp_renewal',
  GovernmentId = 'government_id',
  Prescription = 'prescription',
  Research = 'research',
  Stelo = 'stelo'
}

export enum UserApprovalRequestState {
  Approved = 'approved',
  ConsentRejected = 'consent_rejected',
  ConsentWithdrawn = 'consent_withdrawn',
  DidNotComplete = 'did_not_complete',
  Init = 'init',
  PendingApproval = 'pending_approval',
  PendingMember = 'pending_member',
  PendingRejection = 'pending_rejection',
  PendingUpdate = 'pending_update',
  Rejected = 'rejected',
  Stale = 'stale'
}

export type IUserAuth = {
  __typename?: 'UserAuth'
  /** @deprecated Use user_presenter instead */
  features: Array<MobileAppFeature>
  role?: Maybe<UserRole>
  status?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
  token?: Maybe<Scalars['String']['output']>
  user?: Maybe<IUser>
}

export type IUserAuthorizationPolicy = {
  __typename?: 'UserAuthorizationPolicy'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: UserAuthorizationPolicyKind
  policy: IAuthorizationPolicy
}

export enum UserAuthorizationPolicyKind {
  MobileAdminAccessPolicy = 'mobile_admin_access_policy',
  MobileAdminImpersonateAllPolicy = 'mobile_admin_impersonate_all_policy',
  MobileAdminImpersonateCoachAssignedPolicy = 'mobile_admin_impersonate_coach_assigned_policy',
  MobileAdminImpersonateOrganizationPolicy = 'mobile_admin_impersonate_organization_policy',
  PrivateActionGoalsManagePolicy = 'private_action_goals_manage_policy',
  PrivateActionGoalsViewPolicy = 'private_action_goals_view_policy',
  PrivateAdminPanelManageMembersPolicy = 'private_admin_panel_manage_members_policy',
  PrivateAdminPanelManageNutritionistAssignmentPolicy = 'private_admin_panel_manage_nutritionist_assignment_policy',
  PrivateAdminPanelResetVideoChatAssignmentPolicy = 'private_admin_panel_reset_video_chat_assignment_policy',
  PrivateAdminPanelViewNutritionistAssignmentPolicy = 'private_admin_panel_view_nutritionist_assignment_policy',
  PrivateAdminPanelViewNutritionistNotificationsPolicy = 'private_admin_panel_view_nutritionist_notifications_policy',
  PrivateAppointmentsViewPolicy = 'private_appointments_view_policy',
  PrivateAuthorizationManageAllPolicy = 'private_authorization_manage_all_policy',
  PrivateBillingDashboardViewPolicy = 'private_billing_dashboard_view_policy',
  PrivateChatManageAllPolicy = 'private_chat_manage_all_policy',
  PrivateChatManageNutritionistPolicy = 'private_chat_manage_nutritionist_policy',
  PrivateChatViewAllPolicy = 'private_chat_view_all_policy',
  PrivateChatViewNutritionistPolicy = 'private_chat_view_nutritionist_policy',
  PrivateChatbotAssistantPolicy = 'private_chatbot_assistant_policy',
  PrivateChatbotManageKnowledgePolicy = 'private_chatbot_manage_knowledge_policy',
  PrivateChatbotManageMessageReportsPolicy = 'private_chatbot_manage_message_reports_policy',
  PrivateChatbotViewKnowledgePolicy = 'private_chatbot_view_knowledge_policy',
  PrivateChatbotViewUserPolicy = 'private_chatbot_view_user_policy',
  PrivateCoachesAvailabilityViewAllPolicy = 'private_coaches_availability_view_all_policy',
  PrivateCoachesBillingManageAllPolicy = 'private_coaches_billing_manage_all_policy',
  PrivateCoachesBillingManageOwnPolicy = 'private_coaches_billing_manage_own_policy',
  PrivateCoachesManageHealthTeamStructurePolicy = 'private_coaches_manage_health_team_structure_policy',
  PrivateCoachesManageOwnPolicy = 'private_coaches_manage_own_policy',
  PrivateCoachesManagePolicy = 'private_coaches_manage_policy',
  PrivateCoachesSharedAssetsManagePolicy = 'private_coaches_shared_assets_manage_policy',
  PrivateCoachesViewHealthTeamStructurePolicy = 'private_coaches_view_health_team_structure_policy',
  PrivateDexcomConnectionsViewAccountDataPolicy = 'private_dexcom_connections_view_account_data_policy',
  PrivateFeatureFeedbackPolicy = 'private_feature_feedback_policy',
  PrivateFilesManagePolicy = 'private_files_manage_policy',
  PrivateFinancialsViewPolicy = 'private_financials_view_policy',
  PrivateFormulasRunPolicy = 'private_formulas_run_policy',
  PrivateHealthDataReportManageAllPolicy = 'private_health_data_report_manage_all_policy',
  PrivateHealthDataReportManagePolicy = 'private_health_data_report_manage_policy',
  PrivateHealthDataReportViewAllPolicy = 'private_health_data_report_view_all_policy',
  PrivateHealthDataReportViewPolicy = 'private_health_data_report_view_policy',
  PrivateHealthMetricsManagePolicy = 'private_health_metrics_manage_policy',
  PrivateHealthMetricsViewPolicy = 'private_health_metrics_view_policy',
  PrivateHistoryViewPolicy = 'private_history_view_policy',
  PrivateHomeCallSchedulingPolicy = 'private_home_call_scheduling_policy',
  PrivateHomeMobileAppPresentationModePolicy = 'private_home_mobile_app_presentation_mode_policy',
  PrivateHomeSidebarPolicy = 'private_home_sidebar_policy',
  PrivateHomeTimeTrackerPolicy = 'private_home_time_tracker_policy',
  PrivateHomeViewPolicy = 'private_home_view_policy',
  PrivateInsightsViewPolicy = 'private_insights_view_policy',
  PrivateMembersManagementNutritionistSelectionPolicy = 'private_members_management_nutritionist_selection_policy',
  PrivateMembersManagementViewPolicy = 'private_members_management_view_policy',
  PrivateNutritionistHomeImpersonatePolicy = 'private_nutritionist_home_impersonate_policy',
  PrivateNutritionistHomeViewPolicy = 'private_nutritionist_home_view_policy',
  PrivateOrganizationMembersViewPolicy = 'private_organization_members_view_policy',
  PrivateQuestionnaireViewPolicy = 'private_questionnaire_view_policy',
  PrivateSensorsManageReplacementRequestsPolicy = 'private_sensors_manage_replacement_requests_policy',
  PrivateSensorsManageSupportedSensorPolicy = 'private_sensors_manage_supported_sensor_policy',
  PrivateShipmentsManagePolicy = 'private_shipments_manage_policy',
  PrivateShipmentsViewUserPolicy = 'private_shipments_view_user_policy',
  PrivateSupportCreateAccountRequestsPolicy = 'private_support_create_account_requests_policy',
  PrivateSupportCreateTicketsPolicy = 'private_support_create_tickets_policy',
  PrivateSupportEscalateAccountRequestsPolicy = 'private_support_escalate_account_requests_policy',
  PrivateSupportManageTicketsPolicy = 'private_support_manage_tickets_policy',
  PrivateSupportProcessAgentLevelAccountRequestsPolicy = 'private_support_process_agent_level_account_requests_policy',
  PrivateSupportProcessLeadLevelAccountRequestsPolicy = 'private_support_process_lead_level_account_requests_policy',
  PrivateSupportProcessNutritionistLevelAccountRequestsPolicy = 'private_support_process_nutritionist_level_account_requests_policy',
  PrivateSupportResetRescheduleFreePassUsedPolicy = 'private_support_reset_reschedule_free_pass_used_policy',
  PrivateSupportReviewAgentLevelAccountRequestsPolicy = 'private_support_review_agent_level_account_requests_policy',
  PrivateSupportReviewLeadLevelAccountRequestsPolicy = 'private_support_review_lead_level_account_requests_policy',
  PrivateSupportReviewManagerLevelAccountRequestsPolicy = 'private_support_review_manager_level_account_requests_policy',
  PrivateSupportReviewSupervisorLevelAccountRequestsPolicy = 'private_support_review_supervisor_level_account_requests_policy',
  PrivateSupportViewAccountRequestsPolicy = 'private_support_view_account_requests_policy',
  PrivateSurveysManagePolicy = 'private_surveys_manage_policy',
  PrivateUsersEditOrganizationPolicy = 'private_users_edit_organization_policy',
  PrivateUsersEditProfilePolicy = 'private_users_edit_profile_policy',
  PrivateUsersEditSettingsPolicy = 'private_users_edit_settings_policy',
  PrivateUsersGlucoseFeatureOverridePolicy = 'private_users_glucose_feature_override_policy',
  PrivateUsersManageUiStatesPolicy = 'private_users_manage_ui_states_policy',
  PrivateUsersViewAllPolicy = 'private_users_view_all_policy',
  PrivateUsersViewFulfillmentConfigurationPolicy = 'private_users_view_fulfillment_configuration_policy',
  PrivateUsersViewInsuranceStatusPolicy = 'private_users_view_insurance_status_policy',
  PrivateUsersViewOrganizationPolicy = 'private_users_view_organization_policy',
  PrivateUsersViewProfilePolicy = 'private_users_view_profile_policy',
  PrivateUsersViewSettingsPolicy = 'private_users_view_settings_policy',
  PrivateUsersViewUiStatesPolicy = 'private_users_view_ui_states_policy'
}

export type IUserCalendar = {
  __typename?: 'UserCalendar'
  dates: Array<ICalendarDate>
}

export type IUserCollection = {
  __typename?: 'UserCollection'
  users: Array<IUserMin>
}

export type IUserDynamicFilter = {
  field: UserDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum UserDynamicFilterField {
  ActiveCoachingKindAssignmentsKind = 'active_coaching_kind_assignments_kind',
  AddressCity = 'address_city',
  AddressState = 'address_state',
  AddressStreet = 'address_street',
  AddressStreet_2 = 'address_street_2',
  AddressZipCode = 'address_zip_code',
  CoachProfileActiveOrOnboarding = 'coach_profile_active_or_onboarding',
  CoachProfileAdditionalLanguages = 'coach_profile_additional_languages',
  CoachProfileCdrCnsExpirationDate = 'coach_profile_cdr_cns_expiration_date',
  CoachProfileCdrCnsNumber = 'coach_profile_cdr_cns_number',
  CoachProfileEthnicity = 'coach_profile_ethnicity',
  CoachProfileGender = 'coach_profile_gender',
  CoachProfileGetHealthieId = 'coach_profile_get_healthie_id',
  CoachProfileManagerId = 'coach_profile_manager_id',
  CoachProfileRegistrationStatus = 'coach_profile_registration_status',
  CoachProfileState = 'coach_profile_state',
  CoachProfileStateOfResidence = 'coach_profile_state_of_residence',
  CoachProfileUnlimitedChatSupport = 'coach_profile_unlimited_chat_support',
  CommunicationFrequencyValue = 'communication_frequency_value',
  CreatedAt = 'created_at',
  /** @deprecated use ongoing_dietitian_subscription_cancel_at */
  CurrentDietitianSubscriptionCancelAt = 'current_dietitian_subscription_cancel_at',
  DateOfBirth = 'date_of_birth',
  DexcomSensorPromptUiState = 'dexcom_sensor_prompt_ui_state',
  DietitianRequestValue = 'dietitian_request_value',
  DietitianSensorCountNotesValue = 'dietitian_sensor_count_notes_value',
  Email = 'email',
  FulfillmentConfigurationSensorKind = 'fulfillment_configuration_sensor_kind',
  FullName = 'full_name',
  GoalKind = 'goal_kind',
  HealthGoalValue = 'health_goal_value',
  Id = 'id',
  Kind = 'kind',
  LastAsyncChatAssignmentCoachId = 'last_async_chat_assignment_coach_id',
  LastAsyncChatAssignmentKind = 'last_async_chat_assignment_kind',
  LastAsyncChatAssignmentState = 'last_async_chat_assignment_state',
  /** @deprecated use last_async_chat_assignment_coach_id */
  LastCoachAssignmentCoachId = 'last_coach_assignment_coach_id',
  /** @deprecated use last_async_chat_assignment_kind */
  LastCoachAssignmentKind = 'last_coach_assignment_kind',
  /** @deprecated use last_async_chat_assignment_state */
  LastCoachAssignmentState = 'last_coach_assignment_state',
  LastCoreSubscriptionLatestInvoiceLatestChargeCreated = 'last_core_subscription_latest_invoice_latest_charge_created',
  LastCoreSubscriptionLatestInvoiceLatestChargeStatus = 'last_core_subscription_latest_invoice_latest_charge_status',
  LastCoreSubscriptionLatestInvoicePrimaryInvoiceLinePlanNickname = 'last_core_subscription_latest_invoice_primary_invoice_line_plan_nickname',
  LastCoreSubscriptionPrimaryProduct = 'last_core_subscription_primary_product',
  LastCoreSubscriptionStatus = 'last_core_subscription_status',
  /** @deprecated use last_core_subscription status */
  LastCoreSubscriptionStripeStatus = 'last_core_subscription_stripe_status',
  LastDietitianSubscriptionStatus = 'last_dietitian_subscription_status',
  /** @deprecated use last_dietitian_subscription_status */
  LastDietitianSubscriptionStripeStatus = 'last_dietitian_subscription_stripe_status',
  NutritionistGroupValue = 'nutritionist_group_value',
  OneMonthActiveFeedbackDietitianValue = 'one_month_active_feedback_dietitian_value',
  OngoingDietitianSubscriptionCancelAt = 'ongoing_dietitian_subscription_cancel_at',
  OngoingDietitianSubscriptionPlansNickname = 'ongoing_dietitian_subscription_plans_nickname',
  PhoneNumber = 'phone_number',
  Role = 'role',
  ScheduledVideoCallStatusValue = 'scheduled_video_call_status_value',
  SensorInfoFirstStartTime = 'sensor_info_first_start_time',
  SensorInfoLastSensorExpirationDate = 'sensor_info_last_sensor_expiration_date',
  SensorInfoLastSensorExpired = 'sensor_info_last_sensor_expired',
  SensorInfoReplacementRequestsCount = 'sensor_info_replacement_requests_count',
  SensorInfoTotalCount = 'sensor_info_total_count',
  StripeId = 'stripe_id',
  TestGroupValue = 'test_group_value'
}

export type IUserDynamicFilterItem = {
  items: Array<IUserDynamicFilter>
  operator: DynamicFilterOperator
}

export enum UserExperienceSensorModeKind {
  ActivePrescriptionDexcomG7 = 'active_prescription_dexcom_g7',
  ActiveResearchDexcom = 'active_research_dexcom',
  Default = 'default',
  DexcomStelo = 'dexcom_stelo',
  LibreLinkup = 'libre_linkup',
  Lingo = 'lingo',
  OwnSensorDexcomG6 = 'own_sensor_dexcom_g6',
  OwnSensorDexcomG7 = 'own_sensor_dexcom_g7',
  OwnSensorDexcomStelo = 'own_sensor_dexcom_stelo',
  OwnSensorLibre1 = 'own_sensor_libre1',
  OwnSensorLibre2 = 'own_sensor_libre2',
  OwnSensorLibre3 = 'own_sensor_libre3',
  PendingLibre3 = 'pending_libre3',
  PendingPrescriptionDexcomG7 = 'pending_prescription_dexcom_g7',
  PendingResearchDexcom = 'pending_research_dexcom'
}

export enum UserFileTag {
  BodyPhoto = 'body_photo',
  ChatbotAttachment = 'chatbot_attachment',
  DexcomResearchConsent = 'dexcom_research_consent',
  DppHbA1cEvidence = 'dpp_hb_a1c_evidence',
  DppWeightEvidence = 'dpp_weight_evidence',
  GlpLabWorkResults = 'glp_lab_work_results',
  GovernmentIdCard = 'government_id_card',
  HealthInsuranceCard = 'health_insurance_card',
  InsuranceCardBackPhoto = 'insurance_card_back_photo',
  InsuranceCardFrontPhoto = 'insurance_card_front_photo',
  IntercomAttachment = 'intercom_attachment',
  LabWorkResults = 'lab_work_results'
}

export enum UserGoalKind {
  ImproveGlucoseValues = 'improve_glucose_values',
  LearnAboutGlucoseLevels = 'learn_about_glucose_levels',
  LoseWeight = 'lose_weight',
  ManageChronicCondition = 'manage_chronic_condition',
  OptimizeFitnessPerformance = 'optimize_fitness_performance',
  Other = 'other',
  PreventDisease = 'prevent_disease',
  PromoteLongevity = 'promote_longevity'
}

export enum UserGoalMetricKind {
  GlucoseMax = 'glucose_max',
  GlucoseMean = 'glucose_mean',
  GlucoseMin = 'glucose_min',
  GlucoseMorningAverage = 'glucose_morning_average',
  GlucoseSleepAverage = 'glucose_sleep_average',
  GlucoseStandardDeviation = 'glucose_standard_deviation',
  GlucoseTimeWithinRange = 'glucose_time_within_range',
  JournalAppetite = 'journal_appetite',
  JournalEnergy = 'journal_energy',
  JournalFocus = 'journal_focus',
  JournalMood = 'journal_mood',
  JournalStress = 'journal_stress',
  MeasurementsWeight = 'measurements_weight'
}

export enum UserInsurancePolicyKind {
  Aetna = 'aetna',
  Anthem = 'anthem',
  BlueCrossBlueShield = 'blue_cross_blue_shield',
  Cigna = 'cigna',
  Empire = 'empire',
  Highmark = 'highmark',
  Horizon = 'horizon',
  SanaBenefits = 'sana_benefits',
  UnitedHealthcare = 'united_healthcare'
}

export type IUserInsurancePolicyKindDef = {
  __typename?: 'UserInsurancePolicyKindDef'
  key: UserInsurancePolicyKind
  title: Scalars['String']['output']
}

export enum UserInsurancePolicyStateKind {
  Canceled = 'canceled',
  CanceledInsuranceNotAccepted = 'canceled_insurance_not_accepted',
  CanceledNoProvidersInn = 'canceled_no_providers_inn',
  Created = 'created',
  Eligible = 'eligible',
  EligiblePatientResponsibility = 'eligible_patient_responsibility',
  EligiblePreAuth = 'eligible_pre_auth',
  Hold = 'hold',
  InReview = 'in_review',
  NotEligible = 'not_eligible',
  NotSupported = 'not_supported'
}

export enum UserKind {
  Influencer = 'influencer',
  Internal = 'internal',
  Investor = 'investor',
  Regular = 'regular'
}

export type IUserMin = {
  __typename?: 'UserMin'
  email: Scalars['String']['output']
  fullName: Scalars['String']['output']
  id: Scalars['ID']['output']
  phoneNumber: Scalars['String']['output']
  timeZone: Scalars['String']['output']
}

export type IUserProperties = {
  __typename?: 'UserProperties'
  byosVideoCallsUpsell?: Maybe<IMobileUserProperty>
  communicationFrequency?: Maybe<IMobileUserProperty>
  complimentarySupportDecision?: Maybe<IMobileUserProperty>
  dietitianRequest?: Maybe<IMobileUserProperty>
  dietitianSensorCountNotes?: Maybe<IMobileUserProperty>
  healthGoal?: Maybe<IMobileUserProperty>
  insuranceSurveySkipReason?: Maybe<IMobileUserProperty>
  mfpPromotionCardDismissalTimestamp?: Maybe<IMobileUserProperty>
  nutritionistGroup?: Maybe<IMobileUserProperty>
  oneMonthActiveFeedbackDietitian?: Maybe<IMobileUserProperty>
  scheduledVideoCallStatus?: Maybe<IMobileUserProperty>
  testGroup?: Maybe<IMobileUserProperty>
  videoCallFirstCallSchedulingExperiment?: Maybe<IMobileUserProperty>
  videoCallPaymentMethodExperiment?: Maybe<IMobileUserProperty>
  videoCallRescheduleFreePassUsed?: Maybe<IMobileUserProperty>
  weightLossExperience?: Maybe<IMobileUserProperty>
}

export type IUserPropertiesCollection = {
  __typename?: 'UserPropertiesCollection'
  userProperties: Array<IUserProperty>
}

export type IUserProperty = {
  __typename?: 'UserProperty'
  id: Scalars['Int']['output']
  kind: UserPropertyKind
  userId: Scalars['ID']['output']
  value: Scalars['String']['output']
}

export enum UserPropertyKind {
  AbandonerInsurancePolicyId = 'abandoner_insurance_policy_id',
  ActiveInterventions = 'active_interventions',
  AppRating = 'app_rating',
  Background = 'background',
  BmiRange = 'bmi_range',
  ByosVideoCallsUpsell = 'byos_video_calls_upsell',
  Clinic = 'clinic',
  CoachRatingInitiatedRatingStatus = 'coach_rating_initiated_rating_status',
  CoachingStyle = 'coaching_style',
  CommunicationFrequency = 'communication_frequency',
  ComplimentarySupportDecision = 'complimentary_support_decision',
  CustomKeyPoint = 'custom_key_point',
  Diet = 'diet',
  DietitianNotes = 'dietitian_notes',
  DietitianRequest = 'dietitian_request',
  DietitianSensorCountNotes = 'dietitian_sensor_count_notes',
  DoNotSendWrapUpMessage = 'do_not_send_wrap_up_message',
  Education = 'education',
  FoodAllergies = 'food_allergies',
  FutureInterventions = 'future_interventions',
  GlucoseManagementKnowledge = 'glucose_management_knowledge',
  HealthConditions = 'health_conditions',
  HealthGoal = 'health_goal',
  Height = 'height',
  InferredSex = 'inferred_sex',
  InitialInsuranceCallDuration = 'initial_insurance_call_duration',
  InsuranceReimbursementInterest = 'insurance_reimbursement_interest',
  InsuranceSurveySkipReason = 'insurance_survey_skip_reason',
  InsuranceVideoCallGoal = 'insurance_video_call_goal',
  Libre_3Outage = 'libre_3_outage',
  Libre_3OutagePreShipmentNotice = 'libre_3_outage_pre_shipment_notice',
  Medications = 'medications',
  MfpPromotionCardDismissalTimestamp = 'mfp_promotion_card_dismissal_timestamp',
  NetPromoterScoreSurveyTriggeringMilestoneKind = 'net_promoter_score_survey_triggering_milestone_kind',
  NutritionistGroup = 'nutritionist_group',
  OnboardingExperience = 'onboarding_experience',
  OneMonthActiveFeedbackDietitian = 'one_month_active_feedback_dietitian',
  OwnCgmDevice = 'own_cgm_device',
  OwnGlucometer = 'own_glucometer',
  PrimaryJoiningGoal = 'primary_joining_goal',
  ScheduledVideoCallStatus = 'scheduled_video_call_status',
  StepsPerDay = 'steps_per_day',
  TestGroup = 'test_group',
  UpgradeSubscriptionAlertDismissedBillingProduct = 'upgrade_subscription_alert_dismissed_billing_product',
  VideoCallFirstCallSchedulingExperiment = 'video_call_first_call_scheduling_experiment',
  VideoCallPaymentMethodExperiment = 'video_call_payment_method_experiment',
  VideoCallRescheduleFreePassUsed = 'video_call_reschedule_free_pass_used',
  VideoCallSteloUpsellModalDismissed = 'video_call_stelo_upsell_modal_dismissed',
  VideoCallSteloUpsellPersistent = 'video_call_stelo_upsell_persistent',
  VideoCallUpsell = 'video_call_upsell',
  Weight = 'weight',
  WeightLossExperience = 'weight_loss_experience'
}

export enum UserPropertyOnboardingExperienceKind {
  Other = 'other',
  PreDiabetes = 'pre_diabetes',
  WeightLoss = 'weight_loss',
  WomensHealth = 'womens_health'
}

export enum UserReferralPartner {
  Agelessrx = 'agelessrx',
  Bf = 'bf',
  Bm = 'bm',
  Bodyspec = 'bodyspec',
  Bp = 'bp',
  Dadv = 'dadv',
  Dexcom = 'dexcom',
  Flore = 'flore',
  Forbes = 'forbes',
  Hhtelemed = 'hhtelemed',
  Influencer = 'influencer',
  It = 'it',
  Jh = 'jh',
  Kegg = 'kegg',
  Lg = 'lg',
  LoseIt = 'lose_it',
  Lpd = 'lpd',
  Mfp = 'mfp',
  MfpCredit = 'mfp_credit',
  Mindypelz = 'mindypelz',
  Miracare = 'miracare',
  NoPartner = 'no_partner',
  Northwestern = 'northwestern',
  Pnmag = 'pnmag',
  Proov = 'proov',
  Roswell = 'roswell',
  Sc = 'sc',
  Simple = 'simple',
  Stelo = 'stelo',
  Tovala = 'tovala',
  Trg = 'trg',
  Veracity = 'veracity',
  Vip = 'vip',
  Welltory = 'welltory',
  Wisp = 'wisp'
}

export type IUserReferralPartnerDef = {
  __typename?: 'UserReferralPartnerDef'
  key: UserReferralPartner
  logoUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  product?: Maybe<BillingProduct>
  requiresProtocol: Scalars['Boolean']['output']
  schedulingWithoutInsuranceInformation: Scalars['Boolean']['output']
  schedulingWithoutPaymentMethod: Scalars['Boolean']['output']
}

export enum UserRole {
  Admin = 'admin',
  Coach = 'coach',
  CoachManager = 'coach_manager',
  CustomerSupport = 'customer_support',
  Engineer = 'engineer',
  ExternalAdmin = 'external_admin',
  Operations = 'operations',
  User = 'user'
}

export type IUserSensorInfo = {
  __typename?: 'UserSensorInfo'
  firstActivationDate?: Maybe<Scalars['ISO8601Date']['output']>
  firstStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastSensor?: Maybe<ISensor>
  replacementRequestsCount: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
}

export enum UserSensorKind {
  DexcomG7 = 'dexcom_g7',
  DexcomStelo = 'dexcom_stelo',
  Libre1 = 'libre1',
  Libre2 = 'libre2',
  Libre3 = 'libre3',
  PrescriptionDexcomG7 = 'prescription_dexcom_g7'
}

export type IUserSettings = {
  __typename?: 'UserSettings'
  /** @deprecated Removed in v2.6.0 from mobile app */
  appVersionReminder: Scalars['Boolean']['output']
  dashboardGraph: Scalars['String']['output']
  dexcomSync: Scalars['Boolean']['output']
  displayActivityScore: Scalars['Boolean']['output']
  displayDailyScore: Scalars['Boolean']['output']
  displayMealScore: Scalars['Boolean']['output']
  fastingEnd: Scalars['Int']['output']
  fastingStart: Scalars['Int']['output']
  glucoseHighThreshold: Scalars['Int']['output']
  glucoseLowThreshold: Scalars['Int']['output']
  googleFitSync: Scalars['Boolean']['output']
  healthKitSync: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  integrationsSyncSettings: IIntegrationsSync
  journalNotifications: Scalars['Boolean']['output']
  ketoMojoSync: Scalars['Boolean']['output']
  ketoneHighThreshold: Scalars['Float']['output']
  ketoneLowThreshold: Scalars['Float']['output']
  macroGoalsDaily: IMacroGoals
  patternsNotifications: Scalars['Boolean']['output']
  reminders: Scalars['Boolean']['output']
  showNetCarbs: Scalars['Boolean']['output']
  statsSettings: Array<IStatsSettings>
  /** @deprecated Removed in v2.6.0 from mobile app */
  trackingMode: TrackingMode
  unitSystem: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export enum UserSignUpSource {
  AmazonWebFlow = 'amazon_web_flow',
  Checkout = 'checkout',
  CoursesWebFlow = 'courses_web_flow',
  DexcomLinking = 'dexcom_linking',
  DppWebFlow = 'dpp_web_flow',
  GlpWebFlow = 'glp_web_flow',
  HealthPortal = 'health_portal',
  InsuranceFormSubmission = 'insurance_form_submission',
  InsuranceWebFlow = 'insurance_web_flow',
  MobileApp = 'mobile_app',
  OwnSensorWebFlow = 'own_sensor_web_flow',
  PartnerWebFlow = 'partner_web_flow',
  UhcSamlFlow = 'uhc_saml_flow'
}

export type IUserSort = {
  direction: SortDirection
  field: UserSortField
}

export enum UserSortField {
  AddressCity = 'address_city',
  AddressState = 'address_state',
  AddressStreet = 'address_street',
  AddressStreet_2 = 'address_street_2',
  AddressZipCode = 'address_zip_code',
  CoachAssignmentInfoActiveAssignmentsCount = 'coach_assignment_info_active_assignments_count',
  CoachProfileAdditionalLanguages = 'coach_profile_additional_languages',
  CoachProfileCdrCnsExpirationDate = 'coach_profile_cdr_cns_expiration_date',
  CoachProfileEndDate = 'coach_profile_end_date',
  CoachProfileEthnicity = 'coach_profile_ethnicity',
  CoachProfileStartDate = 'coach_profile_start_date',
  CoachProfileStateOfResidence = 'coach_profile_state_of_residence',
  CoachProfileUnlimitedChatSupport = 'coach_profile_unlimited_chat_support',
  CommunicationFrequencyValue = 'communication_frequency_value',
  CreatedAt = 'created_at',
  /** @deprecated use ongoing_dietitian_subscription_cancel_at */
  CurrentDietitianSubscriptionCancelAt = 'current_dietitian_subscription_cancel_at',
  DateOfBirth = 'date_of_birth',
  DietitianRequestValue = 'dietitian_request_value',
  DietitianSensorCountNotesValue = 'dietitian_sensor_count_notes_value',
  Email = 'email',
  FulfillmentConfigurationSensorKind = 'fulfillment_configuration_sensor_kind',
  FullName = 'full_name',
  GoalKind = 'goal_kind',
  HealthGoalValue = 'health_goal_value',
  Id = 'id',
  Kind = 'kind',
  LastAsyncChatAssignmentCoachFullName = 'last_async_chat_assignment_coach_full_name',
  LastAsyncChatAssignmentKind = 'last_async_chat_assignment_kind',
  LastAsyncChatAssignmentState = 'last_async_chat_assignment_state',
  /** @deprecated use last_async_chat_assignment_coach_full_name */
  LastCoachAssignmentCoachFullName = 'last_coach_assignment_coach_full_name',
  /** @deprecated use last_async_chat_assignment_kind */
  LastCoachAssignmentKind = 'last_coach_assignment_kind',
  /** @deprecated use last_async_chat_assignment_state */
  LastCoachAssignmentState = 'last_coach_assignment_state',
  LastCoreSubscriptionLatestInvoiceLatestChargeCreated = 'last_core_subscription_latest_invoice_latest_charge_created',
  LastCoreSubscriptionLatestInvoiceLatestChargeStatus = 'last_core_subscription_latest_invoice_latest_charge_status',
  LastCoreSubscriptionLatestInvoicePrimaryInvoiceLinePlanNickname = 'last_core_subscription_latest_invoice_primary_invoice_line_plan_nickname',
  LastCoreSubscriptionPrimaryProduct = 'last_core_subscription_primary_product',
  LastCoreSubscriptionStatus = 'last_core_subscription_status',
  /** @deprecated use last_core_subscription_status */
  LastCoreSubscriptionStripeStatus = 'last_core_subscription_stripe_status',
  LastDietitianSubscriptionStatus = 'last_dietitian_subscription_status',
  /** @deprecated use last_dietitian_subscription_status */
  LastDietitianSubscriptionStripeStatus = 'last_dietitian_subscription_stripe_status',
  NutritionistGroupValue = 'nutritionist_group_value',
  OneMonthActiveFeedbackDietitianValue = 'one_month_active_feedback_dietitian_value',
  OngoingDietitianSubscriptionCancelAt = 'ongoing_dietitian_subscription_cancel_at',
  OngoingDietitianSubscriptionPlansNickname = 'ongoing_dietitian_subscription_plans_nickname',
  PhoneNumber = 'phone_number',
  ScheduledVideoCallStatusValue = 'scheduled_video_call_status_value',
  SensorInfoFirstStartTime = 'sensor_info_first_start_time',
  SensorInfoLastSensorExpirationDate = 'sensor_info_last_sensor_expiration_date',
  SensorInfoLastSensorExpired = 'sensor_info_last_sensor_expired',
  SensorInfoReplacementRequestsCount = 'sensor_info_replacement_requests_count',
  SensorInfoTotalCount = 'sensor_info_total_count',
  TestGroupValue = 'test_group_value'
}

export type IValidateCoachInvites = {
  __typename?: 'ValidateCoachInvites'
  results: Array<ICoachInviteResult>
  summary: ICoachInviteSummary
}

export type IValuePair = INumericPair | IRangePair | IStringPair | ITimePair

/** Autogenerated return type of VerifyMfaSmsCodeAction. */
export type IVerifyMfaSmsCodeActionPayload = {
  __typename?: 'VerifyMfaSmsCodeActionPayload'
  mfaToken: Scalars['String']['output']
}
